import createWhitelistFilter from "redux-persist-transform-filter";
import {
  sortPortfolio,
  FETCH_PORTFOLIOS_PENDING,
  UPDATE_FETCH_HOLDINGS_STATUS,
  UPDATE_ALL_CONNECTED_CUSTODIANS_REFRESH_STATUS,
  FETCH_PORTFOLIOS_SUCCESS,
  FETCH_PORTFOLIOS_ERROR,
  SET_PORTFOLIOS,
  INSERT_PORTFOLIO,
  UPDATE_PORTFOLIO,
  DELETE_PORTFOLIO,
  UPDATE_CURRENT_PORTFOLIO,
  INSERT_CUSTODIAN_BULK,
  UPDATE_CUSTODIAN_BULK,
  DELETE_CUSTODIAN,
  DELETE_CUSTODIAN_BULK,
  INSERT_SECTION,
  INSERT_TAG,
  REPLACE_TAG,
  SET_TAG_MEMBERS,
  SET_TAG_ASSIGNMENTS,
  UPDATE_TAG,
  DELETE_TAG,
  UPDATE_SECTION,
  MOVE_SECTION,
  UPDATE_SHEET,
  MOVE_SHEET,
  UPDATE_DASHBOARD,
  CLEAR_DASHBOARD_ENTITIES_TO_UPDATE,
  BULK_CHANGE_CUSTODIAN_STAR_STATUS,
  BULK_CHANGE_CUSTODIAN_UPDATED_STATUS,
  DELETE_SECTION,
  DELETE_SHEET,
  INSERT_SHEET,
  INSERT_DOCUMENT,
  UPDATE_DOCUMENT,
  DELETE_DOCUMENT,
  SET_PROOFS,
  UPSERT_PROOF,
  REMOVE_PROOF,
  SET_PORTFOLIO_LAST_FORCE_REFRESH_TS,
  SET_PORTFOLIO_CHANGE_DATA_LAST_FORCE_REFRESH_TS,
  FETCH_NET_WORTH_DATA_PENDING,
  FETCH_NET_WORTH_DATA_SUCCESS,
  FETCH_NET_WORTH_DATA_ERROR,
  FETCH_RECAP_DATA_ERROR,
  FETCH_RECAP_DATA_PENDING,
  FETCH_RECAP_DATA_SUCCESS,
  FETCH_VANITY_STAT_SUCCESS,
  SET_LAST_VIEWED_NETWORTH_VANITY,
  FETCH_INITIAL_RECAP_DATA_PENDING,
  FETCH_INITIAL_RECAP_DATA_ERROR,
  SET_LINK_TYPE,
  RESET_PORTFOLIO_STATE,
  SET_SLIDE_DIRECTION,
  SET_SHOW_REFRESHING,
  PAGE_RELOADING,
  REFRESH_CUSTODIAN_DONE,
  SET_SECTION_UPDATED,
  REMOVE_SECTION_UPDATED,
  FETCH_PORTFOLIO_CHANGE_DATA_PENDING,
  FETCH_PORTFOLIO_CHANGE_DATA_SUCCESS,
  FETCH_PORTFOLIO_CHANGE_DATA_ERROR,
  FETCH_CHART_AND_CAGR_DATA_PENDING,
  FETCH_CHART_AND_CAGR_DATA_SUCCESS,
  recapChartTypes,
  THEME_SUFFIX_STR,
  LOCK_PREFERENCE_STR,
  INITIAL_FETCH_PORTFOLIOS_SUCCESS,
  REMOVE_CONNECTION_ERRORS,
  getChartDataFromResponse,
  chartTimeRangeGroups,
  chartStyle,
  RECAP_CATEGORY_TYPE_INVESTABLE_ASSETS,
  RECAP_CATEGORY_TYPE_INVESTABLE_ASSETS_WITHOUT_CASH,
  getRecommendationCountForAChartSelector,
  chartKeyParams,
  reportPaths,
  getLineChartTitleSelector,
  irrTypes,
  GET_CONNECTIVITY_CENTER_DATA_ERROR,
  GET_CONNECTIVITY_CENTER_DATA_PENDING,
  GET_CONNECTIVITY_CENTER_DATA_SUCCESS,
  UPDATE_CONNECTIVITY_CENTER_DATA,
  custodianSubTypes,
  holdingSubTypes,
  ADD_SCENARIO,
  DELETE_SCENARIO,
  ADD_RULE,
  DELETE_RULE,
  UPDATE_RULE,
  UPDATE_RULE_BULK,
  UPDATE_SCENARIO,
  UPDATE_SCENARIO_BULK,
  ADD_REPORT_PREFERENCE,
  ADD_DIY_CHART,
  DELETE_DIY_CHART,
  UPDATE_CASH_FORECAST_DURATION,
  custodiansLinkedToSameAccountSelector,
  REHYDRATE_RECAP,
  tickerTypes,
  getSymbolForTickerUsingShortName,
  isCryptoCurrency,
  shortFormatNumberWithCurrency,
  getYTDCustodianChartData,
  filterChartDataBasedOnPortfolioStartDate,
  GET_FUND_SCHEDULE_DATA_SUCCESS,
  fundScheduleDurations,
  fundScheduleTypes,
  UPDATE_SHOW_CHARTS_MODAL_LOADER,
  UPDATE_RECAP_REPORT_CALCULATION_PENDING,
  FETCH_PERCENTAGE_ALLOCATION_DATA_PENDING,
  FETCH_PERCENTAGE_ALLOCATION_DATA_SUCCESS,
  UPDATE_RECAP_RAW_DATA_ACTION,
  UPDATE_PORTFOLIO_CHANGE_DATA_ACTION,
  getChartRangeFromTimePeriod,
  getIrrPeriodLabel,
  getYTDStartDateString,
  getQTDStartDateString,
  CALCULATE_DASHBOARD_DATA_FOR_PORTFOLIO_SUCCESS,
  CALCULATE_DASHBOARD_DATA_FOR_PORTFOLIO_PENDING,
  tickerSubTypes,
  planningAssetTypes,
  custodianTypes,
  assetClassesListSelector,
  getClubbingKeyForCustodian,
  buildGlobalClubbingNames,
  findPortfolioInTree,
  isFiatTicker
} from "../actions/Common";
import i18n from "locale/i18n";
import {
  getPercentageValue,
  getUuid,
  parseNetWorthDateString,
  getKuberaDateString,
  getActualValueFromPercentage,
  getDateInKuberaFormat,
  parseKuberaDateString,
  getTodayMidnight,
  addDaysToDate,
  getCagr,
  numIsNotNull
} from "../../utilities/Number";
import {
  userPreferencesSelector,
  currentPortfolioSelector,
  getCustodianCost,
  portfoliosSelector,
  portfoliosStateSelector,
  portfoliosReducerName,
  currentPortfolioCurrencySelector,
  findCustodianInPortfolios,
  portfolioSheetsMapSelector,
  portfolioSectionsMapSelector,
  custodianSelector,
  recapDataSelector,
  chartTimeRange,
  checkIfAChartOptionHasNoDataToShow,
  recapChartOptions,
  recapDataTotalInvestableAssetsSelector,
  recapDataCurrencySelector,
  recapReportNodeSelector,
  recapReportNameSelector,
  recapReportContentsDataSelector,
  reportPreferencesSelector,
  recapDataTotalAssetsSelector,
  sheetAndSectionReportNodeSelector,
  RECAP_CATEGORY_TYPE_ASSET,
  RECAP_CATEGORY_TYPE_NETWORTH,
  RECAP_CATEGORY_TYPE_DEBT,
  RECAP_CATEGORY_TYPE_FIAT_ASSET,
  convertCurrency,
  chartContent,
  getContentsTabTitle,
  getExchangeRate,
  getTickerUsingId,
  getTickerUsingShortName,
  getComparisonReportsTabTitleSelector,
  recapReportComparisonDataSelector,
  primaryResidenceValueStateSelector,
  currentPortfolioIdSelector,
  vanityStatDataSelector,
  getCustodianValue,
  custodianSheetSelector,
  resolveEffectiveTagAssignments,
  PVST_VALUE_TICKER_ID,
  getPVSTRate,
  categoryType,
  calcCustodianOwnershipValue,
  accountLinkingService,
  isVerifiedLinkingService,
  pickProperties,
  findPortfolioUsingCustodianIdSelector,
  findDefaultPersonTag,
  isDefaultPersonTag,
  liveTagAssignmentsForPortfolio,
  isManualConnectedHolding
} from "./Common";
import { isMobile, parseParams } from "../../utilities/Location";
import { getDirtyProperties, getDirtyItemIds, dirtyItemTypes } from "../../utilities/DirtyFieldTracker";
import { createSelector } from "reselect";
import { createStateAccessSelector } from "../../utilities/ReselectCustomMethods";
import memoize from "lodash.memoize";
import { isAppInViewMode } from "../../utilities/Common";
import { netWorthIrrComparisonTimePeriodSelector, displayTimezoneSelector } from "./AuthReducer";
import { additionalMetadataSelector } from "./TickerReducer";
import {
  toUserTimezoneDate,
  toTimezoneDate,
  getCivilDateString,
  getTodayCivilDateString
} from "../../utilities/Timezone";

export const initialState = {
  initialFetchSuccess: false,
  fetchPortfolioPending: false,
  fetchHoldingsPending: false,
  allConnectedCustodiansRefreshPending: false,
  fetchPortfolioError: null,
  fetchPortfolioChangeDataSuccess: false,
  lastPortfoliosFetchTs: new Date().getTime(),
  portfolios: null,
  currentPortfolioId: null,
  currentPortfolioCustodiansUpdatedTimestamp: undefined,
  lastDashboardUpdateTs: new Date().getTime(),
  dashboardEntitesToUpdate: [],
  portfolioLastForceRefreshTsMap: {},
  sortPreference: null,
  isPageReloading: false,
  isColumnarChartDataFetchError: false,
  sectionsUpdated: {},
  connectivityCenterData: null,
  recapDataPortfolioMap: {},
  recapDataPortfolioMapUpdateTimestamp: undefined,
  vanityStatPortfolioMap: {},
  lastViewedNetworthVanityPortfolioMap: {},
  portfolioChangeDataLastForceRefreshTsMap: {},
  portfolioCashForecastDurationMap: {},
  portfolioFundScheduleMap: {},
  recapRawData: {},
  showLoaderOnChartsModal: false,
  fetchingPercentageAllocationData: false,
  dashboardDataPortfolioMap: {},
  calculatingDashboardData: false,
  cagrData: null,
  proofsByPortfolioId: {}
};

export const portfolioPersistTransform = portfolioUserId => {
  if (isAppInViewMode()) {
    return createWhitelistFilter(portfoliosReducerName(portfolioUserId), [
      "portfolios",
      "portfolioLastForceRefreshTsMap",
      "portfolioChangeDataLastForceRefreshTsMap",
      "lastPortfoliosFetchTs",
      "connectivityCenterData",
      "portfolioCashForecastDurationMap",
      "portfolioFundScheduleMap",
      "dashboardDataPortfolioMap"
    ]);
  }

  return createWhitelistFilter(portfoliosReducerName(portfolioUserId), [
    "currentPortfolioId",
    "portfolioLastForceRefreshTsMap",
    "portfolioChangeDataLastForceRefreshTsMap",
    "lastPortfoliosFetchTs",
    "connectivityCenterData",
    "portfolioCashForecastDurationMap",
    "portfolioFundScheduleMap",
    "vanityStatPortfolioMap",
    "lastViewedNetworthVanityPortfolioMap",
    "dashboardDataPortfolioMap"
  ]);
};

export const pastValueInterval = {
  DAY: "day1",
  WEEK: "week1",
  MONTH: "month1",
  YEAR: "year1",
  YTD: "ytd"
};

export const undoQueue = [];
export const redoQueue = [];

export const portfolioActions = [
  INITIAL_FETCH_PORTFOLIOS_SUCCESS,
  RESET_PORTFOLIO_STATE,
  FETCH_PORTFOLIOS_PENDING,
  UPDATE_FETCH_HOLDINGS_STATUS,
  UPDATE_ALL_CONNECTED_CUSTODIANS_REFRESH_STATUS,
  FETCH_PORTFOLIOS_SUCCESS,
  SET_PORTFOLIOS,
  FETCH_PORTFOLIOS_ERROR,
  INSERT_PORTFOLIO,
  UPDATE_PORTFOLIO,
  DELETE_PORTFOLIO,
  UPDATE_CURRENT_PORTFOLIO,
  INSERT_CUSTODIAN_BULK,
  UPDATE_CUSTODIAN_BULK,
  BULK_CHANGE_CUSTODIAN_STAR_STATUS,
  BULK_CHANGE_CUSTODIAN_UPDATED_STATUS,
  DELETE_CUSTODIAN,
  DELETE_CUSTODIAN_BULK,
  INSERT_SECTION,
  INSERT_TAG,
  REPLACE_TAG,
  SET_TAG_MEMBERS,
  SET_TAG_ASSIGNMENTS,
  UPDATE_TAG,
  DELETE_TAG,
  UPDATE_SECTION,
  MOVE_SECTION,
  DELETE_SECTION,
  UPDATE_SHEET,
  MOVE_SHEET,
  DELETE_SHEET,
  INSERT_SHEET,
  INSERT_DOCUMENT,
  UPDATE_DOCUMENT,
  DELETE_DOCUMENT,
  SET_PROOFS,
  UPSERT_PROOF,
  REMOVE_PROOF,
  UPDATE_DASHBOARD,
  CLEAR_DASHBOARD_ENTITIES_TO_UPDATE,
  SET_PORTFOLIO_LAST_FORCE_REFRESH_TS,
  SET_PORTFOLIO_CHANGE_DATA_LAST_FORCE_REFRESH_TS,
  FETCH_NET_WORTH_DATA_PENDING,
  FETCH_NET_WORTH_DATA_SUCCESS,
  FETCH_NET_WORTH_DATA_ERROR,
  REMOVE_CONNECTION_ERRORS,
  FETCH_INITIAL_RECAP_DATA_PENDING,
  FETCH_RECAP_DATA_PENDING,
  FETCH_RECAP_DATA_SUCCESS,
  FETCH_VANITY_STAT_SUCCESS,
  SET_LAST_VIEWED_NETWORTH_VANITY,
  GET_CONNECTIVITY_CENTER_DATA_ERROR,
  GET_CONNECTIVITY_CENTER_DATA_PENDING,
  GET_CONNECTIVITY_CENTER_DATA_SUCCESS,
  FETCH_INITIAL_RECAP_DATA_ERROR,
  FETCH_RECAP_DATA_ERROR,
  FETCH_PORTFOLIO_CHANGE_DATA_PENDING,
  FETCH_PORTFOLIO_CHANGE_DATA_SUCCESS,
  FETCH_PORTFOLIO_CHANGE_DATA_ERROR,
  FETCH_CHART_AND_CAGR_DATA_PENDING,
  FETCH_CHART_AND_CAGR_DATA_SUCCESS,
  SET_LINK_TYPE,
  SET_SLIDE_DIRECTION,
  SET_SHOW_REFRESHING,
  PAGE_RELOADING,
  REFRESH_CUSTODIAN_DONE,
  SET_SECTION_UPDATED,
  REMOVE_SECTION_UPDATED,
  UPDATE_CONNECTIVITY_CENTER_DATA,
  ADD_SCENARIO,
  DELETE_SCENARIO,
  UPDATE_SCENARIO,
  UPDATE_SCENARIO_BULK,
  ADD_RULE,
  UPDATE_RULE,
  UPDATE_RULE_BULK,
  DELETE_RULE,
  UPDATE_CASH_FORECAST_DURATION,
  ADD_REPORT_PREFERENCE,
  ADD_DIY_CHART,
  DELETE_DIY_CHART,
  REHYDRATE_RECAP,
  GET_FUND_SCHEDULE_DATA_SUCCESS,
  UPDATE_RECAP_RAW_DATA_ACTION,
  CALCULATE_DASHBOARD_DATA_FOR_PORTFOLIO_SUCCESS,
  CALCULATE_DASHBOARD_DATA_FOR_PORTFOLIO_PENDING
];

// The fetched array usually has the section at (or near) the same index as the old array, so
// search outward from anchorIndex in both directions instead of scanning from the start.
const findSectionNearIndex = (sections, id, anchorIndex) => {
  if (sections.length === 0) {
    return null;
  }
  const anchor = Math.min(Math.max(anchorIndex, 0), sections.length - 1);
  for (let offset = 0; anchor + offset < sections.length || anchor - offset >= 0; offset++) {
    const ahead = anchor + offset;
    if (ahead < sections.length && sections[ahead].id === id) {
      return sections[ahead];
    }
    const behind = anchor - offset;
    if (offset !== 0 && behind >= 0 && sections[behind].id === id) {
      return sections[behind];
    }
  }
  return null;
};

// A fetch response that was in flight while the user edited a section field would clobber
// that edit; recently-edited (dirty) fields keep their local value instead.
const carryDirtySectionFieldsForward = (oldPortfolio, newPortfolio) => {
  if (!oldPortfolio.details?.section === true || !newPortfolio.details?.section === true) {
    return;
  }
  for (const id of getDirtyItemIds(dirtyItemTypes.SECTION)) {
    const dirtyProperties = getDirtyProperties(dirtyItemTypes.SECTION, id);
    if (dirtyProperties.length === 0) {
      continue;
    }
    const oldSectionIndex = oldPortfolio.details.section.findIndex(item => item.id === id);
    if (oldSectionIndex === -1) {
      continue;
    }
    const oldSection = oldPortfolio.details.section[oldSectionIndex];
    const newSection = findSectionNearIndex(newPortfolio.details.section, id, oldSectionIndex);
    if (!newSection === true) {
      continue;
    }
    for (const property of dirtyProperties) {
      newSection[property] = oldSection[property];
    }
  }
};

const getNewPortfoliosStateWithCurrentValues = (oldPortfolios, newPortfolios, currentPortfolioId) => {
  for (let portfolioIndex = 0; portfolioIndex < newPortfolios.length; portfolioIndex++) {
    if (newPortfolios[portfolioIndex].id === currentPortfolioId) {
      const oldPortfolio = oldPortfolios?.length
        ? oldPortfolios.find(portfolio => portfolio.id === currentPortfolioId) || {}
        : {};
      newPortfolios[portfolioIndex] = {
        ...oldPortfolio,
        ...newPortfolios[portfolioIndex]
      };
      carryDirtySectionFieldsForward(oldPortfolio, newPortfolios[portfolioIndex]);
      break;
    }
  }

  return newPortfolios;
};

// Upsert a custodian into the portfolio's custodian array.
// - When an existing custodian with the same id is found, merges fields in place and promotes
//   auto-added placeholders to real custodians (clears autoAddedForEmptySections), even if the
//   action's payload carried the flag in via a spread of the existing object (PVST connect flow).
// - When not found and `allowInsert` is true, unshifts the new custodian.
// Returns the section id if the upsert resulted in a non-auto-added custodian in a known
// section, so the caller can drive the auto-added-row sweep; null otherwise.
const upsertCustodianIntoPortfolio = (currentPortfolio, custodian, state, allowInsert, propertiesToUpdate = null) => {
  const custodianIndex = currentPortfolio.details.custodian.findIndex(item => item.id === custodian.id);

  if (!custodian.parentId === false) {
    copyLinkingInfoFromParentCustodian(state, custodian.parentId, custodian);
  }

  if (custodianIndex === -1) {
    if (!allowInsert) {
      return null;
    }
    currentPortfolio.details.custodian.unshift(custodian);
    return !custodian.autoAddedForEmptySections && custodian.sectionId ? custodian.sectionId : null;
  }

  const existing = currentPortfolio.details.custodian[custodianIndex];
  const merged = { ...existing, ...pickProperties(custodian, propertiesToUpdate) };
  if (existing.autoAddedForEmptySections === true) {
    merged.autoAddedForEmptySections = false;
  }
  currentPortfolio.details.custodian[custodianIndex] = merged;
  return !merged.autoAddedForEmptySections && merged.sectionId ? merged.sectionId : null;
};

// Drop auto-added blank-section placeholders from any section that just received a
// non-auto-added custodian. Two-pointer compaction keeps the array reference stable in a single
// O(n) pass — callers (e.g. the updateCustodian thunk) capture details.custodian by reference
// and rely on later mutations being visible through that reference; replacing the array would
// strand them on a stale snapshot.
const sweepAutoAddedPlaceholders = (custodianArr, sectionsWithRealRow, preserveCustodianIds) => {
  if (sectionsWithRealRow.size === 0) {
    return;
  }
  let writeIndex = 0;
  for (let readIndex = 0; readIndex < custodianArr.length; readIndex++) {
    const c = custodianArr[readIndex];
    const shouldKeep =
      preserveCustodianIds.has(c.id) || !c.autoAddedForEmptySections || !sectionsWithRealRow.has(c.sectionId);
    if (shouldKeep) {
      if (writeIndex !== readIndex) {
        custodianArr[writeIndex] = c;
      }
      writeIndex++;
    }
  }
  custodianArr.length = writeIndex;
};

export function portfolioReducer(state = initialState, action) {
  const suffix = !action.portfolioUserId === false ? `-${action.portfolioUserId}` : "";
  // make sure to add newPortfolioActions to portfolioActions array in Common.js to make sure subuser suffix logic works correctly
  switch (action.type) {
    case INITIAL_FETCH_PORTFOLIOS_SUCCESS + suffix:
      return {
        ...state,
        initialFetchSuccess: true
      };
    case RESET_PORTFOLIO_STATE + suffix:
      return {
        ...initialState
      };
    case FETCH_PORTFOLIOS_PENDING + suffix:
      return {
        ...state,
        fetchPortfolioPending: action.isBackgroundRefresh === false,
        fetchPortfolioError: null
      };
    case UPDATE_FETCH_HOLDINGS_STATUS + suffix:
      return {
        ...state,
        fetchHoldingsPending: action.isPending
      };
    case UPDATE_ALL_CONNECTED_CUSTODIANS_REFRESH_STATUS + suffix:
      return {
        ...state,
        allConnectedCustodiansRefreshPending: action.isPending
      };
    case FETCH_PORTFOLIOS_SUCCESS + suffix: {
      const newState = { ...state };
      newState.fetchPortfolioPending = false;
      newState.portfolios = getNewPortfoliosStateWithCurrentValues(
        state.portfolios,
        action.portfolios,
        state.currentPortfolioId
      );
      newState.fetchPortfolioError = null;
      newState.lastPortfoliosFetchTs = new Date().getTime();

      const isCurrentPortfolioValid =
        action.portfolios.findIndex(portfolio => portfolio.id === newState.currentPortfolioId) !== -1;
      if (isCurrentPortfolioValid === false && action.portfolios.length > 0) {
        newState.currentPortfolioId = action.portfolios[0].id;
      }
      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      return newState;
    }
    case SET_PORTFOLIOS + suffix: {
      const newState = { ...state };
      newState.portfolios = getNewPortfoliosStateWithCurrentValues(
        state.portfolios,
        action.portfolios,
        state.currentPortfolioId
      );

      const currentPortfolio = action.portfolios.find(portfolio => portfolio.id === newState.currentPortfolioId);
      var newCurrentPortfolioId =
        !currentPortfolio === false
          ? currentPortfolio.id
          : action.portfolios.length > 0
          ? action.portfolios[0].id
          : null;

      if (
        isAppInViewMode() === false &&
        action.showNonEmptyAsCurrent === true &&
        (!currentPortfolio === true || isPortfolioEmpty(currentPortfolio) === true)
      ) {
        for (const portfolio of newState.portfolios) {
          if (isPortfolioEmpty(portfolio) === false) {
            newCurrentPortfolioId = portfolio.id;
            break;
          }
        }
      }
      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      newState.currentPortfolioId = newCurrentPortfolioId;
      return newState;
    }
    case FETCH_PORTFOLIOS_ERROR + suffix:
      return {
        ...state,
        fetchPortfolioPending: false,
        isRefreshing: false,
        fetchPortfolioError: action.error
      };
    case INSERT_PORTFOLIO + suffix:
      return {
        ...state,
        createPortfolioPending: false,
        portfolios: [...state.portfolios, action.portfolio]
      };
    case UPDATE_PORTFOLIO + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const portfolioIndex = (portfolios || []).findIndex(portfolio => portfolio.id === action.portfolio.id);
      if (portfolioIndex !== -1) {
        sortPortfolio(action.portfolio);
        if (action.propToBeUpdated) {
          portfolios[portfolioIndex][action.propToBeUpdated] = action.portfolio[action.propToBeUpdated];
        } else {
          portfolios[portfolioIndex] = action.portfolio;
        }
      }
      newState.portfolios = portfolios;
      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      return newState;
    }
    case DELETE_PORTFOLIO + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const portfolioIndex = (portfolios || []).findIndex(portfolio => portfolio.id === action.portfolio.id);
      if (portfolioIndex !== -1) {
        portfolios.splice(portfolioIndex, 1);
        newState.portfolios = portfolios;
      }
      if (action.portfolio.id === newState.currentPortfolioId) {
        newState.currentPortfolioId = portfolios[0].id;
      }
      return newState;
    }
    case UPDATE_CURRENT_PORTFOLIO + suffix: {
      const newState = state;
      const portfolios = newState.portfolios;
      const portfolioIndex = (portfolios || []).findIndex(portfolio => portfolio.id === action.portfolioId);
      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();

      return {
        ...newState,
        currentPortfolioId:
          portfolioIndex === -1 && !portfolios === false && portfolios.length > 0
            ? portfolios[0].id
            : action.portfolioId
      };
    }
    case INSERT_CUSTODIAN_BULK + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }

      const sectionsWithRealNew = new Set();
      const incomingIds = new Set();

      for (const custodian of action.custodians) {
        incomingIds.add(custodian.id);
        const sectionId = upsertCustodianIntoPortfolio(currentPortfolio, custodian, state, true);
        if (sectionId) {
          sectionsWithRealNew.add(sectionId);
        }
        sortPortfolio(currentPortfolio);
        newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
        newState.portfolios = portfolios;
      }

      sweepAutoAddedPlaceholders(currentPortfolio.details.custodian, sectionsWithRealNew, incomingIds);

      return newState;
    }
    case UPDATE_CUSTODIAN_BULK + suffix: {
      const newState = { ...state };
      const portfolios = [...(newState.portfolios || [])];

      if (!action.portfolioId && !action.custodians && !action.portfolioCustodianMap) {
        return state;
      }

      const portfolioCustodianMap = action.portfolioCustodianMap || { [action.portfolioId]: action.custodians };
      for (const [portfolioId, custodians] of Object.entries(portfolioCustodianMap)) {
        const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === portfolioId);
        if (!currentPortfolio === true) {
          return state;
        }

        const sectionsWithRealUpdate = new Set();
        const touchedIds = new Set();

        for (const custodian of custodians) {
          touchedIds.add(custodian.id);
          const sectionId = upsertCustodianIntoPortfolio(
            currentPortfolio,
            custodian,
            state,
            !!action.includeNotFoundCustodians,
            action.propertiesToUpdate
          );
          if (sectionId) {
            sectionsWithRealUpdate.add(sectionId);
          }
        }
        sortPortfolio(currentPortfolio);

        sweepAutoAddedPlaceholders(currentPortfolio.details.custodian, sectionsWithRealUpdate, touchedIds);
      }
      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      newState.portfolios = portfolios;
      return newState;
    }
    case BULK_CHANGE_CUSTODIAN_STAR_STATUS + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }
      for (const custodian of currentPortfolio.details.custodian) {
        if (action.custodianIdArray.includes(custodian.id)) {
          custodian.star = action.isStarred === true ? 1 : 0;
        }
      }
      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      newState.portfolios = portfolios;
      return newState;
    }
    case BULK_CHANGE_CUSTODIAN_UPDATED_STATUS + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }
      for (const custodian of currentPortfolio.details.custodian) {
        if (action.custodianIdArray.includes(custodian.id)) {
          custodian.past = action.isUpdated === true ? 0 : 1;
        }
      }
      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      newState.portfolios = portfolios;
      return newState;
    }
    case DELETE_CUSTODIAN + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }
      currentPortfolio.details.custodian = currentPortfolio.details.custodian.filter(
        custodian => custodian.id !== action.custodianId && custodian.parentId !== action.custodianId
      );
      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      newState.portfolios = portfolios;
      return newState;
    }
    case DELETE_CUSTODIAN_BULK + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }
      currentPortfolio.details.custodian = currentPortfolio.details.custodian.filter(
        item =>
          action.custodianIds.includes(item.id) === false &&
          (!item.parentId || action.custodianIds.includes(item.parentId) === false)
      );
      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      newState.portfolios = portfolios;
      return newState;
    }
    case INSERT_SECTION + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }
      const sectionIndex = currentPortfolio.details.section.findIndex(section => section.id === action.section.id);
      if (sectionIndex === -1) {
        currentPortfolio.details.section.unshift(action.section);
      }
      sortPortfolio(currentPortfolio);
      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      newState.portfolios = portfolios;
      return newState;
    }
    case INSERT_TAG + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }
      const existingTags = currentPortfolio.details.tag || [];
      const tagIndex = existingTags.findIndex(tag => tag.id === action.tag.id);
      if (tagIndex === -1) {
        currentPortfolio.details.tag = [...existingTags, action.tag];
      }
      newState.portfolios = portfolios;
      return newState;
    }
    case REPLACE_TAG + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }
      const existingTags = currentPortfolio.details.tag || [];
      currentPortfolio.details.tag = existingTags.map(tag => (tag.id === action.clientTagId ? action.tag : tag));
      const existingMembers = currentPortfolio.details.tagMember || [];
      currentPortfolio.details.tagMember = existingMembers.map(member => ({
        ...member,
        trustTagId: member.trustTagId === action.clientTagId ? action.tag.id : member.trustTagId,
        personTagId: member.personTagId === action.clientTagId ? action.tag.id : member.personTagId
      }));
      const existingAssignments = currentPortfolio.details.tagAssignment || [];
      currentPortfolio.details.tagAssignment = existingAssignments.map(assignment =>
        assignment.tagId === action.clientTagId ? { ...assignment, tagId: action.tag.id } : assignment
      );
      newState.portfolios = portfolios;
      return newState;
    }
    case SET_TAG_MEMBERS + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }
      const existingMembers = currentPortfolio.details.tagMember || [];
      currentPortfolio.details.tagMember = [
        ...existingMembers.filter(member => member.trustTagId !== action.trustTagId),
        ...action.members.map(member => ({
          trustTagId: action.trustTagId,
          personTagId: member.personTagId,
          percentage: member.percentage
        }))
      ];
      newState.portfolios = portfolios;
      return newState;
    }
    case UPDATE_TAG + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }
      const existingTags = currentPortfolio.details.tag || [];
      currentPortfolio.details.tag = existingTags.map(tag =>
        tag.id === action.tagId ? { ...tag, ...action.properties } : tag
      );
      newState.portfolios = portfolios;
      return newState;
    }
    case DELETE_TAG + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }
      currentPortfolio.details.tag = (currentPortfolio.details.tag || []).filter(tag => tag.id !== action.tagId);
      currentPortfolio.details.tagMember = (currentPortfolio.details.tagMember || []).filter(
        member => member.trustTagId !== action.tagId && member.personTagId !== action.tagId
      );
      currentPortfolio.details.tagAssignment = (currentPortfolio.details.tagAssignment || []).filter(
        assignment => assignment.tagId !== action.tagId
      );
      newState.portfolios = portfolios;
      return newState;
    }
    case SET_TAG_ASSIGNMENTS + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }
      const existingAssignments = currentPortfolio.details.tagAssignment || [];
      currentPortfolio.details.tagAssignment = [
        ...existingAssignments.filter(
          assignment => !(assignment.entityType === action.entityType && assignment.entityId === action.entityId)
        ),
        ...action.tags.map(tag => ({
          tagId: tag.tagId,
          entityType: action.entityType,
          entityId: action.entityId,
          portfolioId: action.portfolioId,
          percentage: tag.percentage
        }))
      ];
      newState.portfolios = portfolios;
      return newState;
    }
    case UPDATE_SECTION + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];

      if (!action.portfolioSectionsMap === true) {
        return state;
      }
      for (const [portfolioId, sections] of Object.entries(action.portfolioSectionsMap)) {
        const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === portfolioId);
        if (!currentPortfolio === true) {
          return state;
        }
        for (const section of sections) {
          const sectionIndex = currentPortfolio.details.section.findIndex(item => item.id === section.id);
          if (sectionIndex !== -1) {
            currentPortfolio.details.section[sectionIndex] = {
              ...currentPortfolio.details.section[sectionIndex],
              ...pickProperties(section, action.propertiesToUpdate)
            };
          } else {
            currentPortfolio.details.section.push(section);
          }
        }
        sortPortfolio(currentPortfolio);
      }

      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      newState.portfolios = portfolios;
      return newState;
    }
    case MOVE_SECTION + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);
      const targetPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.targetPortfolioId);

      if (!currentPortfolio === true) {
        return state;
      }

      if (targetPortfolio.id === currentPortfolio.id) {
        const sectionIndex = currentPortfolio.details.section.findIndex(section => section.id === action.section.id);
        if (sectionIndex !== -1) {
          currentPortfolio.details.section[sectionIndex] = {
            ...currentPortfolio.details.section[sectionIndex],
            ...action.section
          };
        }
      } else {
        currentPortfolio.details.section = currentPortfolio.details.section.filter(
          item => item.id !== action.section.id
        );
        targetPortfolio.details.section.push(action.section);

        const sectionCustodians = currentPortfolio.details.custodian.filter(
          item => item.sectionId === action.section.id
        );
        currentPortfolio.details.custodian = currentPortfolio.details.custodian.filter(
          item => item.sectionId !== action.section.id
        );
        targetPortfolio.details.custodian.push(...sectionCustodians);
      }
      sortPortfolio(targetPortfolio);
      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      newState.portfolios = portfolios;
      return newState;
    }
    case DELETE_SECTION + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }
      const sections = currentPortfolio.details.section;
      const sectionIndex = sections.findIndex(section => section.id === action.sectionId);
      if (sectionIndex !== -1) {
        sections.splice(sectionIndex, 1);
        currentPortfolio.details.section = sections;

        const custodians = currentPortfolio.details.custodian;
        if (custodians) {
          const newCustodians = custodians.filter(
            custodian => custodian.sectionId !== action.sectionId || custodian.hidden === 1
          );
          currentPortfolio.details.custodian = newCustodians;
        }
      }
      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      newState.portfolios = portfolios;
      return newState;
    }
    case UPDATE_SHEET + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];

      if (!action.portfolioSheetsMap === true) {
        return state;
      }
      for (const [portfolioId, sheets] of Object.entries(action.portfolioSheetsMap)) {
        const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === portfolioId);
        if (!currentPortfolio === true) {
          continue;
        }
        for (const sheet of sheets) {
          const sheetIndex = currentPortfolio.details.sheet.findIndex(item => item.id === sheet.id);
          if (sheetIndex !== -1) {
            currentPortfolio.details.sheet[sheetIndex] =
              !action.propertiesToUpdate === true
                ? sheet
                : {
                    ...currentPortfolio.details.sheet[sheetIndex],
                    ...pickProperties(sheet, action.propertiesToUpdate)
                  };
          }
        }
      }
      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      newState.portfolios = portfolios;
      return newState;
    }
    case MOVE_SHEET + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);
      const targetPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.targetPortfolioId);

      if (!currentPortfolio === true) {
        return state;
      }

      const sheetSections = currentPortfolio.details.section.filter(item => item.sheetId === action.sheet.id);
      const sheetSectionsIds = sheetSections.map(item => item.id);
      const sheetCustodians = currentPortfolio.details.custodian.filter(item =>
        sheetSectionsIds.includes(item.sectionId)
      );

      currentPortfolio.details.sheet = currentPortfolio.details.sheet.filter(item => item.id !== action.sheet.id);
      currentPortfolio.details.section = currentPortfolio.details.section.filter(
        item => sheetSectionsIds.includes(item.id) === false
      );
      currentPortfolio.details.custodian = currentPortfolio.details.custodian.filter(
        item => sheetSectionsIds.includes(item.sectionId) === false
      );

      targetPortfolio.details.sheet.push(action.sheet);
      targetPortfolio.details.section.push(...sheetSections);
      targetPortfolio.details.custodian.push(...sheetCustodians);

      sortPortfolio(targetPortfolio);
      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      newState.portfolios = portfolios;
      return newState;
    }
    case DELETE_SHEET + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }
      const sheets = currentPortfolio.details.sheet;
      const sheetIndex = sheets.findIndex(sheet => sheet.id === action.sheetId);
      if (sheetIndex !== -1) {
        sheets.splice(sheetIndex, 1);
        currentPortfolio.details.sheet = sheets;

        const sections = currentPortfolio.details.section;
        if (sections) {
          const newSections = sections.filter(section => section.sheetId !== action.sheetId);
          currentPortfolio.details.section = newSections;

          const newSectionIds = newSections.map(section => section.id);
          const custodians = currentPortfolio.details.custodian;
          if (custodians) {
            const newCustodians = custodians.filter(
              custodian => newSectionIds.includes(custodian.sectionId) === true || custodian.hidden === 1
            );
            currentPortfolio.details.custodian = newCustodians;
          }
        }
      }
      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      newState.portfolios = portfolios;
      return newState;
    }
    case INSERT_SHEET + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }
      const sheetIndex = currentPortfolio.details.sheet.findIndex(sheet => sheet.id === action.sheet.id);
      if (sheetIndex === -1) {
        currentPortfolio.details.sheet.push(action.sheet);
      }
      sortPortfolio(currentPortfolio);
      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      newState.portfolios = portfolios;
      return newState;
    }
    case INSERT_DOCUMENT + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }
      const newDocuments = [...currentPortfolio.details.document, action.document];
      currentPortfolio.details.document = newDocuments;
      newState.portfolios = portfolios;
      return newState;
    }
    case UPDATE_DOCUMENT + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }
      var newDocuments = currentPortfolio.details.document.filter(doc => doc.id !== action.document.id);
      newDocuments.push(action.document);
      currentPortfolio.details.document = newDocuments;
      newState.portfolios = portfolios;
      return newState;
    }
    case DELETE_DOCUMENT + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === true) {
        return state;
      }
      const newDocuments = currentPortfolio.details.document.filter(
        doc => doc.id !== action.document.id && doc.custodianId !== action.document.id
      );
      currentPortfolio.details.document = newDocuments;
      newState.portfolios = portfolios;
      return newState;
    }
    case SET_PROOFS + suffix: {
      return {
        ...state,
        proofsByPortfolioId: {
          ...state.proofsByPortfolioId,
          [action.portfolioId]: action.proofs
        }
      };
    }
    case UPSERT_PROOF + suffix: {
      const existing = state.proofsByPortfolioId[action.portfolioId] || [];
      return {
        ...state,
        proofsByPortfolioId: {
          ...state.proofsByPortfolioId,
          [action.portfolioId]: [...existing.filter(p => p.id !== action.proof.id), action.proof]
        }
      };
    }
    case REMOVE_PROOF + suffix: {
      const existing = state.proofsByPortfolioId[action.portfolioId] || [];
      return {
        ...state,
        proofsByPortfolioId: {
          ...state.proofsByPortfolioId,
          [action.portfolioId]: existing.filter(p => p.id !== action.proofId)
        }
      };
    }
    case UPDATE_DASHBOARD + suffix: {
      const newState = { ...state };
      newState.lastDashboardUpdateTs = new Date().getTime();

      // null payload = "refresh everything"; it subsumes any pending list and stays null until cleared.
      // Otherwise accumulate (deduped) so rapid dispatches don't clobber each other before consumers process.
      if (action.updatedEntitiesArray === null || state.dashboardEntitesToUpdate === null) {
        newState.dashboardEntitesToUpdate = null;
      } else {
        const existing = state.dashboardEntitesToUpdate || [];
        newState.dashboardEntitesToUpdate = Array.from(new Set([...existing, ...action.updatedEntitiesArray]));
      }

      const portfolios = Array.isArray(newState.portfolios) ? [...newState.portfolios] : [];
      for (const portfolio of portfolios) {
        for (const section of portfolio.details.section) {
          const custodians = portfolio.details.custodian
            .filter(custodian => custodian.sectionId === section.id)
            .filter(custodian => custodian.hidden !== 1);

          // Insert 3 empty custodians if none present for a section
          if (custodians.length === 0) {
            var defaultCustodians = [
              { id: getUuid(), sectionId: section.id, sortKey: "1", autoAddedForEmptySections: true },
              { id: getUuid(), sectionId: section.id, sortKey: "2", autoAddedForEmptySections: true },
              { id: getUuid(), sectionId: section.id, sortKey: "3", autoAddedForEmptySections: true }
            ];
            portfolio.details.custodian.push(...defaultCustodians);
          }
        }

        // Remove duplicate custodians if any
        const custodianIdMap = {};
        var uniqueCustodians = [];
        for (const custodian of portfolio.details.custodian) {
          if (!custodianIdMap[custodian.id] === true) {
            custodianIdMap[custodian.id] = custodian;
          }
        }
        if (Object.keys(custodianIdMap).length !== portfolio.details.custodian.length) {
          for (const key in custodianIdMap) {
            uniqueCustodians.push(custodianIdMap[key]);
          }
          portfolio.details.custodian = uniqueCustodians;
        }
      }

      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      newState.portfolios = portfolios;
      return newState;
    }
    case CLEAR_DASHBOARD_ENTITIES_TO_UPDATE + suffix: {
      return {
        ...state,
        dashboardEntitesToUpdate: []
      };
    }
    case SET_PORTFOLIO_LAST_FORCE_REFRESH_TS + suffix: {
      const newState = { ...state };
      const portfolioLastForceRefreshTsMap = newState.portfolioLastForceRefreshTsMap;
      portfolioLastForceRefreshTsMap[action.portfolioId] = action.timestamp;
      return newState;
    }
    case SET_PORTFOLIO_CHANGE_DATA_LAST_FORCE_REFRESH_TS + suffix: {
      const newState = { ...state };
      const portfolioChangeDataLastForceRefreshTsMap = newState.portfolioChangeDataLastForceRefreshTsMap;
      portfolioChangeDataLastForceRefreshTsMap[action.portfolioId] = action.timestamp;
      return newState;
    }
    case FETCH_NET_WORTH_DATA_PENDING + suffix: {
      const newState = { ...state };
      const portfolios = Array.isArray(newState.portfolios) ? [...newState.portfolios] : [];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === false) {
        if (!currentPortfolio.details.networth === true) {
          currentPortfolio.details.networth = {};
        }
        currentPortfolio.details.networth = {
          ...currentPortfolio.details.networth,
          ...{ isFetching: true, error: null }
        };
      }
      newState.portfolios = portfolios;
      return newState;
    }

    case FETCH_NET_WORTH_DATA_SUCCESS + suffix: {
      const newState = { ...state };
      const portfolios = [...(newState?.portfolios || [])];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);
      const recapRawData = action.data.recapRawData;
      delete action.data.recapRawData;
      if (!currentPortfolio === false) {
        currentPortfolio.details.networth = {
          data: action.data,
          isFetching: false,
          error: null
        };
      }
      newState.portfolios = portfolios;
      newState.recapRawData = recapRawData;
      return newState;
    }
    case FETCH_NET_WORTH_DATA_ERROR + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === false) {
        if (!currentPortfolio.details.networth === true) {
          currentPortfolio.details.networth = {};
        }
        currentPortfolio.details.networth = {
          ...currentPortfolio.details.networth,
          ...{ isFetching: false, error: action.error }
        };
      }
      newState.portfolios = portfolios;
      return newState;
    }
    case REMOVE_CONNECTION_ERRORS + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);
      if (currentPortfolio?.details?.networth?.data?.connErrors) {
        const connectionErrors = currentPortfolio.details.networth.data.connErrors;
        currentPortfolio.details.networth.data.connErrors = connectionErrors.filter(
          item => action.custodianIds.includes(item.id) === false
        );
      }
      currentPortfolio.details.networth = { ...currentPortfolio.details.networth };
      newState.portfolios = portfolios;
      return newState;
    }

    case FETCH_INITIAL_RECAP_DATA_PENDING + suffix:
    case FETCH_RECAP_DATA_PENDING + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);
      if (!currentPortfolio === false) {
        currentPortfolio.details.recapDataStatus = {
          isFetching: true
        };
      }
      newState.portfolios = portfolios;
      return newState;
    }

    case FETCH_RECAP_DATA_SUCCESS + suffix: {
      const newState = { ...state };
      const portfolios = Array.isArray(newState.portfolios) ? [...newState.portfolios] : [];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);
      const { recapData, currency, isRecapPage } = action.data;
      if (!currentPortfolio === false && isRecapPage) {
        currentPortfolio.details.recapDataStatus = {
          isFetching: false
        };
      }

      if (!newState.recapDataPortfolioMap === true) {
        newState.recapDataPortfolioMap = {};
      }
      const recapPortfolioId = currentPortfolio && currentPortfolio.id;
      const existingCurrency = newState.recapDataPortfolioMap[recapPortfolioId]?.currency;
      newState.recapDataPortfolioMap[recapPortfolioId] = {
        data: recapData,
        currency: currency === undefined ? existingCurrency : currency
      };
      newState.recapDataPortfolioMapUpdateTimestamp = Date.now();
      newState.portfolios = portfolios;
      newState.fetchingPercentageAllocationData = false;
      newState.showLoaderOnChartsModal = false;
      newState.isCalculatingRecapReport = false;
      return newState;
    }

    case CALCULATE_DASHBOARD_DATA_FOR_PORTFOLIO_SUCCESS + suffix: {
      const newState = { ...state };
      newState.calculatingDashboardData = false;
      newState.dashboardDataPortfolioMap[action.portfolioId] = action.dashboardData;
      return newState;
    }

    case CALCULATE_DASHBOARD_DATA_FOR_PORTFOLIO_PENDING + suffix: {
      const newState = { ...state };
      newState.calculatingDashboardData = true;
      return newState;
    }

    case FETCH_VANITY_STAT_SUCCESS + suffix: {
      const newState = { ...state };
      newState.vanityStatPortfolioMap = {
        ...state.vanityStatPortfolioMap,
        [action.portfolioId]: action.stat
      };
      return newState;
    }

    case SET_LAST_VIEWED_NETWORTH_VANITY + suffix: {
      const newState = { ...state };
      newState.lastViewedNetworthVanityPortfolioMap = {
        ...state.lastViewedNetworthVanityPortfolioMap,
        [action.portfolioId]: action.networthVanity
      };
      return newState;
    }

    case UPDATE_SHOW_CHARTS_MODAL_LOADER: {
      return {
        ...state,
        showLoaderOnChartsModal: action.showLoader
      };
    }

    case UPDATE_RECAP_REPORT_CALCULATION_PENDING: {
      return {
        ...state,
        isCalculatingRecapReport: action.isCalculating
      };
    }
    case GET_CONNECTIVITY_CENTER_DATA_ERROR + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === false) {
        if (!currentPortfolio.details.connectivityCenterData === true) {
          currentPortfolio.details.connectivityCenterData = {};
        }
        currentPortfolio.details.connectivityCenterData = {
          ...currentPortfolio.details.connectivityCenterData,
          ...{ isFetching: false, error: action.error }
        };
      }
      newState.portfolios = portfolios;
      return newState;
    }
    case GET_CONNECTIVITY_CENTER_DATA_PENDING + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === false) {
        if (!currentPortfolio.details.connectivityCenterData === true) {
          currentPortfolio.details.connectivityCenterData = {};
        }
        currentPortfolio.details.connectivityCenterData = {
          ...currentPortfolio.details.connectivityCenterData,
          ...{ isFetching: true, error: null }
        };
      }
      newState.portfolios = portfolios;
      return newState;
    }
    case GET_CONNECTIVITY_CENTER_DATA_SUCCESS + suffix: {
      const newState = { ...state };
      newState.connectivityCenterData = action.data;
      return newState;
    }
    case FETCH_INITIAL_RECAP_DATA_ERROR + suffix: {
      const newState = { ...state };
      newState.isColumnarChartDataFetchError = true;
      return newState;
    }
    case FETCH_RECAP_DATA_ERROR + suffix: {
      const newState = { ...state };
      newState.isColumnarChartDataFetchError = true;
      newState.isCalculatingRecapReport = false;
      return newState;
    }
    case FETCH_PORTFOLIO_CHANGE_DATA_PENDING + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === false) {
        if (!currentPortfolio.details.changeData === true) {
          currentPortfolio.details.changeData = {};
        }
        currentPortfolio.details.changeData = {
          ...currentPortfolio.details.changeData,
          ...{ isDayChangeFetching: true, isAllChangeFetching: true, error: null }
        };
      }
      newState.portfolios = portfolios;
      return newState;
    }
    case FETCH_PORTFOLIO_CHANGE_DATA_SUCCESS + suffix: {
      const newState = { ...state };
      newState.fetchPortfolioChangeDataSuccess = true;

      const portfolios = [...newState.portfolios];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === false && !currentPortfolio.details.changeData === false) {
        var changeData = currentPortfolio.details.changeData;

        if (action.isDayChangeData) {
          for (const key in action.data.change) {
            if (!action.data.change[key] === true) {
              delete action.data.change[key];
            }
          }
        }

        if (changeData.data && changeData.data.change) {
          action.data.change = { ...changeData.data.change, ...action.data.change };
        }

        currentPortfolio.details.changeData = {
          data: action.data,
          isDayChangeFetching: false,
          isAllChangeFetching: action.isDayChangeData ? changeData.isAllChangeFetching : false,
          error: null
        };
      } else if (!currentPortfolio === false && currentPortfolio.details) {
        currentPortfolio.details.changeData = {
          ...currentPortfolio.details.changeData,
          isDayChangeFetching: false,
          isAllChangeFetching: action.isDayChangeData ? changeData.isAllChangeFetching : false
        };
      }

      newState.currentPortfolioCustodiansUpdatedTimestamp = Date.now();
      newState.portfolios = portfolios;
      return newState;
    }
    case FETCH_PORTFOLIO_CHANGE_DATA_ERROR + suffix: {
      const newState = { ...state };
      const portfolios = Array.isArray(newState.portfolios) ? [...newState.portfolios] : [];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);

      if (!currentPortfolio === false) {
        if (!currentPortfolio.details.changeData === true) {
          currentPortfolio.details.changeData = {};
        }
        const changeData = currentPortfolio.details.changeData;
        currentPortfolio.details.changeData = {
          ...currentPortfolio.details.changeData,
          ...{
            isDayChangeFetching: false,
            isAllChangeFetching: action.isDayChangeData ? changeData.isAllChangeFetching : false,
            error: action.error
          }
        };
        // eslint-disable-next-line no-dupe-else-if
      } else if (!currentPortfolio === false && currentPortfolio.details) {
        currentPortfolio.details.changeData = {
          ...currentPortfolio.details.changeData,
          isDayChangeFetching: false,
          isAllChangeFetching: action.isDayChangeData ? changeData.isAllChangeFetching : false
        };
      }

      newState.portfolios = portfolios;
      return newState;
    }
    case FETCH_CHART_AND_CAGR_DATA_PENDING + suffix: {
      const newState = { ...state };
      const portfolios = [...(newState.portfolios || [])];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);
      if (!currentPortfolio === false) {
        currentPortfolio.details.chartAndCagrData = {
          ...currentPortfolio.details.chartAndCagrData,
          isFetching: true
        };
      }
      newState.portfolios = portfolios;
      return newState;
    }
    case FETCH_CHART_AND_CAGR_DATA_SUCCESS + suffix: {
      const newState = { ...state };
      const portfolios = [...(newState.portfolios || [])];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);
      if (!currentPortfolio === false) {
        currentPortfolio.details.chartAndCagrData = { ...action.data, isFetching: false };
      }
      newState.portfolios = portfolios;
      return newState;
    }
    case UPDATE_PORTFOLIO_CHANGE_DATA_ACTION + suffix: {
      const newState = { ...state };
      const portfolios = Array.isArray(newState.portfolios) ? [...newState.portfolios] : [];
      const currentPortfolio = (portfolios || []).find(portfolio => portfolio.id === action.portfolioId);
      if (currentPortfolio?.details) {
        currentPortfolio.details.changeData = action.data;
      }
      newState.portfolios = portfolios;
      return newState;
    }
    case SET_LINK_TYPE + suffix:
      return {
        ...state,
        connectedLinkType: action.connectedLinkType
      };
    case SET_SLIDE_DIRECTION + suffix:
      return {
        ...state,
        slideDirection: action.slideDirection
      };
    case SET_SHOW_REFRESHING + suffix:
      return {
        ...state,
        isRefreshing: action.isRefreshing
      };
    case PAGE_RELOADING + suffix:
      return {
        ...state,
        isPageReloading: action.isLoading
      };
    case REFRESH_CUSTODIAN_DONE + suffix:
      return {
        ...state,
        refreshCustodoanTime: new Date().getTime()
      };
    case SET_SECTION_UPDATED + suffix:
      return {
        ...state,
        sectionsUpdated: {
          ...state.sectionsUpdated,
          [action.sectionId]: true
        }
      };
    case REMOVE_SECTION_UPDATED + suffix: {
      const newState = { ...state };

      delete newState.sectionsUpdated[action.sectionId];
      return newState;
    }
    case UPDATE_CONNECTIVITY_CENTER_DATA + suffix: {
      const newState = { ...state };
      const portfolioIndex = newState.connectivityCenterData.findIndex(data => data.portfolioId === action.portfolioId);
      const connectivityCenterData = [...newState.connectivityCenterData];
      connectivityCenterData[portfolioIndex] = {
        ...newState.connectivityCenterData[portfolioIndex],
        connectivityCenter: action.connectivityCenterDataForAPortfolio
      };
      newState.connectivityCenterData = connectivityCenterData;
      return { ...newState };
    }

    case ADD_SCENARIO + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const portfolioIndex = (portfolios || []).findIndex(portfolio => portfolio.id === action.portfolioId);
      if (portfolioIndex !== -1) {
        const portfolioDetails = portfolios[portfolioIndex];
        const planningDataForAPortfolio = { ...portfolioDetails.planning };
        if (action.scenarioIndex !== undefined) {
          planningDataForAPortfolio.scenario.splice(action.scenarioIndex, 0, action.scenario);
        } else {
          planningDataForAPortfolio.scenario = [...planningDataForAPortfolio.scenario, action.scenario];
        }
        planningDataForAPortfolio.rule = [...planningDataForAPortfolio.rule, ...action.scenario.rule];
        portfolios[portfolioIndex].planning = planningDataForAPortfolio;
      }
      newState.portfolios = portfolios;
      return { ...newState };
    }

    case DELETE_SCENARIO + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const portfolioIndex = (portfolios || []).findIndex(portfolio => portfolio.id === action.portfolioId);
      if (portfolioIndex !== -1) {
        const portfolioDetails = portfolios[portfolioIndex];
        const planningDataForAPortfolio = { ...portfolioDetails.planning };
        const planningScenarios = [...planningDataForAPortfolio.scenario];
        const planningRules = [...planningDataForAPortfolio.rule];
        const scenarioIndex = planningScenarios.findIndex(scenario => scenario.id === action.scenarioId);
        if (scenarioIndex !== -1) {
          planningScenarios.splice(scenarioIndex, 1);
          const filteredRules = planningRules.filter(rule => rule.scenarioId !== action.scenarioId);
          planningDataForAPortfolio.scenario = planningScenarios;
          planningDataForAPortfolio.rule = filteredRules;
          portfolios[portfolioIndex].planning = planningDataForAPortfolio;
        }
      }
      newState.portfolios = portfolios;
      return newState;
    }

    case UPDATE_SCENARIO + suffix: {
      const newState = { ...state };
      const portfolios = newState.portfolios;
      const portfolioIndex = (portfolios || []).findIndex(portfolio => portfolio.id === action.portfolioId);
      if (portfolioIndex !== -1) {
        const portfolioDetails = portfolios[portfolioIndex];
        const planningDataForAPortfolio = portfolioDetails.planning;
        const scenarioIndex = planningDataForAPortfolio.scenario.findIndex(
          scenario => scenario.id === action.scenario.id
        );
        if (scenarioIndex !== -1) {
          planningDataForAPortfolio.scenario[scenarioIndex] = action.scenario;
          const updatedPortfolioDetails = { ...portfolioDetails, planning: planningDataForAPortfolio };
          portfolios[portfolioIndex] = updatedPortfolioDetails;
        }
      }
      newState.portfolios = portfolios;
      return newState;
    }

    case UPDATE_SCENARIO_BULK + suffix: {
      const newState = { ...state };
      const portfolios = newState.portfolios;
      const portfolioIndex = (portfolios || []).findIndex(portfolio => portfolio.id === action.portfolioId);
      if (portfolioIndex !== -1) {
        const portfolioDetails = portfolios[portfolioIndex];
        const planningDataForAPortfolio = portfolioDetails.planning;
        const currentScenarioIds = planningDataForAPortfolio.scenario.map(scenario => scenario.id);
        const updatedScenarios = action.scenarios.reduce((verifiedScenarios, scenario) => {
          if (currentScenarioIds.includes(scenario.id)) {
            verifiedScenarios.push(scenario);
          }

          return verifiedScenarios;
        }, []);
        planningDataForAPortfolio.scenario = updatedScenarios;
        const updatedPortfolioDetails = { ...portfolioDetails, planning: planningDataForAPortfolio };
        portfolios[portfolioIndex] = updatedPortfolioDetails;
      }
      newState.portfolios = portfolios;
      return newState;
    }

    case ADD_RULE + suffix: {
      const newState = { ...state };
      const portfolios = newState.portfolios;
      const portfolioIndex = (portfolios || []).findIndex(portfolio => portfolio.id === action.portfolioId);
      if (portfolioIndex !== -1) {
        const portfolioDetails = portfolios[portfolioIndex];
        const planningDataForAPortfolio = { ...portfolioDetails.planning };
        planningDataForAPortfolio.rule.push(action.rule);
        portfolios[portfolioIndex].planning = planningDataForAPortfolio;
      }
      newState.portfolios = portfolios;
      return newState;
    }

    case UPDATE_RULE + suffix: {
      const newState = { ...state };
      const portfolios = newState.portfolios;
      const portfolioIndex = (portfolios || []).findIndex(portfolio => portfolio.id === action.portfolioId);
      if (portfolioIndex !== -1) {
        const portfolioDetails = portfolios[portfolioIndex];
        const planningDataForAPortfolio = { ...portfolioDetails.planning };
        const ruleIndex = planningDataForAPortfolio.rule.findIndex(rule => rule.id === action.ruleId);
        if (ruleIndex !== -1) {
          const ruleToBeUpdated = planningDataForAPortfolio.rule[ruleIndex];
          planningDataForAPortfolio.rule[ruleIndex] = { ...ruleToBeUpdated, ...action.dataToBeUpdated };
          portfolios[portfolioIndex].planning = planningDataForAPortfolio;
        }
      }
      newState.portfolios = portfolios;
      return newState;
    }

    case UPDATE_RULE_BULK + suffix: {
      const newState = { ...state };
      const portfolios = [...newState.portfolios];
      const portfolioIndex = (portfolios || []).findIndex(portfolio => portfolio.id === action.portfolioId);
      if (portfolioIndex !== -1) {
        const portfolioDetails = portfolios[portfolioIndex];
        const planningDataForAPortfolio = { ...portfolioDetails.planning };
        for (const rule of action.rules) {
          const ruleIndex = planningDataForAPortfolio.rule.findIndex(item => item.id === rule.id);

          if (ruleIndex !== -1) {
            planningDataForAPortfolio.rule[ruleIndex] = {
              ...planningDataForAPortfolio.rule[ruleIndex],
              ...rule
            };
            portfolios[portfolioIndex].planning = planningDataForAPortfolio;
          }
        }
      }
      newState.portfolios = portfolios;
      return newState;
    }

    case DELETE_RULE + suffix: {
      const newState = { ...state };
      const portfolios = newState.portfolios;
      const portfolioIndex = (portfolios || []).findIndex(portfolio => portfolio.id === action.portfolioId);
      if (portfolioIndex !== -1) {
        const portfolioDetails = portfolios[portfolioIndex];
        const planningDataForAPortfolio = { ...portfolioDetails.planning };
        const planningRules = [...planningDataForAPortfolio.rule];
        const ruleIndex = planningRules.findIndex(rule => rule.id === action.ruleId);
        if (ruleIndex !== -1) {
          planningRules.splice(ruleIndex, 1);
          planningDataForAPortfolio.rule = planningRules;
          portfolios[portfolioIndex].planning = planningDataForAPortfolio;
        }
      }
      newState.portfolios = portfolios;
      return newState;
    }

    case UPDATE_CASH_FORECAST_DURATION + suffix: {
      const newState = { ...state };
      const portfolioCashForecastDurationMap = newState.portfolioCashForecastDurationMap;
      portfolioCashForecastDurationMap[action.portfolioId] = action.duration;
      return newState;
    }

    case ADD_REPORT_PREFERENCE + suffix: {
      const newState = { ...state };
      const portfolios = newState.portfolios;
      const portfolioIndex = (portfolios || []).findIndex(portfolio => portfolio.id === action.portfolioId);
      if (portfolioIndex !== -1) {
        const portfolioDetails = portfolios[portfolioIndex];
        const reportPreferences = portfolioDetails.reportPreference;
        const indexForSelectedReportPreference = reportPreferences.findIndex(
          preference => preference.reportType === action.reportType
        );
        if (indexForSelectedReportPreference !== -1) {
          reportPreferences[indexForSelectedReportPreference] = action.reportPreference;
        } else {
          reportPreferences.push(action.reportPreference);
        }
        portfolios[portfolioIndex].reportPreference = [...reportPreferences];
      }
      newState.portfolios = portfolios;
      return newState;
    }

    case ADD_DIY_CHART + suffix: {
      const newState = { ...state };
      const portfolios = newState.portfolios;
      const portfolioIndex = (portfolios || []).findIndex(portfolio => portfolio.id === action.portfolioId);
      if (portfolioIndex !== -1) {
        const portfolioDetails = portfolios[portfolioIndex];
        const updateDiyChartsData = { portfolioId: action.portfolioId, data: action.updatedDiyChartForPortfolio };
        portfolioDetails.diyChart = updateDiyChartsData;
      }
      newState.portfolios = portfolios;
      return newState;
    }

    case DELETE_DIY_CHART + suffix: {
      const newState = { ...state };
      return newState;
    }
    case GET_FUND_SCHEDULE_DATA_SUCCESS + suffix: {
      const newState = { ...state };
      newState.portfolioFundScheduleMap[action.portfolioId] = action.fundSchedule;
      return newState;
    }
    case REHYDRATE_RECAP + suffix: {
      // Live data wins: hydration only fills portfolios and time ranges the
      // store doesn't already hold, so it can never overwrite recap data
      // fetched after the boot gate released.
      const recapDataPortfolioMap = { ...state.recapDataPortfolioMap };
      for (const [portfolioId, hydratedEntry] of Object.entries(action.payload || {})) {
        const existingEntry = recapDataPortfolioMap[portfolioId];
        recapDataPortfolioMap[portfolioId] = existingEntry
          ? { ...existingEntry, data: { ...hydratedEntry?.data, ...existingEntry.data } }
          : hydratedEntry;
      }
      return {
        ...state,
        recapDataPortfolioMap,
        recapDataPortfolioMapUpdateTimestamp: Date.now()
      };
    }
    case FETCH_PERCENTAGE_ALLOCATION_DATA_PENDING:
      return {
        ...state,
        fetchingPercentageAllocationData: action.showLoader
      };
    case FETCH_PERCENTAGE_ALLOCATION_DATA_SUCCESS:
      return {
        ...state
      };

    case UPDATE_RECAP_RAW_DATA_ACTION:
      return {
        ...state,
        recapRawData: action.updatedRecapRawData
      };
    default:
      return state;

    // make sure to add newPortfolioActions to portfolioActions array in Common.js to make sure subuser suffix logic works correctly
  }
}

export const copyParentInfoToChild = (parent, child) => {
  if (!parent === true || !child === true) {
    return;
  }

  child.linkType = parent.linkType;
  child.tsLastTransaction = parent.tsLastTransaction;
  child.tsLastUpdateCheck = parent.tsLastUpdateCheck;
  child.status = parent.status;
  child.statusInfo = parent.statusInfo;
  child.linkProviderAccountId = parent.linkProviderAccountId;
  child.linkProviderId = parent.linkProviderId;
  child.linkAccountId = parent.linkAccountId;
  child.linkProviderName = parent.linkProviderName;
  child.linkContainer = parent.linkContainer;
  child.linkAccountName = parent.linkAccountName;
  child.linkAccountMask = parent.linkAccountMask;
  child.parentOrigin = parent.origin;
  child.linkAccountTsCreated = parent.linkAccountTsCreated;
  child.ownership = parent.ownership;
  child.holdingSubType = child.holdingSubType ? child.holdingSubType : child.subType;
  child.subType =
    child.subType === custodianSubTypes.CASH || child.subType === holdingSubTypes.AGGREGATED_HOLDING
      ? child.subType
      : parent.subType;
};

export const copyLinkingInfoFromParentCustodian = (portfoliosState, parentId, child) => {
  if (!parentId === true || !child === true) {
    return;
  }

  const parent = findCustodianInPortfolios(portfoliosState, parentId);
  if (!parent === true) {
    return;
  }

  copyParentInfoToChild(parent, child);
};

export const initialFetchSuccessSelector = state => portfoliosStateSelector(state).initialFetchSuccess;

export const sectionsUpdatedSelector = state => portfoliosStateSelector(state).sectionsUpdated;

export const refreshCustodianTimeSelector = state => portfoliosStateSelector(state).refreshCustodoanTime;

export const connectedLinkTypeSelector = state => portfoliosStateSelector(state).connectedLinkType;

export const fetchPortfolioPendingSelector = state => portfoliosStateSelector(state).fetchPortfolioPending;

export const fetchHoldingsPendingSelector = state => portfoliosStateSelector(state).fetchHoldingsPending;

export const allConnectedCustodiansRefreshPendingSelector = state =>
  portfoliosStateSelector(state).allConnectedCustodiansRefreshPending;

export const fetchPortfolioChangeDataSuccessSelector = state =>
  portfoliosStateSelector(state).fetchPortfolioChangeDataSuccess;

export const fetchPortfolioErrorSelector = state => portfoliosStateSelector(state).fetchPortfolioError;

export const lastDashboardUpdateTsSelector = state => portfoliosStateSelector(state).lastDashboardUpdateTs;

export const dashboardEntitesToUpdateSelector = state => portfoliosStateSelector(state).dashboardEntitesToUpdate;

export const portfoliosNameSelector = state =>
  portfoliosStateSelector(state).portfolios.map(portfolio => portfolio.name);

export const sortPreferenceSelector = state => portfoliosStateSelector(state).sortPreference;

export const currentPortfolioCustodiansUpdatedTimestampSelector = state =>
  portfoliosStateSelector(state).currentPortfolioCustodiansUpdatedTimestamp;

export const recapDataPortfolioMapUpdateTimestampSelector = state =>
  portfoliosStateSelector(state).recapDataPortfolioMapUpdateTimestamp;

export const showRecapPage = state => {
  const recapData = recapDataSelector(state);
  const networthReportTotalsData =
    recapData &&
    recapData.data &&
    recapData.data[chartTimeRange.TODAY] &&
    recapData.data[chartTimeRange.TODAY][recapChartOptions.NETWORTH.id] &&
    recapData.data[chartTimeRange.TODAY][recapChartOptions.NETWORTH.id][recapChartTypes.TOTALS];
  let recapCustodians = [];
  if (networthReportTotalsData && networthReportTotalsData.Assets) {
    recapCustodians.push(networthReportTotalsData.Assets);
  }
  if (networthReportTotalsData && networthReportTotalsData.Debts) {
    recapCustodians.push(networthReportTotalsData.Debts);
  }
  recapCustodians = recapCustodians.flat().filter(custodian => custodian.type !== "header" && !custodian.isArchived);
  return recapCustodians.length >= 5;
};

export const shouldShowLoaderOnPortfolioAndNeworthCurrencyMismatch = state => {
  const currentPortfolioCurrency = currentPortfolioCurrencySelector(state);
  const netWorthData = currentPortfolioNetWorthDataSelector(state);
  const netWorthDataCurrency = netWorthData && netWorthData.data && netWorthData.data.netWorthDataCurrency;
  return currentPortfolioCurrency !== netWorthDataCurrency;
};

export const shouldShowLoaderOnPortfolioAndRecapCurrencyMismatch = state => {
  const currentPortfolioCurrency = currentPortfolioCurrencySelector(state);
  const recapCurrency = recapDataCurrencySelector(state);
  return !!recapCurrency && currentPortfolioCurrency !== recapCurrency;
};

export const recapReportDescriptionSelector = (
  state,
  reportId,
  isInvestableAssetsBySheetsAndSectionsChart,
  isInvestableAssetsBySectionsChart
) => {
  if (!reportId === true) {
    return null;
  }

  const recapNode = recapReportNodeSelector(
    state,
    reportId,
    true,
    null,
    isInvestableAssetsBySheetsAndSectionsChart,
    isInvestableAssetsBySectionsChart
  );
  const recapCurrency = recapDataCurrencySelector(state);
  const portfolioCurrency = currentPortfolioCurrencySelector(state);
  return recapNode && recapNode.isUsFund
    ? `${recapNode.percentage}% of ${shortFormatNumberWithCurrency(
        state,
        convertCurrency(state, recapNode.totalValue, recapCurrency, portfolioCurrency),
        portfolioCurrency,
        true,
        true
      )}`
    : null;
};

export const recapDataCashOnHandTotalSelector = state => {
  const recapData = recapDataSelector(state);
  const recapDataCurrency = recapDataCurrencySelector(state);
  const portfolioCurrency = currentPortfolioCurrencySelector(state);
  const cashOnHandValue =
    recapData?.data?.[chartTimeRange.TODAY]?.[recapChartOptions.CASH_ON_HAND.id]?.totals?.["Cash on hand"]?.[0]
      ?.values[0]?.value;
  return convertCurrency(state, cashOnHandValue, recapDataCurrency, portfolioCurrency);
};

export const recapDataCashOnHandCustodiansSelector = createSelector(
  [
    state => recapDataSelector(state),
    state => {
      const recapData = recapDataSelector(state);
      const cashOnHandReportData =
        recapData?.data?.[chartTimeRange.TODAY]?.[recapChartOptions.CASH_ON_HAND.id]?.totals?.["Cash on hand"];
      return cashOnHandReportData;
    }
  ],
  (_, cashOnHandReportData) => {
    return (
      cashOnHandReportData &&
      cashOnHandReportData
        .filter(data => (data.type === "header" ? false : true))
        .map(data => {
          return {
            name: data.name,
            id: data.id,
            value: data.values[0].value
          };
        })
    );
  }
);

export const recapDataTaxOnUnrealisedGainsSelector = state => {
  const recapData = recapDataSelector(state);
  return recapData && recapData.data && recapData.data.taxOnUnrealisedGainsList;
};

export const recapDataCustodiansWithCommitedCapitalSelector = state => {
  const recapData = recapDataSelector(state);
  return recapData && recapData.data && recapData.data.unfundedCustodiansList;
};

export const recapReportValueSelector = (
  state,
  reportId,
  isInvestableAssetsBySheetsAndSectionsChart,
  isInvestableAssetsBySectionsChart,
  isInvestableAssetsWithoutCashBySheetsAndSectionsChart,
  isInvestableAssetsWithoutCashBySectionsChart
) => {
  if (!reportId === true) {
    return null;
  }

  const recapNode = recapReportNodeSelector(
    state,
    reportId,
    true,
    chartTimeRange.TODAY,
    isInvestableAssetsBySheetsAndSectionsChart,
    isInvestableAssetsBySectionsChart,
    isInvestableAssetsWithoutCashBySheetsAndSectionsChart,
    isInvestableAssetsWithoutCashBySectionsChart
  );
  return recapNode && recapNode.values[0] && recapNode.values[0].value;
};

export const recapReportLineChartDataSelector = createStateAccessSelector(
  [
    state => state,
    recapDataSelector,
    state => getNetWorthChartStartDateForPortfolio(state),
    recapDataCurrencySelector,
    (...args) => args[1]
  ],
  (state, _, portfolioStartDate, recapCurrency, reportId) => {
    if (!reportId === true) {
      return null;
    }

    try {
      const reportParams = parseParams(decodeURIComponent(reportId));
      const dailyData = { ...recapReportNodeSelector(state, reportId, true, chartTimeRange.DAILY) };
      const weeklyData = { ...recapReportNodeSelector(state, reportId, true, chartTimeRange.WEEKLY) };
      const monthlyData = { ...recapReportNodeSelector(state, reportId, true, chartTimeRange.MONTHLY) };
      const yearlyData = { ...recapReportNodeSelector(state, reportId, true, chartTimeRange.YEARLY) };
      dailyData.currency = recapCurrency;
      weeklyData.currency = recapCurrency;
      monthlyData.currency = recapCurrency;
      yearlyData.currency = recapCurrency;

      dailyData.data = [...dailyData.values].reverse();
      delete dailyData.values;

      weeklyData.data = [...weeklyData.values].reverse();
      delete weeklyData.values;

      monthlyData.data = [...monthlyData.values].reverse();
      delete monthlyData.values;

      yearlyData.data = [...yearlyData.values].reverse();
      delete yearlyData.values;

      var chartRawData = { chart: {} };
      chartRawData.chart[chartTimeRangeGroups.GROUP_BY_DAY] = dailyData;
      chartRawData.chart[chartTimeRangeGroups.GROUP_BY_WEEK] = weeklyData;
      chartRawData.chart[chartTimeRangeGroups.GROUP_BY_MONTH] = monthlyData;
      chartRawData.chart[chartTimeRangeGroups.GROUP_BY_YEAR] = yearlyData;

      let chartData = chartRawData;
      chartData.chart = getChartDataFromResponse(state, chartData.chart, "data", false, false, portfolioStartDate);

      if (!chartData === false) {
        for (const chartDuration in chartData.chart) {
          if (chartDuration === chartTimeRange.LAST_YEAR_END || !chartData.chart[chartDuration] === true) {
            continue;
          }

          const chartDataArray =
            chartData.chart[chartDuration].data &&
            chartData.chart[chartDuration].data
              .map(dataPoint => {
                //dataPoint.value = Math.kuberaFloor(dataPoint.value);
                return dataPoint;
              })
              .filter(dataPoint => {
                return getDateInKuberaFormat(state, dataPoint.date).getTime() >= portfolioStartDate.getTime();
              });
          chartData.chart[chartDuration].data = chartDataArray.slice(
            chartDataArray.findIndex(data => data.value !== 0)
          );
        }
      }
      chartData = filterChartDataBasedOnPortfolioStartDate(chartData);
      const ytdData = { ...recapReportNodeSelector(state, reportId, true, "lastYearEnd") };
      const ytdDataPoint = { value: ytdData?.values?.[0]?.value, date: ytdData?.values?.[0]?.date };
      const ytdCustodianChartData = getYTDCustodianChartData(state, chartData, ytdDataPoint, portfolioStartDate);
      chartData.chart[chartTimeRange.YTD] = ytdCustodianChartData;
      const reportName = recapReportNameSelector(state, reportId);
      chartData.title = getLineChartTitleSelector(
        state,
        reportParams.chart_option,
        reportParams.report_path,
        reportName,
        reportId
      );
      return chartData;
    } catch (e) {
      return null;
    }
  }
);

export const recapReportContentsDoughnutDataSelectorMemoized = memoize(
  (
    reportId,
    isInvestableAssetsBySheetsAndSectionsChart,
    isInvestableAssetsBySectionsChart,
    isInvestableAssetsWithoutCashBySheetsAndSectionsChart,
    isInvestableAssetsWithoutCashBySectionsChart,
    isAssetsBySectionsChart
  ) =>
    createSelector(
      [
        (state, reportContents) => {
          if (reportContents) return reportContents;
          return recapReportContentsDataSelector(
            state,
            reportId,
            isInvestableAssetsBySheetsAndSectionsChart,
            isInvestableAssetsBySectionsChart,
            isInvestableAssetsWithoutCashBySheetsAndSectionsChart,
            isInvestableAssetsWithoutCashBySectionsChart,
            isAssetsBySectionsChart
          );
        },
        reportPreferencesSelector
      ],
      (reportContents, _) => {
        if (!reportId === true) {
          return null;
        }
        if (!reportContents === true) {
          return null;
        }
        return getDoughnutData(
          reportContents.name,
          reportContents.total,
          reportContents.contents.filter(item => item && item.value > 0).map(item => item.name),
          reportContents.contents.filter(item => item && item.value > 0).map(item => item.value),
          reportContents.currency,
          undefined,
          2
        );
      }
    ),
  (
    reportId,
    isInvestableAssetsBySheetsAndSectionsChart,
    isInvestableAssetsBySectionsChart,
    isInvestableAssetsWithoutCashBySheetsAndSectionsChart,
    isInvestableAssetsWithoutCashBySectionsChart,
    isAssetsBySectionsChart
  ) =>
    "" +
    reportId +
    isInvestableAssetsBySheetsAndSectionsChart +
    isInvestableAssetsBySectionsChart +
    isInvestableAssetsWithoutCashBySheetsAndSectionsChart +
    isInvestableAssetsWithoutCashBySectionsChart +
    isAssetsBySectionsChart
);

export const recapReportContentsDoughnutDataSelector = (
  state,
  reportId,
  reportContents = null,
  isInvestableAssetsBySheetsAndSectionsChart,
  isInvestableAssetsBySectionsChart,
  isInvestableAssetsWithoutCashBySheetsAndSectionsChart,
  isInvestableAssetsWithoutCashBySectionsChart,
  isAssetsBySectionsChart
) =>
  recapReportContentsDoughnutDataSelectorMemoized(
    reportId,
    isInvestableAssetsBySheetsAndSectionsChart,
    isInvestableAssetsBySectionsChart,
    isInvestableAssetsWithoutCashBySheetsAndSectionsChart,
    isInvestableAssetsWithoutCashBySectionsChart,
    isAssetsBySectionsChart
  )(state, reportContents);

export const recapReportComparisonDoughnutDataSelectorMemoized = memoize(
  (
    reportId,
    shouldCompareWithInvestableAsset,
    shouldCompareWithTotalAssetsOrDebts,
    shouldCompareWithSheet,
    shouldCompareAgainstInvestableAssetsWithOutCash
  ) => {
    return createSelector(
      [
        (state, reportContents) => {
          if (reportContents) return reportContents;
          return recapReportComparisonDataSelector(
            state,
            reportId,
            shouldCompareWithInvestableAsset,
            shouldCompareWithTotalAssetsOrDebts,
            shouldCompareWithSheet,
            shouldCompareAgainstInvestableAssetsWithOutCash
          );
        },
        reportPreferencesSelector
      ],
      reportContents => {
        if (!reportId === true) {
          return null;
        }
        if (!reportContents === true) {
          return null;
        }
        const doughnutData = getDoughnutData(
          reportContents.name,
          reportContents.total,
          reportContents.contents.filter(item => item.value > 0).map(item => item.name),
          reportContents.contents.filter(item => item.value > 0).map(item => item.value),
          reportContents.currency,
          undefined,
          2
        );
        doughnutData.value = reportContents.value;
        return doughnutData;
      }
    );
  },
  (
    reportId,
    shouldCompareAgainstInvestableAssets,
    shouldCompareAgainstTotalAssetsOrDebts,
    shouldCompareAgainstSheet,
    shouldCompareAgainstInvestableAssetsWithOutCash
  ) =>
    "" +
    reportId +
    shouldCompareAgainstInvestableAssets +
    shouldCompareAgainstTotalAssetsOrDebts +
    shouldCompareAgainstSheet +
    shouldCompareAgainstInvestableAssetsWithOutCash
);

export const recapReportComparisonDoughnutDataSelector = (
  state,
  reportId,
  reportContents,
  shouldCompareWithInvestableAsset,
  shouldCompareWithTotalAssetsOrDebts,
  shouldCompareWithSheet,
  shouldCompareWithInvestableAssetsWithOutCash
) =>
  recapReportComparisonDoughnutDataSelectorMemoized(
    reportId,
    shouldCompareWithInvestableAsset,
    shouldCompareWithTotalAssetsOrDebts,
    shouldCompareWithSheet,
    shouldCompareWithInvestableAssetsWithOutCash
  )(state, reportContents);

export const showRefreshingSelector = state => {
  const portfoliosState = portfoliosStateSelector(state);
  const showRefreshing = portfoliosState.isRefreshing || portfoliosState.fetchPortfolioPending;

  if (isMobile()) {
    return showRefreshing;
  } else {
    const lastPortfoliosFetchAge = new Date().getTime() - portfoliosState.lastPortfoliosFetchTs;
    return showRefreshing && lastPortfoliosFetchAge > 7 * 24 * 60 * 60 * 1000;
  }
};

export const pageReloadingSelector = state => portfoliosStateSelector(state).isPageReloading;

export const currentThemeMode = state => {
  try {
    const userPreferences = userPreferencesSelector(state);

    return (
      userPreferences[`currentThemeMode${THEME_SUFFIX_STR}`] ||
      localStorage.getItem(`theme${THEME_SUFFIX_STR}`) ||
      "default"
    );
  } catch (e) {
    return "default";
  }
};

export const currentLockModeSelector = state => {
  try {
    const userPreferences = userPreferencesSelector(state);

    return userPreferences[LOCK_PREFERENCE_STR] || localStorage.getItem(LOCK_PREFERENCE_STR) || "default";
  } catch (e) {
    return "default";
  }
};

export const currentSlideDirectionSelector = state => portfoliosStateSelector(state).slideDirection;

export const portfolioLastForceUpdateTsSelector = (state, portfolioId) => {
  const lastRefreshTs = portfoliosStateSelector(state).portfolioLastForceRefreshTsMap[portfolioId];
  if (!lastRefreshTs === true) {
    return 0;
  }
  return lastRefreshTs;
};

export const portfolioChangeDataLastForceUpdateTsSelector = (state, portfolioId) => {
  const lastRefreshTs = portfoliosStateSelector(state).portfolioChangeDataLastForceRefreshTsMap[portfolioId];
  if (!lastRefreshTs === true) {
    return 0;
  }
  return lastRefreshTs;
};

export const portfolioSelector = createSelector(
  [portfoliosSelector, (_, portfolioId) => portfolioId],
  (portfolios, portfolioId) => {
    if (portfolios === null) {
      return null;
    }
    const currentPortfolioIndex = (portfolios || []).findIndex(portfolio => {
      return portfolio.id === portfolioId;
    });
    return currentPortfolioIndex === -1 ? null : portfolios[currentPortfolioIndex];
  }
);

export const hasValidPortfolio = portfolio => {
  const { details } = portfolio || { details: null };

  if (!details || !details.custodian) {
    return false;
  }

  let foundData = false;

  for (let i = 0; i < details.custodian.length; i++) {
    if (details.custodian[i].value) {
      foundData = true;
      break;
    }
  }

  return foundData;
};

export const hasValidPortfolioSelector = state => {
  return hasValidPortfolio(currentPortfolioSelector(state));
};

export const custodianUsingIdSelector = custodianId => {
  return state => {
    const portfoliosState = portfoliosStateSelector(state);
    return findCustodianInPortfolios(portfoliosState, custodianId);
  };
};

const custodiansWithSameParentIdSelectorMemoized = memoize(
  (portfolioId, parentId) => {
    return createSelector(
      [
        state => state,
        state => currentPortfolioCustodiansUpdatedTimestampSelector(state),
        state => (!parentId === true ? null : portfolioSelector(state, portfolioId))
      ],
      (_, _1, portfolio) => {
        if (!parentId === true) {
          return [];
        }
        return portfolio.details.custodian.filter(custodian => custodian.parentId === parentId);
      }
    );
  },
  (portfolioId, parentId) => `${portfolioId}-${parentId}`
);

export const custodiansWithSameParentIdSelector = (state, portfolioId, parentId) =>
  custodiansWithSameParentIdSelectorMemoized(portfolioId, parentId)(state);

export const sectionSelector = (state, sectionId) => {
  const portfoliosState = portfoliosStateSelector(state);
  if (portfoliosState.portfolios === null) {
    return null;
  }
  return portfolioSectionsMapSelector(portfoliosState).sectionsMap.get(sectionId) || null;
};

export const sectionPortfolioSelector = (state, sectionId) => {
  const portfoliosState = portfoliosStateSelector(state);
  if (portfoliosState.portfolios === null) {
    return null;
  }
  return portfolioSectionsMapSelector(portfoliosState).portfolioSectionIdMap.get(sectionId);
};

export const sheetPortfolioSelector = (state, sheetId) => {
  const portfoliosState = portfoliosStateSelector(state);
  if (portfoliosState.portfolios === null) {
    return null;
  }
  return portfolioSheetsMapSelector(portfoliosState).portfolioSheetIdMap.get(sheetId);
};

export const sectionIndexSelector = (state, sectionId, sheetId) => {
  const portfolios = portfoliosStateSelector(state).portfolios;
  if (portfolios === null) {
    return null;
  }

  for (const portfolio of portfolios) {
    const filteredSection = portfolio.details.section
      .filter(section => section.sheetId === sheetId)
      .filter(section => {
        const rows = portfolio.details.custodian.filter(row => row.sectionId === section.id && row.tsModified);
        if (rows.length) {
          return true;
        }
        return false;
      });

    const index = filteredSection.findIndex(section => section.id === sectionId);
    if (index !== -1) {
      return index;
    }
  }
  return null;
};

export const sectionCustodiansSelector = (
  state,
  portfolioId,
  sectionId,
  includeAssociatedItems = false,
  onlyVisible = false
) => {
  const portfolio = portfolioSelector(state, portfolioId);
  if (!portfolio) return [];
  var custodians = portfolio.details.custodian.filter(custodian => custodian.sectionId === sectionId);

  if (includeAssociatedItems === true) {
    const associatedCustodians = sectionAssociatedCustodiansSelector(state, portfolioId, sectionId);
    custodians.push(...associatedCustodians);
  }
  custodians = [...new Set(custodians)];
  if (onlyVisible === true) {
    custodians = custodians.filter(item => item.hidden !== 1);
  }
  return custodians;
};

export const sectionAssociatedCustodiansSelector = (state, portfolioId, sectionId) => {
  var associatedCustodians = [];

  const sectionCustodians = sectionCustodiansSelector(state, portfolioId, sectionId);
  for (const custodian of sectionCustodians) {
    if (custodian.linkType === accountLinkingService.KUBERA_PORTFOLIO) {
      associatedCustodians = associatedCustodians.concat(
        custodiansLinkedToSameAccountSelector(state, custodian.id).portfolioCustodiansMap[portfolioId].filter(
          item => item.id !== custodian.id
        )
      );
    } else if (!custodian.parentId === false && custodian.hidden === 0) {
      const siblings = custodiansWithSameParentIdSelector(state, portfolioId, custodian.parentId);

      for (const sibling of siblings) {
        if (associatedCustodians.findIndex(item => item.id === sibling.id) === -1) {
          associatedCustodians.push(sibling);
        }
      }

      const parent = custodianSelector(state, custodian.parentId);
      if (parent && associatedCustodians.findIndex(item => item.id === parent.id) === -1) {
        associatedCustodians.push(parent);
      }
    }
  }
  return associatedCustodians;
};

export const sheetSectionsSelector = (state, portfolioId, sheetId) => {
  const portfolio = portfolioSelector(state, portfolioId);
  return portfolio.details.section.filter(section => section.sheetId === sheetId);
};

export const isSheetEmpty = (state, portfolioId, sheetId) => {
  const custodians = sheetCustodiansSelector(state, portfolioId, sheetId, false, true);
  return custodians.filter(item => isCustodianEmpty(item) === false).length === 0;
};

export const sheetCustodiansSelector = (
  state,
  portfolioId,
  sheetId,
  includeAssociatedItems = false,
  onlyVisible = false
) => {
  var custodians = [];

  const sections = sheetSectionsSelector(state, portfolioId, sheetId);
  for (const section of sections) {
    custodians.push(...sectionCustodiansSelector(state, portfolioId, section.id, includeAssociatedItems, onlyVisible));
  }
  custodians = [...new Set(custodians)];
  return custodians;
};

export const sheetAssociatedCustodiansSelector = (state, portfolioId, sheetId) => {
  var associatedCustodians = [];

  const sections = sheetSectionsSelector(state, portfolioId, sheetId);
  for (const section of sections) {
    const sectionAssociatedCustodians = sectionAssociatedCustodiansSelector(state, portfolioId, section.id);
    for (const custodian of sectionAssociatedCustodians) {
      if (associatedCustodians.findIndex(item => item.id === custodian.id) === -1) {
        associatedCustodians.push(custodian);
      }
    }
  }
  return associatedCustodians;
};

export const custodianPortfolioSelector = (state, custodianId) => {
  const portfolio = findPortfolioUsingCustodianIdSelector(state, custodianId);
  if (portfolio) return portfolio;
  return null;
};

export const custodianSectionSelector = (state, custodianId) => {
  const custodian = custodianSelector(state, custodianId);
  if (!custodian === true) {
    return null;
  }
  return sectionSelector(state, custodian.sectionId);
};

export const sheetSelector = (state, sheetId) => {
  const portfoliosState = portfoliosStateSelector(state);
  if (portfoliosState.portfolios === null || !sheetId === true) {
    return null;
  }
  return portfolioSheetsMapSelector(portfoliosState).sheetsMap.get(sheetId) || null;
};

export const custodianCategorySelector = (state, custodianId) => {
  const custodian = custodianSelector(state, custodianId);
  if (!custodian === true) {
    return null;
  }
  const section = custodianSectionSelector(
    state,
    !custodian.parentId === false && custodian.hidden === 1 ? custodian.parentId : custodian.id
  );
  if (!section === true) {
    return null;
  }
  return sheetSelector(state, section.sheetId)?.category || null;
};

export const sheetCategorySelector = (state, sheetId) => sheetSelector(state, sheetId)?.category ?? null;

export const sectionCategorySelector = (state, sectionId) =>
  sheetCategorySelector(state, sectionSelector(state, sectionId)?.sheetId);

export const sheetIndexSelector = (state, sheetId, category) => {
  const portfolios = portfoliosStateSelector(state).portfolios;
  if (portfolios === null) {
    return null;
  }

  for (const portfolio of portfolios) {
    const filteredSheets = portfolio.details.sheet
      .filter(sheet => sheet.category === category)
      .filter(sheet => {
        const sections = portfolio.details.section
          .filter(section => section.sheetId === sheet.id)
          .filter(section => {
            const rows = portfolio.details.custodian.filter(row => row.sectionId === section.id && row.tsModified);
            if (rows.length) {
              const isRowValuesZero = rows.every(row => row.value === 0);
              return !isRowValuesZero;
            }
            return false;
          });
        if (sections.length) {
          return true;
        }
        return false;
      });
    const index = filteredSheets.findIndex(sheet => sheet.id === sheetId);
    if (index !== -1) {
      return index;
    }
  }
  return null;
};

export const rowIndexSelector = (state, sectionId, rowId) => {
  const portfolios = portfoliosStateSelector(state).portfolios;
  if (portfolios === null) {
    return null;
  }

  for (const portfolio of portfolios) {
    const filteredRows = portfolio.details.custodian.filter(row => row.sectionId === sectionId && row.tsModified);
    const index = filteredRows.findIndex(row => row.id === rowId);
    if (index !== -1) {
      return index;
    }
  }
  return null;
};

export const sheetNameSelector = (state, portfolioId, sheetName) => {
  const portfolio = portfolioSelector(state, portfolioId);

  const sheet = portfolio.details.sheet.find(sheet => sheet.name === sheetName);
  if (sheet) {
    return sheet;
  }
  return null;
};

const ifNewDoc = (doc, list) => {
  if (list.includes(doc.id)) {
    return false;
  }

  list.push(doc.id);
  return true;
};

const computePortfolioDocuments = createSelector(
  [state => state, (_, portfolio) => portfolio],
  (state, portfolio) => {
    if (!portfolio) {
      return null;
    }
    const docIdsAdded = [];
    const portfolioDocuments = portfolio.details.document || [];

    const folderOrCustodianIdsCount = portfolioDocuments.reduce((result, document) => {
      const id = document.custodianId || document.folderId;

      if (!id) {
        return result;
      }

      result[id] = id in result ? result[id] + 1 : 1;

      return result;
    }, {});

    const mappedCustodiansToFolderIds = [];
    const mappedFolders = portfolioDocuments.map(doc => {
      if (doc.fileType === "folder") {
        return {
          ...doc,
          filesCount: folderOrCustodianIdsCount[doc.id]
        };
      }

      if (doc.custodianId !== null && !mappedCustodiansToFolderIds.includes(doc.custodianId)) {
        mappedCustodiansToFolderIds.push(doc.custodianId);
        const custodian = custodianSelector(state, doc.custodianId);

        if (!custodian) {
          return doc;
        }

        const targetSheet = custodianSheetSelector(state, custodian.id);

        return {
          ...doc,
          custodianId: null,
          fileType: "custodian",
          folderId: null,
          id: doc.custodianId,
          size: 0,
          thumbnailToken: null,
          name: custodian.name,
          custodian,
          category: targetSheet && targetSheet.category,
          filesCount: folderOrCustodianIdsCount[doc.custodianId]
        };
      }

      return doc;
    });
    const uploadedDocuments =
      !mappedFolders === true
        ? []
        : mappedFolders.filter(doc => doc.custodianId === null && doc.folderId === null && ifNewDoc(doc, docIdsAdded));
    const pendingDocuments = (state.sync.pendingDocumentUploads || []).filter(
      doc =>
        doc.portfolioId === portfolio.id &&
        doc.custodianId === null &&
        doc.folderId === null &&
        ifNewDoc(doc, docIdsAdded)
    );
    return [...uploadedDocuments, ...pendingDocuments];
  }
);

export const currentPortfolioDocumentsSelector = createSelector(
  [state => state],
  state => {
    const portfolios = portfoliosStateSelector(state).portfolios;
    if (portfolios === null) {
      return null;
    }
    return computePortfolioDocuments(state, currentPortfolioSelector(state));
  }
);

export const portfolioDocumentsSelector = (state, portfolioId) => {
  const portfolios = portfoliosStateSelector(state).portfolios;
  if (portfolios === null) {
    return null;
  }
  return computePortfolioDocuments(state, portfolioSelector(state, portfolioId));
};

export const folderPortfolioDocumentsSelector = (folderId, portfolioId = null) => state => {
  if (!folderId) {
    return null;
  }
  const portfolios = portfoliosStateSelector(state).portfolios;
  if (portfolios === null) {
    return null;
  }
  const portfolio = portfolioId ? portfolioSelector(state, portfolioId) : currentPortfolioSelector(state);
  if (!portfolio) {
    return null;
  }
  const docIdsAdded = [];
  const uploadedDocuments =
    !portfolio.details.document === true
      ? []
      : portfolio.details.document.filter(doc => doc.folderId === folderId && ifNewDoc(doc, docIdsAdded));
  const pendingDocuments = (state.sync.pendingDocumentUploads || []).filter(
    doc => doc.portfolioId === portfolio.id && doc.folderId === folderId && ifNewDoc(doc, docIdsAdded)
  );
  return [...uploadedDocuments, ...pendingDocuments];
};

export const currentPortfolioDocumentsCountSelector = state => {
  const documents = currentPortfolioDocumentsSelector(state);
  return !documents === true ? 0 : documents.length;
};

export const custodianDocumentsSelector = (state, custodianId) => {
  const portfolios = portfoliosStateSelector(state).portfolios;
  if (portfolios === null) {
    return null;
  }
  const currentPortfolio = custodianPortfolioSelector(state, custodianId) || currentPortfolioSelector(state);
  if (!currentPortfolio) {
    return null;
  }

  const docIdsAdded = [];
  const uploadedDocuments =
    !currentPortfolio.details.document === false
      ? currentPortfolio.details.document.filter(doc => doc.custodianId === custodianId && ifNewDoc(doc, docIdsAdded))
      : [];
  const pendingDocuments = state.sync.pendingDocumentUploads
    ? state.sync.pendingDocumentUploads.filter(doc => doc.custodianId === custodianId && ifNewDoc(doc, docIdsAdded))
    : [];

  const custodian = custodianSelector(state, custodianId);
  var parentCustodianDocuments = [];
  if (custodian && !custodian.parentId === false && isManualConnectedHolding(state, custodian) === false) {
    parentCustodianDocuments =
      !currentPortfolio.details.document === false
        ? currentPortfolio.details.document.filter(doc => doc.custodianId === custodian.parentId)
        : [];
  }
  return [...uploadedDocuments, ...parentCustodianDocuments, ...pendingDocuments];
};

export const hasUserLinkedAnyAccounts = createSelector(
  [portfoliosSelector],
  portfolios => {
    if (!portfolios === false) {
      for (const portfolio of portfolios) {
        for (const custodian of portfolio.details.custodian) {
          if (!custodian.linkType === false || custodian.isLinking === true) {
            return true;
          }
        }
      }
    }
    return false;
  }
);

export const hasUserMadeAnyManualEntries = createSelector(
  [portfoliosSelector],
  portfolios => {
    if (!portfolios === false) {
      for (const portfolio of portfolios) {
        for (const custodian of portfolio.details.custodian) {
          if (
            !custodian.linkType === true &&
            (!custodian.tsModified === false || !custodian.isLocallyEdited === false)
          ) {
            return true;
          }
        }
      }
    }
    return false;
  }
);

export const uniqueProviderIdsLinkedSelector = createSelector(
  [portfoliosSelector],
  portfolios => {
    var uniqueProviderIds = [];
    if (!portfolios === false) {
      for (const portfolio of portfolios) {
        for (const custodian of portfolio.details.custodian) {
          if (!custodian.linkProviderId === false && uniqueProviderIds.includes(custodian.linkProviderId) === false) {
            uniqueProviderIds.push(custodian.linkProviderId);
          }
        }
      }
    }
    return uniqueProviderIds;
  }
);

const verifiedConnectionKey = (linkType, providerAccountId) => `${linkType}-${providerAccountId}`;

export const verifiedConnectionKeysSelector = (state, excludedCustodianIds = new Set()) => {
  const keys = new Set();
  for (const custodian of allPortfoliosCustodiansSelector(state)) {
    if (
      excludedCustodianIds.has(custodian.id) === false &&
      isVerifiedLinkingService(custodian.linkType) &&
      !custodian.linkProviderAccountId === false
    ) {
      keys.add(verifiedConnectionKey(custodian.linkType, custodian.linkProviderAccountId));
    }
  }
  return keys;
};

export const getCustodiansLinkedWithProviderAccountId = (state, providerAccountId, includeChildren = true) => {
  const custodians = allPortfoliosCustodiansSelector(state);
  var matchingCustodians = [];

  if (!custodians || !providerAccountId) {
    return matchingCustodians;
  }
  for (const custodian of custodians) {
    if (custodian.linkProviderAccountId === providerAccountId) {
      if (includeChildren === true || !custodian.parentId === true) {
        matchingCustodians.push(custodian);
      }
    }
  }
  return matchingCustodians;
};

export const isPortfolioEmpty = portfolio => {
  const assets = portfolioCustodiansSelector(undefined, portfolio, categoryType.ASSET, true);
  const debts = portfolioCustodiansSelector(undefined, portfolio, categoryType.DEBT, true);
  const insurance = portfolioCustodiansSelector(undefined, portfolio, categoryType.INSURANCE, true);

  return assets.length === 0 && debts.length === 0 && insurance.length === 0;
};

export const isCurrentPortfolioEmpty = state => {
  const currentPortfolio = currentPortfolioSelector(state);
  return isPortfolioEmpty(currentPortfolio);
};

export const currentPortfolioCustodiansCountSelector = (state, category, excludeEmpty = false) => {
  return currentPortfolioCustodiansSelector(state, category, excludeEmpty).length;
};

export const currentPortfolioCustodiansSelector = (state, category, excludeEmpty = false) => {
  const currentPortfolio = currentPortfolioSelector(state);
  return portfolioCustodiansSelector(state, currentPortfolio, category, excludeEmpty);
};

export const allPortfoliosCustodiansSelector = state => {
  const portfolios = portfoliosSelector(state);
  var custodians = [];

  if (!portfolios === true) {
    return custodians;
  }
  for (const portfolio of portfolios) {
    custodians.push(...portfolio.details.custodian);
  }
  return custodians;
};

const portfolioCustodiansSelectorMemoized = memoize(
  (category, excludeEmpty, onlyInvestable) =>
    createSelector(
      [
        (state, portfolio) => {
          if (!portfolio && state) {
            return currentPortfolioSelector(state);
          }
          return portfolio;
        },
        state => {
          if (state) {
            return currentPortfolioCustodiansUpdatedTimestampSelector(state);
          }
          return undefined;
        }
      ],
      (portfolio, _) => {
        const categorySheetIds = new Set();
        for (const sheet of portfolio.details.sheet) {
          if (sheet.category === category) {
            categorySheetIds.add(sheet.id);
          }
        }
        const categorySectionIds = new Set();
        for (const section of portfolio.details.section) {
          if (categorySheetIds.has(section.sheetId)) {
            categorySectionIds.add(section.id);
          }
        }
        var categoryCustodians = portfolio.details.custodian.filter(custodian =>
          categorySectionIds.has(custodian.sectionId)
        );
        if (excludeEmpty === true) {
          categoryCustodians = categoryCustodians.filter(custodian => isCustodianEmpty(custodian) === false);
        }
        if (onlyInvestable === true) {
          categoryCustodians = categoryCustodians.filter(custodian => custodian.type === 0 || custodian.type === 2);
        }
        return categoryCustodians;
      }
    ),
  (category, excludeEmpty, onlyInvestable) => "" + category + excludeEmpty + onlyInvestable
);

export const portfolioCustodiansSelector = (state = null, portfolio, category, excludeEmpty, onlyInvestable) =>
  portfolioCustodiansSelectorMemoized(category, excludeEmpty, onlyInvestable)(state, portfolio);

export const portfolioNetWorth = (state, portfolio) => {
  if (!portfolio) {
    portfolio = currentPortfolioSelector(state);
  }
  const portfolioTotalAssets = portfolioTotalForCategory(state, portfolio, categoryType.ASSET);
  const portfolioTotalDebts = portfolioTotalForCategory(state, portfolio, categoryType.DEBT);
  return portfolioTotalAssets - portfolioTotalDebts;
};

const OWNERSHIP_ROLLUP_TRUST_GROUP = "trust";
const OWNERSHIP_ROLLUP_PERSON_GROUP = "person";

const ownershipRollupKeyForGroup = (group, name) => {
  const key = (name ?? "").trim().toLowerCase();
  return key === "" ? "" : `${group}:${key}`;
};

export const ownershipRollupKeyForTag = tag =>
  ownershipRollupKeyForGroup(
    tag.type === "trust" ? OWNERSHIP_ROLLUP_TRUST_GROUP : OWNERSHIP_ROLLUP_PERSON_GROUP,
    tag.name
  );

const pushOwnershipContribution = (acc, key, category, contribution, custodian) => {
  if (!acc[key]) {
    acc[key] = { assets: [], debts: [], totalAssets: 0, totalDebts: 0, net: 0 };
  }
  if (category === categoryType.DEBT) {
    acc[key].debts.push({ id: custodian.id, name: custodian.name, value: contribution });
    acc[key].totalDebts += contribution;
    acc[key].net -= contribution;
  } else {
    acc[key].assets.push({ id: custodian.id, name: custodian.name, value: contribution });
    acc[key].totalAssets += contribution;
    acc[key].net += contribution;
  }
};

const collectOwnershipContributions = (state, portfolio, scaleToRootCurrency, acc, visited) => {
  if (!portfolio === true || visited.has(portfolio.id)) {
    return;
  }
  visited.add(portfolio.id);
  const tags = portfolio.details?.tag ?? [];
  const portfolioTicker = getTickerUsingShortName(state, portfolio.currency);
  const defaultPersonTag = findDefaultPersonTag(tags);
  const defaultPersonKey = !defaultPersonTag === true ? "" : ownershipRollupKeyForTag(defaultPersonTag);
  for (const category of [categoryType.ASSET, categoryType.DEBT]) {
    for (const custodian of portfolioCustodiansSelector(state, portfolio, category)) {
      if (custodian.hidden === 1) {
        continue;
      }
      if (custodian.linkType === accountLinkingService.KUBERA_PORTFOLIO) {
        const child = portfolioSelector(state, custodian.linkProviderAccountId);
        const childScale =
          scaleToRootCurrency *
          ((custodian.ownership ?? 100) / 100) *
          getExchangeRate(state, child?.currency, portfolio.currency);
        collectOwnershipContributions(state, child, childScale, acc, visited);
        continue;
      }
      const value = getCustodianValue(state, custodian, category, portfolioTicker) * scaleToRootCurrency;
      let assignedTotal = 0;
      let defaultPersonPct = 0;
      for (const assignment of resolveEffectiveTagAssignments(portfolio, custodian.id)) {
        const percentage = (assignment.percentage || 0) / 100;
        const tag = tags.find(item => item.id === assignment.tagId);
        if (!tag === true) {
          continue;
        }
        assignedTotal += percentage;
        if (tag.id === defaultPersonTag?.id) {
          defaultPersonPct += percentage;
          continue;
        }
        if (percentage === 0) {
          continue;
        }
        const key = ownershipRollupKeyForTag(tag);
        if (key !== "") {
          pushOwnershipContribution(acc, key, category, value * percentage, custodian);
        }
      }
      defaultPersonPct += Math.max(0, 1 - assignedTotal);
      if (defaultPersonPct > 0 && defaultPersonKey !== "") {
        pushOwnershipContribution(acc, defaultPersonKey, category, value * defaultPersonPct, custodian);
      }
    }
  }
};

const ownershipContributionsByName = (state, portfolio) => {
  const acc = {};
  const visitedPortfolioIds = new Set();
  collectOwnershipContributions(state, portfolio, 1, acc, visitedPortfolioIds);
  return { acc, visitedPortfolioIds };
};

const EMPTY_OWNERSHIP_BREAKDOWN = { assets: [], debts: [], totalAssets: 0, totalDebts: 0 };

export const ownershipBreakdownForRollupKeySelector = (state, rollupKey) => {
  const portfolio = currentPortfolioSelector(state);
  if (!portfolio === true || !rollupKey === true) {
    return EMPTY_OWNERSHIP_BREAKDOWN;
  }

  const { acc } = ownershipContributionsByName(state, portfolio);
  const bucket = acc[rollupKey];
  if (!bucket === true) {
    return EMPTY_OWNERSHIP_BREAKDOWN;
  }
  return {
    assets: bucket.assets,
    debts: bucket.debts,
    totalAssets: bucket.totalAssets,
    totalDebts: bucket.totalDebts
  };
};

export const ownershipBreakdownForTagSelector = (state, tagId) => {
  const portfolio = currentPortfolioSelector(state);
  if (!portfolio === true || !tagId === true) {
    return EMPTY_OWNERSHIP_BREAKDOWN;
  }

  const tag = (portfolio.details?.tag ?? []).find(item => item.id === tagId);
  if (!tag === true) {
    return EMPTY_OWNERSHIP_BREAKDOWN;
  }
  return ownershipBreakdownForRollupKeySelector(state, ownershipRollupKeyForTag(tag));
};

const EMPTY_INHERITED_OWNERSHIP_TAGS = [];

export const inheritedOwnershipTagsSelector = state => {
  const portfolio = currentPortfolioSelector(state);
  if (!portfolio === true) {
    return EMPTY_INHERITED_OWNERSHIP_TAGS;
  }

  const { acc, visitedPortfolioIds } = ownershipContributionsByName(state, portfolio);
  const localRollupKeys = new Set((portfolio.details?.tag ?? []).map(tag => ownershipRollupKeyForTag(tag)));
  const entries = [];
  const seenRollupKeys = new Set();

  for (const visitedPortfolioId of visitedPortfolioIds) {
    if (visitedPortfolioId === portfolio.id) {
      continue;
    }
    const linkedPortfolio = portfolioSelector(state, visitedPortfolioId);
    const linkedTags = linkedPortfolio?.details?.tag ?? [];
    for (const tag of linkedTags) {
      if (tag.type !== "person" && tag.type !== "trust") {
        continue;
      }
      const rollupKey = ownershipRollupKeyForTag(tag);
      if (rollupKey === "" || localRollupKeys.has(rollupKey) || seenRollupKeys.has(rollupKey)) {
        continue;
      }
      seenRollupKeys.add(rollupKey);
      entries.push({
        id: rollupKey,
        rollupKey,
        tagId: tag.id,
        portfolioId: visitedPortfolioId,
        type: tag.type,
        name: tag.name,
        description: tag.description,
        net: acc[rollupKey]?.net ?? 0,
        members: (linkedPortfolio.details?.tagMember ?? [])
          .filter(member => member.trustTagId === tag.id)
          .map(member => ({
            personTagId: member.personTagId,
            name: linkedTags.find(item => item.id === member.personTagId)?.name ?? "",
            percentage: member.percentage || 0
          }))
      });
    }
  }
  return entries;
};

const EMPTY_OWNERSHIP_TRUST_CONTRIBUTIONS = {};

export const ownershipTrustContributionsByRollupKeySelector = state => {
  const portfolio = currentPortfolioSelector(state);
  if (!portfolio === true) {
    return EMPTY_OWNERSHIP_TRUST_CONTRIBUTIONS;
  }

  const { acc, visitedPortfolioIds } = ownershipContributionsByName(state, portfolio);
  const contributionsByRollupKey = {};

  for (const visitedPortfolioId of visitedPortfolioIds) {
    const visitedPortfolio = portfolioSelector(state, visitedPortfolioId);
    const visitedTags = visitedPortfolio?.details?.tag ?? [];
    for (const member of visitedPortfolio?.details?.tagMember ?? []) {
      const personTag = visitedTags.find(item => item.id === member.personTagId);
      const trustTag = visitedTags.find(item => item.id === member.trustTagId);
      if (!personTag === true || !trustTag === true) {
        continue;
      }
      const personRollupKey = ownershipRollupKeyForTag(personTag);
      const trustRollupKey = ownershipRollupKeyForTag(trustTag);
      if (personRollupKey === "" || trustRollupKey === "") {
        continue;
      }
      const percentage = member.percentage || 0;
      if (!contributionsByRollupKey[personRollupKey]) {
        contributionsByRollupKey[personRollupKey] = [];
      }
      contributionsByRollupKey[personRollupKey].push({
        trustRollupKey,
        trustName: trustTag.name,
        percentage,
        value: (acc[trustRollupKey]?.net ?? 0) * (percentage / 100)
      });
    }
  }
  return contributionsByRollupKey;
};

export const ownershipRollupSelector = state => {
  const portfolio = currentPortfolioSelector(state);
  const rollupByTagId = {};
  if (!portfolio === true) {
    return rollupByTagId;
  }

  const { acc } = ownershipContributionsByName(state, portfolio);
  for (const tag of portfolio.details?.tag ?? []) {
    rollupByTagId[tag.id] = acc[ownershipRollupKeyForTag(tag)]?.net ?? 0;
  }
  return rollupByTagId;
};

export const custodiansWithLiquidationExpenseSelector = (state, portfolio) => {
  if (!portfolio) {
    portfolio = currentPortfolioSelector(state);
  }
  return portfolio.details.custodian.filter(item => !item.liqExpValue === false && item.hidden !== 1);
};

export const portfolioLiquidationExpenses = (state, portfolio) => {
  if (!portfolio) {
    portfolio = currentPortfolioSelector(state);
  }

  const custodiansWithExpense = custodiansWithLiquidationExpenseSelector(state, portfolio);
  return custodiansWithExpense.reduce((total, temp) => {
    const expense = convertCurrency(
      state,
      temp.liqExpValue,
      getTickerUsingId(state, temp.liqExpValueTickerId).shortName,
      portfolio.currency
    );
    return total + expense;
  }, 0);
};

export const hasLinkedPortfolioAsCustodianSelector = createSelector(
  [portfoliosSelector],
  portfolios => {
    if (!portfolios) return false;

    for (const portfolio of portfolios) {
      for (const custodian of portfolio.details.custodian) {
        if (custodian.linkType === accountLinkingService.KUBERA_PORTFOLIO) {
          return true;
        }
      }
    }

    return false;
  }
);

export const hasOwnershipTagDataSelector = createSelector(
  [portfoliosSelector],
  portfolios => {
    if (!portfolios) return false;

    return portfolios.some(portfolio => {
      const tags = portfolio.details?.tag ?? [];
      return liveTagAssignmentsForPortfolio(portfolio).some(assignment => {
        if ((assignment.percentage || 0) <= 0) {
          return false;
        }
        const tag = tags.find(item => item.id === assignment.tagId);
        return !tag === false && isDefaultPersonTag(tag) === false;
      });
    });
  }
);

export const usesBlackExclusiveFeaturesSelector = createSelector(
  [hasLinkedPortfolioAsCustodianSelector, hasOwnershipTagDataSelector],
  (hasLinkedPortfolio, hasOwnershipData) => hasLinkedPortfolio || hasOwnershipData
);

export function getUnfundedCommitmentForCustodian(state, custodian) {
  if (!custodian.cmtdCap === true) {
    return null;
  }
  const currentPortfolio = currentPortfolioSelector(state);
  let irrDetails = null;
  try {
    if (!custodian.irr === false) {
      irrDetails = JSON.parse(custodian.irr);
    }
  } catch (e) {
    return null;
  }
  if (irrDetails && irrDetails.totalCashInTickerId && irrDetails.totalCashInTickerId === custodian.cmtdCapTickerId) {
    const unfundedCommitment = custodian.cmtdCap - irrDetails.totalCashIn;

    if (unfundedCommitment <= 0) {
      return null;
    }

    return convertCurrency(
      state,
      unfundedCommitment,
      getTickerUsingId(state, custodian.cmtdCapTickerId).shortName,
      currentPortfolio.currency
    );
  }
  const committedCapital = convertCurrency(
    state,
    custodian.cmtdCap,
    getTickerUsingId(state, custodian.cmtdCapTickerId).shortName,
    currentPortfolio.currency
  );
  var cashIns = 0;

  if (!custodian.irr === false) {
    try {
      cashIns = convertCurrency(
        state,
        irrDetails.all.cashIn,
        getTickerUsingId(state, irrDetails.all.cashTickerId).shortName,
        currentPortfolio.currency
      );
    } catch (e) {
      return null;
    }
  }
  const unfundedCommitment = committedCapital - cashIns;
  if (unfundedCommitment > 0) {
    return custodian.linkedOwnership
      ? calcCustodianOwnershipValue(unfundedCommitment, custodian.linkedOwnership)
      : unfundedCommitment;
  }
  return null;
}

export const portfolioUnfundedCapital = state => {
  const custodiansWithCommittedCapital = custodiansWithCommitedCapitalForDashboardSelector(state);
  const committedCapitalValue =
    custodiansWithCommittedCapital &&
    custodiansWithCommittedCapital.reduce((total, temp) => {
      const value = getUnfundedCommitmentForCustodian(state, temp);
      return total + value;
    }, 0);
  const recapDataCurrency = recapDataCurrencySelector(state);
  const portfolioCurrency = currentPortfolioCurrencySelector(state);
  return convertCurrency(state, committedCapitalValue, recapDataCurrency, portfolioCurrency);
};

export const getDefaultTaxRateForPortfolioSelector = (state, portfolioId) => {
  const currentPortfolio = currentPortfolioSelector(state);
  const portfolio =
    portfolioId && portfolioId !== currentPortfolio?.id
      ? portfoliosSelector(state).find(p => p.id === portfolioId) || currentPortfolio
      : currentPortfolio;
  return portfolio && (portfolio.taxRate || portfolio.taxRate === 0) ? portfolio.taxRate : 30;
};

export const getCostTickerIdForTaxOnUnrealizedGainsForCustodian = custodian => {
  const taxDetails = custodian.taxDetails ? JSON.parse(custodian.taxDetails) : null;
  if (!taxDetails === true || !taxDetails.costBasisTickerId === true) {
    if (custodian.irrType === irrTypes.COSTBASIS && custodian.cost) {
      return custodian.costTickerId;
    }
    return null;
  }
  return taxDetails.costBasisTickerId;
};

export const getCostExchangeRateForTaxOnUnrealizedGainsForCustodian = custodian => {
  const taxDetails = custodian.taxDetails ? JSON.parse(custodian.taxDetails) : null;
  if (!taxDetails === true || !taxDetails.costBasisExchangeRate === true) {
    if (custodian.irrType === irrTypes.COSTBASIS && custodian.cost) {
      return custodian.costExchangeRate;
    }
    return null;
  }
  return taxDetails.costBasisExchangeRate;
};

export const getShowTaxLossForPortfolioSelector = (state, portfolioId) => {
  let portfolioIdToUse;
  if (!portfolioId) {
    portfolioIdToUse = currentPortfolioSelector(state).id;
  } else {
    portfolioIdToUse = portfolioId;
  }
  const userPreferences = userPreferencesSelector(state);
  const showTaxLossMap = userPreferences.portfolioShowTaxLossMap;
  if (!showTaxLossMap === true || !showTaxLossMap[portfolioIdToUse] === true) {
    return false;
  }
  return showTaxLossMap[portfolioIdToUse] === true;
};

export const getEstimatedTaxOnUnrealizedGainsForCustodian = (state, custodian, unrealizedGain) => {
  if (!unrealizedGain) {
    return unrealizedGain === null ? null : 0;
  }
  const taxDetails = custodian.taxDetails ? JSON.parse(custodian.taxDetails) : null;
  let taxPercentage;
  if (taxDetails && taxDetails.taxPercentage !== undefined && taxDetails.taxPercentage !== null) {
    taxPercentage = taxDetails.taxPercentage;
  } else {
    taxPercentage = getDefaultTaxRateForPortfolioSelector(state, custodian.portfolioId);
  }

  if (unrealizedGain <= 0) {
    return getShowTaxLossForPortfolioSelector(state, custodian.portfolioId)
      ? getActualValueFromPercentage(taxPercentage, unrealizedGain)
      : 0;
  }

  return getActualValueFromPercentage(taxPercentage, unrealizedGain);
};

const getIrrDetails = irr => {
  try {
    const details = JSON.parse(irr);
    if (!details.all.error === false) {
      return null;
    }
    return details;
  } catch (e) {
    return null;
  }
};

export const getCostBasisForTaxOnUnrealizedGains = (state, custodian, holdings) => {
  const currentPortfolio = currentPortfolioSelector(state);
  const cashHoldingsCost = getCashHoldingsCost(state, holdings, custodian.costTickerId);
  const taxDetails = custodian.taxDetails ? JSON.parse(custodian.taxDetails) : null;
  if (
    !taxDetails === true ||
    !taxDetails.costBasis === true ||
    (custodian.irrType === irrTypes.HOLDING && !taxDetails.costBasisTickerId)
  ) {
    if (taxDetails && taxDetails.costBasis === 0) {
      return taxDetails.costBasis;
    }
    if (custodian.irrType === irrTypes.HOLDING) {
      const irrDetails = getIrrDetails(custodian.irr);
      if (!irrDetails?.all?.cashIn) return null;
      const cashFlowHoldings = holdings.filter(holding => holding.irrType === irrTypes.CASHFLOW);
      if (cashFlowHoldings.length > 0) return null;
      const cashTicker = getTickerUsingId(state, irrDetails.all.cashTickerId);
      const cashExchangeRate = getExchangeRate(state, cashTicker.shortName, currentPortfolio.currency);
      const totalCashIn = irrDetails.all.cashIn * cashExchangeRate;
      return totalCashIn - cashHoldingsCost;
    }
    if (custodian.irrType === irrTypes.COSTBASIS && (custodian.cost === 0 || !custodian.cost === false)) {
      const actualCustodianCost = custodian.cost;
      return actualCustodianCost - cashHoldingsCost;
    }
    return null;
  }
  return taxDetails.costBasis;
};

const getActualCostBasisForTaxOnUnrealizedGainsForCustodian = (state, custodian, cashHoldingsCost = 0, holdings) => {
  const currentPortfolio = currentPortfolioSelector(state);
  if (!currentPortfolio) {
    return null;
  }
  const taxDetails = custodian.taxDetails ? JSON.parse(custodian.taxDetails) : null;
  if (
    !taxDetails === true ||
    !taxDetails.costBasis === true ||
    (custodian.irrType === irrTypes.HOLDING && !taxDetails.costBasisTickerId)
  ) {
    if (taxDetails && taxDetails.costBasis === 0) {
      return taxDetails.costBasis;
    }
    if (custodian.irrType === irrTypes.HOLDING) {
      return getCostBasisForTaxOnUnrealizedGains(state, custodian, holdings);
    }
    if (custodian.irrType === irrTypes.COSTBASIS && (custodian.cost === 0 || !custodian.cost === false)) {
      return (
        getCustodianCost(
          state,
          custodian.cost,
          custodian.costExchangeRate,
          getTickerUsingId(state, custodian.costTickerId).shortName,
          currentPortfolio.currency
        ) - cashHoldingsCost
      );
    }
    return null;
  }
  const costBasisSourceCurrency = taxDetails.costBasisTickerId
    ? getTickerUsingId(state, taxDetails.costBasisTickerId).shortName
    : currentPortfolio.currency;
  const costBasisForTaxOnUnrealizedGains = convertCurrency(
    state,
    taxDetails.costBasis,
    costBasisSourceCurrency,
    currentPortfolio.currency
  );
  return costBasisForTaxOnUnrealizedGains;
};

export function getUnrealizedGainForACustodian(state, custodian, category, holdings) {
  const cashHoldingsCost = getCashHoldingsCost(state, holdings);
  const cashHoldingsValue = getCashHoldingsValueForCustodian(state, holdings);
  const actualCostBasisOnTaxOnUnrealizedGains = getActualCostBasisForTaxOnUnrealizedGainsForCustodian(
    state,
    custodian,
    cashHoldingsCost,
    holdings
  );
  if (!actualCostBasisOnTaxOnUnrealizedGains && actualCostBasisOnTaxOnUnrealizedGains !== 0) {
    return actualCostBasisOnTaxOnUnrealizedGains === null ? null : 0;
  }

  const currentPortfolio = currentPortfolioSelector(state);
  const custodianValue = getCustodianValue(
    state,
    custodian,
    category,
    getTickerUsingShortName(state, currentPortfolio.currency)
  );
  return custodianValue - cashHoldingsValue - actualCostBasisOnTaxOnUnrealizedGains;
}

export const portfolioTaxOnUnrealizedGains = (state, portfolio) => {
  if (!portfolio) {
    portfolio = currentPortfolioSelector(state);
  }
  const custodiansWithTaxOnUnrealizedGains = recapDataTaxOnUnrealisedGainsSelector(state);
  const taxOnUnrealizedGainsValue =
    custodiansWithTaxOnUnrealizedGains &&
    custodiansWithTaxOnUnrealizedGains.reduce((total, temp) => {
      const holdingsForACustodian = portfolio.details.custodian.filter(custodian => custodian.parentId === temp.id);
      const unrealizedGain = getUnrealizedGainForACustodian(state, temp, categoryType.ASSET, holdingsForACustodian);
      const value = temp.linkedOwnership
        ? calcCustodianOwnershipValue(
            getEstimatedTaxOnUnrealizedGainsForCustodian(state, temp, unrealizedGain),
            temp.linkedOwnership
          )
        : getEstimatedTaxOnUnrealizedGainsForCustodian(state, temp, unrealizedGain);
      return total + value;
    }, 0);
  const recapDataCurrency = recapDataCurrencySelector(state);
  const portfolioCurrency = currentPortfolioCurrencySelector(state);
  return convertCurrency(state, taxOnUnrealizedGainsValue, recapDataCurrency, portfolioCurrency);
};

export const currentPortfolioTotalForCategory = (state, category, onlyInvestable = false) => {
  const currentPortfolio = currentPortfolioSelector(state);
  return portfolioTotalForCategory(state, currentPortfolio, category, onlyInvestable);
};

export const portfolioTotalForAssets = state => {
  const portfolio = currentPortfolioSelector(state);
  const portfolioTotalAssets = portfolioTotalForCategory(state, portfolio, categoryType.ASSET);

  return portfolioTotalAssets;
};

export const portfolioTotalForDebts = state => {
  const portfolio = currentPortfolioSelector(state);
  const portfolioTotalDebts = portfolioTotalForCategory(state, portfolio, categoryType.DEBT);

  return portfolioTotalDebts;
};

export const portfolioTotalForCategory = createStateAccessSelector(
  [
    state => state,
    currentPortfolioCustodiansUpdatedTimestampSelector,
    (state, portfolio) => {
      if (!portfolio) {
        portfolio = currentPortfolioSelector(state);
      }

      return portfolio;
    },
    (...args) => args[2],
    (...args) => args[3] ?? false
  ],
  (state, _, portfolio, category, onlyInvestable) => {
    if (!portfolio) {
      return 0;
    }
    const categoryCustodians = portfolioCustodiansSelector(state, portfolio, category);
    const portfolioTicker = getTickerUsingShortName(state, portfolio.currency);

    var total = 0;
    for (const custodian of categoryCustodians) {
      if (custodian.hidden === 1) {
        continue;
      }
      const custodianValue = getCustodianValue(state, custodian, category, portfolioTicker);
      if (onlyInvestable === true) {
        if (custodian.type === 0 || custodian.type === 2) {
          total = total + custodianValue;
        }
      } else {
        total = total + custodianValue;
      }
    }
    return total;
  }
);

export const getCashHoldingsValueForCustodian = (state, holdings) => {
  const currentPortfolio = currentPortfolioSelector(state);
  return holdings
    .filter(holding => holding.type === 2)
    .reduce((total, temp) => {
      const holdingValue = getCustodianValue(
        state,
        temp,
        categoryType.ASSET,
        getTickerUsingShortName(state, currentPortfolio.currency)
      );
      return total + holdingValue;
    }, 0);
};

export const getCashHoldingsCost = (state, holdings, custodianCostTickerId) => {
  const currentPortfolioCurrency = currentPortfolioCurrencySelector(state);
  return holdings
    .filter(holding => holding.type === 2)
    .reduce((total, temp) => {
      const holdingCost = getCustodianCost(
        state,
        temp.cost,
        temp.costExchangeRate,
        getTickerUsingId(state, temp.costTickerId).shortName,
        custodianCostTickerId ? getTickerUsingId(state, custodianCostTickerId).shortName : currentPortfolioCurrency
      );
      return total + holdingCost;
    }, 0);
};

export const currentPortfolioNameSelector = state => {
  const currentPortfolio = currentPortfolioSelector(state);
  return currentPortfolio && currentPortfolio.name;
};

export const currentPortfolioNetWorthDataSelector = state => {
  const currentPortfolio = currentPortfolioSelector(state);
  if (currentPortfolio) {
    return currentPortfolio.details.networth;
  }
  return 0;
};

export const currentPortfolioConnectionErrorsSelector = state => {
  const currentPortfolio = currentPortfolioSelector(state);
  if (currentPortfolio && currentPortfolio.details.networth && currentPortfolio.details.networth.data) {
    return currentPortfolio.details.networth.data.connErrors;
  }
  return null;
};

export const currentPortfolioChangeDataSelector = state => {
  if (currentPortfolioSelector(state)) {
    return currentPortfolioSelector(state).details.changeData;
  }
  return null;
};

export const currentPortfolioCagrDataSelector = state => {
  const currentPortfolio = currentPortfolioSelector(state);
  if (currentPortfolio?.details?.chartAndCagrData) {
    return currentPortfolio.details.chartAndCagrData;
  }
  return null;
};

export const isFetchingChartAndCagrDataSelector = state => {
  return currentPortfolioCagrDataSelector(state)?.isFetching === true;
};

export const getChangeTotalsWithContributorsForCurrentPortfolio = createStateAccessSelector(
  [
    state => state,
    currentPortfolioCurrencySelector,
    currentPortfolioSelector,
    currentPortfolioChangeDataSelector,
    state =>
      currentPortfolioChangeDataSelector(state)?.data ? currentPortfolioChangeDataSelector(state).data.change : null,
    (_, category) => category,
    state => displayTimezoneSelector(state)
  ],
  (state, _, currentPortfolio, changeData, changeDataChange, category) => {
    const getCurrentTotalValue = () => {
      const total = 0;
      const changeDataKey = "day";
      if (!changeData === false && !changeData.data === false) {
        if (!changeDataChange[changeDataKey] === false) {
          const yesterdaysTotal =
            category === categoryType.DEBT
              ? changeDataChange[changeDataKey].debtTotal
              : changeDataChange[changeDataKey].assetTotal;
          const change =
            category === categoryType.DEBT
              ? changeDataChange[changeDataKey].debtChangeTotal
              : changeDataChange[changeDataKey].assetChangeTotal;
          const value = yesterdaysTotal + change;
          return convertCurrency(state, value, changeData.data.currency, currentPortfolio.currency);
        }
      }
      return total;
    };

    const getChangeDataKey = forPastInterval => {
      switch (forPastInterval) {
        case pastValueInterval.DAY:
          return "day";
        case pastValueInterval.WEEK:
          return "week";
        case pastValueInterval.MONTH:
          return "month";
        case pastValueInterval.YEAR:
          return "year";
        case pastValueInterval.YTD:
          return "lastYearEnd";
        default:
          return null;
      }
    };

    const getTotalValueAndContributors = forInterval => {
      const changeDataKey = getChangeDataKey(forInterval);
      if (!changeData === false && !changeData.data === false && !changeDataKey === false) {
        const changeDataForInterval = changeData.data.change[changeDataKey];

        if (!changeDataForInterval === false) {
          const value =
            category === categoryType.DEBT ? changeDataForInterval.debtTotal : changeDataForInterval.assetTotal;
          const total = convertCurrency(state, value, changeData.data.currency, currentPortfolio.currency);

          const contributors =
            category === categoryType.ASSET ? changeDataForInterval.asset : changeDataForInterval.debt;

          const nonArchivedContributors = contributors.filter(item => item.archived === 0);
          const archivedContributors = contributors.filter(item => item.archived === 1);
          const sortedContributors = [...nonArchivedContributors, ...archivedContributors];

          const changeContributors = sortedContributors.map(item => {
            const value = convertCurrency(state, item.value, changeData.data.currency, currentPortfolio.currency);

            return {
              name: item.name,
              startValue: item.archived === 0 && value > 0 ? 0 : Math.abs(value),
              currentValue: item.archived === 0 && value > 0 ? Math.abs(value) : 0,
              isArchived: item.archived === 1
            };
          });

          const changeTotal = parseFloat((getCurrentTotalValue() - total).toFixed(2));
          const contributorsTotal = parseFloat(
            changeContributors.reduce((total, temp) => total + (temp.currentValue - temp.startValue), 0).toFixed(2)
          );

          if (changeTotal !== contributorsTotal) {
            changeContributors.push({
              name: `Others (${
                category === categoryType.DEBT ? "Debts" : "Assets"
              } with less than ${getSymbolForTickerUsingShortName(state, currentPortfolio.currency)}${
                isCryptoCurrency(state, currentPortfolio.currency) ? 0.0001 : 1
              } change)`,
              startValue: contributorsTotal,
              currentValue: changeTotal
            });
          }

          return {
            total: total,
            contributors: changeContributors,
            isInsidePortfolioStartDate:
              checkIfDateIsGreaterThanPortfolioStartDate(state, currentPortfolio.id, forInterval) ||
              forInterval === pastValueInterval.YTD
          };
        }
      }
      return { total: 0, contributors: [] };
    };

    var totalsWithContributors = {};
    totalsWithContributors.currentTotal = getCurrentTotalValue();
    totalsWithContributors.changes = {};
    totalsWithContributors.changes.day = getTotalValueAndContributors(pastValueInterval.DAY);
    totalsWithContributors.changes.week = getTotalValueAndContributors(pastValueInterval.WEEK);
    totalsWithContributors.changes.month = getTotalValueAndContributors(pastValueInterval.MONTH);
    totalsWithContributors.changes.year = getTotalValueAndContributors(pastValueInterval.YEAR);
    totalsWithContributors.changes.ytd = getTotalValueAndContributors(pastValueInterval.YTD);
    // console.log("totalsWithContributors", JSON.stringify(totalsWithContributors));
    return totalsWithContributors;
  }
);

export const isPortfolioReadySelector = state => {
  const currentPortfolio = currentPortfolioSelector(state);
  const netWorthTotal = portfolioNetWorth(state);
  if (!currentPortfolio === true) {
    return true;
  }
  const hasValidCustodian = currentPortfolio.details.custodian.some(custodian => {
    const sheetData = custodianSheetSelector(state, custodian.id);
    return (
      sheetData && sheetData.category === categoryType.ASSET && !custodian.name === false && !custodian.value === false
    );
  });
  return hasValidCustodian && netWorthTotal !== 0;
};

export const dashboardChartsDataSelector = createStateAccessSelector(
  [state => state, recapDataPortfolioMapUpdateTimestampSelector, (_, chartIds) => chartIds],
  (state, _, chartIds) => {
    var chartsData = [];
    for (const chartId of chartIds) {
      try {
        const chartParams = parseParams(chartId);
        const reportId = chartParams.report_id;
        const isChecked = chartParams.is_checked;
        const content = chartParams.chart_content;
        const chartName = chartParams.chart_name;
        const isDefaultChart = chartParams.is_default_chart;
        const shouldCompareWithTotalAssetsOrDebts = chartParams.should_compare_with_total_assets_or_debts === "true";
        const shouldCompareWithInvestableAsset = chartParams.should_compare_with_investable_assets === "true";
        const shouldCompareWithSheet = chartParams.should_compare_with_sheet === "true";
        const shouldCompareWithInvestableAssetsWithOutCash =
          chartParams.should_compare_with_investable_assets_without_cash === "true";
        const isDisabled = chartParams.is_disabled === "true";
        var data = null;
        let recommendationCount = 0;
        if (chartParams.chart_style === chartStyle.LINE) {
          data = recapReportLineChartDataSelector(state, reportId);
        } else if (chartParams.chart_style === chartStyle.DOUGHNUT) {
          if (chartParams.chart_content === chartContent.CONTENTS) {
            data = recapReportContentsDoughnutDataSelector(state, reportId);
            recommendationCount = getRecommendationCountForAChartSelector(
              state,
              reportId,
              content,
              (data && data.percentages) || []
            );
          } else if (chartParams.chart_content === chartContent.REPORTS) {
            data = recapReportComparisonDoughnutDataSelector(
              state,
              reportId,
              null,
              shouldCompareWithInvestableAsset,
              shouldCompareWithTotalAssetsOrDebts,
              shouldCompareWithSheet,
              shouldCompareWithInvestableAssetsWithOutCash
            );
            if (data) {
              data.content = content;
            }
            recommendationCount = getRecommendationCountForAChartSelector(
              state,
              reportId,
              content,
              (data && data.percentages) || []
            );
          }
          if (chartParams.chart_content === chartContent.CONTENTS_GROUPED_BY_SHEETS_AND_SECTION) {
            data = recapReportContentsDoughnutDataSelector(state, reportId, null, true);
            recommendationCount = getRecommendationCountForAChartSelector(
              state,
              reportId,
              content,
              (data && data.percentages) || []
            );
          }
          if (chartParams.chart_content === chartContent.INVESTABLE_ASSETS_GROUPED_BY_SECTION) {
            const node = recapReportNodeSelector(state, reportId, true, chartTimeRange.TODAY, false, true);
            const isAllSheetsHaveOneSection =
              node && node.sheets.filter(sheet => sheet).every(sheet => sheet?.sections?.length === 1);
            if (!isAllSheetsHaveOneSection) {
              data = recapReportContentsDoughnutDataSelector(state, reportId, null, false, true);
              recommendationCount = getRecommendationCountForAChartSelector(
                state,
                reportId,
                content,
                (data && data.percentages) || []
              );
            }
          }
          if (chartParams.chart_content === chartContent.INVESTABLE_ASSETS_WITHOUT_CASH_GROUPED_BY_SHEETS_AND_SECTION) {
            data = recapReportContentsDoughnutDataSelector(state, reportId, null, false, false, true);
            recommendationCount = getRecommendationCountForAChartSelector(
              state,
              reportId,
              content,
              (data && data.percentages) || []
            );
          }
          if (chartParams.chart_content === chartContent.INVESTABLE_ASSETS_WITHOUT_CASH_GROUPED_BY_SECTION) {
            const node = recapReportNodeSelector(
              state,
              reportId,
              true,
              chartTimeRange.TODAY,
              false,
              false,
              false,
              true
            );
            const isAllSheetsHaveOneSection =
              node && node.sheets.filter(sheet => sheet).every(sheet => sheet?.sections?.length === 1);
            if (!isAllSheetsHaveOneSection) {
              data = recapReportContentsDoughnutDataSelector(state, reportId, null, false, false, false, true);
              recommendationCount = getRecommendationCountForAChartSelector(
                state,
                reportId,
                content,
                (data && data.percentages) || []
              );
            }
          }
          if (chartParams.chart_content === chartContent.ASSETS_GROUPED_BY_SECTIONS) {
            const node = recapReportNodeSelector(state, reportId, null, false, false, false, false, false, true);
            const isAllSheetsHaveOneSection =
              node && node.sheets.filter(sheet => sheet).every(sheet => sheet?.sections?.length === 1);
            if (!isAllSheetsHaveOneSection) {
              data = recapReportContentsDoughnutDataSelector(state, reportId, null, false, false, false, false, true);
              recommendationCount = getRecommendationCountForAChartSelector(
                state,
                reportId,
                content,
                (data && data.percentages) || []
              );
            }
          }
        } else if (content === chartContent.CONNECTIVITY_WIDGET) {
          data = { title: i18n.t("connectivityWidgettitle") };
        }
        const shouldShowTotalSubText = chartName === "Investable Assets" && isDefaultChart === "true";
        const assetsTotal = recapDataTotalAssetsSelector(state);
        const investableAssetsTotal = recapDataTotalInvestableAssetsSelector(state);
        const investablePercentage = getPercentageValue(
          investableAssetsTotal && investableAssetsTotal.values[0].value,
          assetsTotal && assetsTotal.values[0].value
        );
        // const shouldShowChart = isDefaultChart === "true" ? data && data.labels.length >= 2 : true;
        if (content === chartContent.CONNECTIVITY_WIDGET) {
          chartsData.push({
            ...data,
            id: chartId,
            isChecked: isChecked === "true",
            chartStyle: chartParams.chart_style,
            recommendationCount: recommendationCount,
            isDisabled: isDisabled,
            chartContent: content
          });
        } else {
          const reportCurrentValue = recapReportValueSelector(
            state,
            chartParams.report_id,
            content === chartContent.CONTENTS_GROUPED_BY_SHEETS_AND_SECTION,
            content === chartContent.INVESTABLE_ASSETS_GROUPED_BY_SECTION,
            content === chartContent.INVESTABLE_ASSETS_WITHOUT_CASH_GROUPED_BY_SHEETS_AND_SECTION,
            content === chartContent.INVESTABLE_ASSETS_WITHOUT_CASH_GROUPED_BY_SECTION
          );
          if (reportCurrentValue && data) {
            chartsData.push({
              ...data,
              id: chartId,
              isChecked: isChecked === "true",
              chartStyle: chartParams.chart_style,
              recommendationCount: recommendationCount,
              totalSubText: shouldShowTotalSubText ? `${investablePercentage}% of Assets` : null,
              isDisabled: isDisabled
            });
          } else {
            chartsData.push(null);
          }
        }
      } catch (e) {
        console.log("error", e);
      }
    }
    return chartsData;
  }
);

const checkIfRecapDataIsEmpty = state => {
  const recapData = recapDataSelector(state);
  return (
    recapData &&
    recapData.data &&
    recapData.data[chartTimeRange.DAILY] &&
    recapData.data[chartTimeRange.DAILY][recapChartOptions.NETWORTH.id] &&
    recapData.data[chartTimeRange.DAILY][recapChartOptions.NETWORTH.id][recapChartTypes.TOTALS] &&
    recapData.data[chartTimeRange.DAILY][recapChartOptions.NETWORTH.id][recapChartTypes.TOTALS][
      RECAP_CATEGORY_TYPE_NETWORTH
    ] &&
    recapData.data[chartTimeRange.DAILY][recapChartOptions.NETWORTH.id][recapChartTypes.TOTALS][
      RECAP_CATEGORY_TYPE_NETWORTH
    ][0].values.length === 0
  );
};

export const defaultDashboardChartIdsSelector = createStateAccessSelector(
  [state => state, currentPortfolioIdSelector, recapDataSelector],
  (state, currentPortfolioId, recapData) => {
    try {
      if (!recapData === true) {
        return [];
      }
      const timeRange = chartTimeRange.TODAY;

      const chartOption = recapChartOptions.SHEETS_AND_SECTIONS.id;
      const chartType = getRecapChartTypeForPortfolio(state);
      if (checkIfRecapDataIsEmpty(state)) {
        return [];
      }

      const reportTotals = recapData.data[timeRange][chartOption].totals;
      const assetTotals = reportTotals[RECAP_CATEGORY_TYPE_ASSET];
      const debtTotals = reportTotals[RECAP_CATEGORY_TYPE_DEBT];
      if (!assetTotals === true || !debtTotals === true) {
        return [];
      }

      const connectivityCenterDataForAPortfolio = connectivityCenterDataForPortfolioSelector(state, currentPortfolioId);
      const showConnectivityWidget =
        connectivityCenterDataForAPortfolio && connectivityCenterDataForAPortfolio.length > 0;
      var chartIds = [];
      if (showConnectivityWidget) {
        chartIds.push(
          createChartId(
            state,
            null,
            null,
            null,
            null,
            null,
            chartStyle.OTHER,
            chartContent.CONNECTIVITY_WIDGET,
            showConnectivityWidget,
            true,
            showConnectivityWidget
          )
        );
      }
      if (!checkIfAChartOptionHasNoDataToShow(recapChartOptions.ASSET_CLASSES.id, timeRange, recapData.data)) {
        chartIds.push(
          createChartId(
            state,
            recapChartOptions.ASSET_CLASSES.id,
            timeRange,
            chartType,
            null,
            RECAP_CATEGORY_TYPE_ASSET,
            chartStyle.DOUGHNUT,
            chartContent.CONTENTS,
            true,
            true,
            true
          )
        );
      }
      if (!checkIfAChartOptionHasNoDataToShow(recapChartOptions.INVESTABLE.id, timeRange, recapData.data)) {
        chartIds.push(
          createChartId(
            state,
            recapChartOptions.INVESTABLE.id,
            timeRange,
            chartType,
            null,
            RECAP_CATEGORY_TYPE_INVESTABLE_ASSETS,
            chartStyle.DOUGHNUT,
            chartContent.CONTENTS,
            true,
            true,
            true
          )
        );
      }

      if (!checkIfAChartOptionHasNoDataToShow(recapChartOptions.INVESTABLE.id, timeRange, recapData.data)) {
        chartIds.push(
          createChartId(
            state,
            recapChartOptions.INVESTABLE.id,
            timeRange,
            chartType,
            null,
            RECAP_CATEGORY_TYPE_INVESTABLE_ASSETS,
            chartStyle.DOUGHNUT,
            chartContent.CONTENTS_GROUPED_BY_SHEETS_AND_SECTION,
            true,
            true,
            true
          )
        );
      }
      if (
        !checkIfAChartOptionHasNoDataToShow(recapChartOptions.INVESTABLE_WITHOUT_CASH.id, timeRange, recapData.data)
      ) {
        chartIds.push(
          createChartId(
            state,
            recapChartOptions.INVESTABLE_WITHOUT_CASH.id,
            timeRange,
            chartType,
            null,
            RECAP_CATEGORY_TYPE_INVESTABLE_ASSETS_WITHOUT_CASH,
            chartStyle.DOUGHNUT,
            chartContent.CONTENTS,
            true,
            true,
            true
          )
        );
      }

      if (!checkIfAChartOptionHasNoDataToShow(recapChartOptions.ASSETS_AND_CURRENCY.id, timeRange, recapData.data)) {
        chartIds.push(
          createChartId(
            state,
            recapChartOptions.ASSETS_AND_CURRENCY.id,
            timeRange,
            chartType,
            null,
            RECAP_CATEGORY_TYPE_FIAT_ASSET,
            chartStyle.DOUGHNUT,
            chartContent.CONTENTS,
            true,
            true,
            true
          )
        );
      }

      if (!checkIfAChartOptionHasNoDataToShow(recapChartOptions.STOCKS_AND_GEOGRAPHY.id, timeRange, recapData.data)) {
        chartIds.push(
          createChartId(
            state,
            recapChartOptions.STOCKS_AND_GEOGRAPHY.id,
            timeRange,
            chartType,
            null,
            "Stocks",
            chartStyle.DOUGHNUT,
            chartContent.CONTENTS,
            true,
            true,
            true
          )
        );
      }

      if (!checkIfAChartOptionHasNoDataToShow(recapChartOptions.STOCKS_AND_SECTOR.id, timeRange, recapData.data)) {
        chartIds.push(
          createChartId(
            state,
            recapChartOptions.STOCKS_AND_SECTOR.id,
            timeRange,
            chartType,
            null,
            "Stocks",
            chartStyle.DOUGHNUT,
            chartContent.CONTENTS,
            true,
            true,
            true
          )
        );
      }

      if (!checkIfAChartOptionHasNoDataToShow(recapChartOptions.STOCKS_AND_MARKETCAP.id, timeRange, recapData.data)) {
        chartIds.push(
          createChartId(
            state,
            recapChartOptions.STOCKS_AND_MARKETCAP.id,
            timeRange,
            chartType,
            null,
            "Stocks",
            chartStyle.DOUGHNUT,
            chartContent.CONTENTS,
            true,
            true,
            true
          )
        );
      }

      if (!checkIfAChartOptionHasNoDataToShow(recapChartOptions.CRYPTO.id, timeRange, recapData.data)) {
        chartIds.push(
          createChartId(
            state,
            recapChartOptions.CRYPTO.id,
            timeRange,
            chartType,
            null,
            "Crypto",
            chartStyle.DOUGHNUT,
            chartContent.CONTENTS,
            true,
            true,
            true
          )
        );
      }

      if (assetTotals.values[assetTotals.values.length - 1] !== 0) {
        chartIds.push(
          createChartId(
            state,
            chartOption,
            timeRange,
            chartType,
            null,
            RECAP_CATEGORY_TYPE_ASSET,
            chartStyle.DOUGHNUT,
            chartContent.CONTENTS,
            true,
            true,
            true
          )
        );

        for (const sheet of assetTotals.sheets) {
          if (sheet) {
            chartIds.push(
              createChartId(
                state,
                chartOption,
                timeRange,
                chartType,
                `${RECAP_CATEGORY_TYPE_ASSET}/sheets`,
                sheet.id,
                chartStyle.DOUGHNUT,
                chartContent.CONTENTS,
                sheet.sections && sheet.sections.length > 1,
                true,
                sheet.sections && sheet.sections.length > 1
              )
            );
            if (sheet.sections.length > 1) {
              for (const section of sheet.sections) {
                if (section) {
                  chartIds.push(
                    createChartId(
                      state,
                      chartOption,
                      timeRange,
                      chartType,
                      `${RECAP_CATEGORY_TYPE_ASSET}/sections`,
                      section.sectionId,
                      chartStyle.DOUGHNUT,
                      chartContent.CONTENTS,
                      false,
                      true,
                      false
                    )
                  );
                }
              }
            }
          }
        }
      }

      return chartIds;
    } catch (e) {
      console.log("e", e);
      return [];
    }
  }
);

export const chartIdsForSelectedCustodianSelector = createSelector(
  [
    state => state,
    (...args) => args[1],
    (...args) => args[2],
    (...args) => args[3],
    (...args) => args[4],
    (...args) => args[5],
    (...args) => args[6],
    (...args) => args[7] ?? false,
    (...args) => args[8] ?? false,
    (...args) => args[9] ?? false,
    (...args) => args[10] ?? false,
    (...args) => args[11] ?? false,
    (...args) => args[12] ?? false,
    (...args) => args[13] ?? false
  ],
  (
    state,
    selectedChartOptions,
    selectedTimeRange,
    selectedChartType,
    reportPath,
    reportNodeId,
    reportId,
    shouldShowContentsTab,
    shouldShowReportsTab,
    shouldShowInvestableAssetsBySheetsTab,
    shouldShowInvestableAssetsBySectionsTab,
    shouldShowInvestableAssetsWithoutCashBySheetsTab,
    shouldShowInvestableAssetsWithoutCashBySectionsTab,
    shouldShowAssetsBySectionsTab
  ) => {
    const chartIds = [];
    // line chart
    chartIds.push(
      createChartId(
        state,
        selectedChartOptions,
        selectedTimeRange,
        selectedChartType,
        reportPath,
        reportNodeId,
        chartStyle.LINE,
        null,
        true
      )
    );
    if (shouldShowContentsTab) {
      chartIds.push(
        createChartId(
          state,
          selectedChartOptions,
          selectedTimeRange,
          selectedChartType,
          reportPath,
          reportNodeId,
          chartStyle.DOUGHNUT,
          chartContent.CONTENTS,
          true
        )
      );
    }
    if (shouldShowInvestableAssetsBySheetsTab) {
      chartIds.push(
        createChartId(
          state,
          selectedChartOptions,
          selectedTimeRange,
          selectedChartType,
          reportPath,
          reportNodeId,
          chartStyle.DOUGHNUT,
          chartContent.CONTENTS_GROUPED_BY_SHEETS_AND_SECTION,
          true,
          true
        )
      );
    }
    if (shouldShowInvestableAssetsBySectionsTab) {
      chartIds.push(
        createChartId(
          state,
          selectedChartOptions,
          selectedTimeRange,
          selectedChartType,
          reportPath,
          reportNodeId,
          chartStyle.DOUGHNUT,
          chartContent.INVESTABLE_ASSETS_GROUPED_BY_SECTION,
          true,
          false
        )
      );
    }
    if (shouldShowInvestableAssetsWithoutCashBySheetsTab) {
      chartIds.push(
        createChartId(
          state,
          selectedChartOptions,
          selectedTimeRange,
          selectedChartType,
          reportPath,
          reportNodeId,
          chartStyle.DOUGHNUT,
          chartContent.INVESTABLE_ASSETS_WITHOUT_CASH_GROUPED_BY_SHEETS_AND_SECTION,
          true,
          false
        )
      );
    }
    if (shouldShowInvestableAssetsWithoutCashBySectionsTab) {
      chartIds.push(
        createChartId(
          state,
          selectedChartOptions,
          selectedTimeRange,
          selectedChartType,
          reportPath,
          reportNodeId,
          chartStyle.DOUGHNUT,
          chartContent.INVESTABLE_ASSETS_WITHOUT_CASH_GROUPED_BY_SECTION,
          true,
          false
        )
      );
    }
    if (shouldShowAssetsBySectionsTab) {
      chartIds.push(
        createChartId(
          state,
          selectedChartOptions,
          selectedTimeRange,
          selectedChartType,
          reportPath,
          reportNodeId,
          chartStyle.DOUGHNUT,
          chartContent.ASSETS_GROUPED_BY_SECTIONS,
          true,
          false
        )
      );
    }
    if (shouldShowReportsTab) {
      if (selectedChartOptions === recapChartOptions.SHEETS_AND_SECTIONS.id) {
        if (reportPath === reportPaths.ASSETS_ROW) {
          const parentNode = sheetAndSectionReportNodeSelector(state, reportId, null, true);
          const shouldAddToSheetsChart = parentNode.type && parentNode.type === "header";
          chartIds.push(
            createChartId(
              state,
              selectedChartOptions,
              selectedTimeRange,
              selectedChartType,
              reportPath,
              reportNodeId,
              chartStyle.DOUGHNUT,
              chartContent.REPORTS,
              true,
              false,
              false,
              false,
              false
            )
          );
          if (shouldAddToSheetsChart) {
            chartIds.push(
              createChartId(
                state,
                selectedChartOptions,
                selectedTimeRange,
                selectedChartType,
                reportPath,
                reportNodeId,
                chartStyle.DOUGHNUT,
                chartContent.REPORTS,
                true,
                false,
                false,
                false,
                false,
                true
              )
            );
          }

          chartIds.push(
            createChartId(
              state,
              selectedChartOptions,
              selectedTimeRange,
              selectedChartType,
              reportPath,
              reportNodeId,
              chartStyle.DOUGHNUT,
              chartContent.REPORTS,
              true,
              false,
              false,
              true,
              false
            )
          );
          chartIds.push(
            createChartId(
              state,
              selectedChartOptions,
              selectedTimeRange,
              selectedChartType,
              reportPath,
              reportNodeId,
              chartStyle.DOUGHNUT,
              chartContent.REPORTS,
              true,
              false,
              false,
              false,
              true
            )
          );
        } else if (reportPath === reportPaths.DEBTS_ROW) {
          const parentNode = sheetAndSectionReportNodeSelector(state, reportId, null, true);
          const shouldAddToSheetsChart = parentNode.type && parentNode.type === "header";
          chartIds.push(
            createChartId(
              state,
              selectedChartOptions,
              selectedTimeRange,
              selectedChartType,
              reportPath,
              reportNodeId,
              chartStyle.DOUGHNUT,
              chartContent.REPORTS,
              true,
              false,
              false,
              false,
              false
            )
          );
          if (shouldAddToSheetsChart) {
            chartIds.push(
              createChartId(
                state,
                selectedChartOptions,
                selectedTimeRange,
                selectedChartType,
                reportPath,
                reportNodeId,
                chartStyle.DOUGHNUT,
                chartContent.REPORTS,
                true,
                false,
                false,
                false,
                false,
                true
              )
            );
          }
          chartIds.push(
            createChartId(
              state,
              selectedChartOptions,
              selectedTimeRange,
              selectedChartType,
              reportPath,
              reportNodeId,
              chartStyle.DOUGHNUT,
              chartContent.REPORTS,
              true,
              false,
              false,
              false,
              true
            )
          );
        } else if (reportPath === reportPaths.ASSETS_SECTION || reportPath === reportPaths.DEBTS_SECTION) {
          chartIds.push(
            createChartId(
              state,
              selectedChartOptions,
              selectedTimeRange,
              selectedChartType,
              reportPath,
              reportNodeId,
              chartStyle.DOUGHNUT,
              chartContent.REPORTS,
              true,
              false,
              false,
              false,
              false
            )
          );
          if (reportPath === reportPaths.ASSETS_SECTION) {
            chartIds.push(
              createChartId(
                state,
                selectedChartOptions,
                selectedTimeRange,
                selectedChartType,
                reportPath,
                reportNodeId,
                chartStyle.DOUGHNUT,
                chartContent.REPORTS,
                true,
                false,
                false,
                true,
                false
              )
            );
          }
          chartIds.push(
            createChartId(
              state,
              selectedChartOptions,
              selectedTimeRange,
              selectedChartType,
              reportPath,
              reportNodeId,
              chartStyle.DOUGHNUT,
              chartContent.REPORTS,
              true,
              false,
              false,
              false,
              true
            )
          );
        } else if (reportPath === reportPaths.ASSETS_SHEET || reportPath === reportPaths.DEBTS_SHEETS) {
          if (reportPath === reportPaths.ASSETS_SHEET) {
            chartIds.push(
              createChartId(
                state,
                selectedChartOptions,
                selectedTimeRange,
                selectedChartType,
                reportPath,
                reportNodeId,
                chartStyle.DOUGHNUT,
                chartContent.REPORTS,
                true,
                false,
                false,
                true,
                false
              )
            );
          }
          chartIds.push(
            createChartId(
              state,
              selectedChartOptions,
              selectedTimeRange,
              selectedChartType,
              reportPath,
              reportNodeId,
              chartStyle.DOUGHNUT,
              chartContent.REPORTS,
              true,
              false,
              false,
              false,
              false
            )
          );
        }
      } else {
        chartIds.push(
          createChartId(
            state,
            selectedChartOptions,
            selectedTimeRange,
            selectedChartType,
            reportPath,
            reportNodeId,
            chartStyle.DOUGHNUT,
            chartContent.REPORTS,
            true
          )
        );
        const node = recapReportNodeSelector(
          state,
          reportId,
          true,
          selectedTimeRange,
          shouldShowInvestableAssetsBySheetsTab,
          shouldShowInvestableAssetsBySectionsTab,
          shouldShowInvestableAssetsWithoutCashBySheetsTab,
          shouldShowInvestableAssetsWithoutCashBySectionsTab,
          shouldShowAssetsBySectionsTab
        );
        if (
          selectedChartOptions === recapChartOptions.INVESTABLE.id &&
          node &&
          (!node.type || node.type !== "header") &&
          reportNodeId !== "Investable Assets"
        ) {
          chartIds.push(
            createChartId(
              state,
              selectedChartOptions,
              selectedTimeRange,
              selectedChartType,
              reportPath,
              reportNodeId,
              chartStyle.DOUGHNUT,
              chartContent.REPORTS,
              true,
              false,
              false,
              true,
              false,
              false,
              false
            )
          );
        }
        if (
          selectedChartOptions === recapChartOptions.INVESTABLE_WITHOUT_CASH.id &&
          node &&
          (!node.type || node.type !== "header") &&
          reportNodeId !== "Investable Assets ex Cash"
        ) {
          chartIds.push(
            createChartId(
              state,
              selectedChartOptions,
              selectedTimeRange,
              selectedChartType,
              reportPath,
              reportNodeId,
              chartStyle.DOUGHNUT,
              chartContent.REPORTS,
              true,
              false,
              false,
              false,
              false,
              false,
              true
            )
          );
        }
      }
    }
    return chartIds;
  }
);

export const createChartIdUsingReportId = (
  reportId,
  chartStyle,
  chartContent,
  isChecked,
  isDefaultChart,
  chartName,
  shouldBeCheckedByDefault,
  shouldCompareWithInvestableAsset,
  shouldCompareWithTotalAssetsOrDebts,
  shouldCompareWithSheet,
  shouldCompareWithInvestableAssetsWithOutCash
) => {
  return [
    `report_id=${reportId}`,
    `chart_style=${chartStyle}`,
    `chart_content=${chartContent}`,
    `is_checked=${isChecked}`,
    `is_default_chart=${isDefaultChart}`,
    `chart_name=${encodeURIComponent(chartName)}`,
    `should_be_checked_by_default=${shouldBeCheckedByDefault}`,
    `should_compare_with_investable_assets=${shouldCompareWithInvestableAsset}`,
    `should_compare_with_total_assets_or_debts=${shouldCompareWithTotalAssetsOrDebts}`,
    `should_compare_with_sheet=${shouldCompareWithSheet}`,
    `should_compare_with_investable_assets_without_cash=${shouldCompareWithInvestableAssetsWithOutCash}`
  ].join("&");
};

export const getChartStyleFromChartId = chartId => {
  const chartParams = parseParams(chartId);
  return chartParams.chart_style;
};

const createChartId = (
  state,
  chartOption,
  chartTimeRange,
  chartType,
  reportPath,
  reportNodeId,
  chartStyles,
  chartContents,
  isChecked,
  isDefaultChart,
  shouldBeCheckedByDefault,
  shouldCompareWithInvestableAsset,
  shouldCompareWithTotalAssetsOrDebts,
  shouldCompareWithSheet,
  shouldCompareWithInvestableAssetsWithOutCash
) => {
  try {
    var reportIdParams = [
      `chart_option=${chartOption}`,
      `chart_timerange=${chartTimeRange}`,
      `chart_type=${chartType}`
    ];
    if (reportPath) {
      reportIdParams.push(`report_path=${encodeURIComponent(reportPath)}`);
    }
    reportIdParams.push(`report_node_id=${encodeURIComponent(reportNodeId)}`);
    const reportId = encodeURIComponent(reportIdParams.join("&"));
    let reportName;
    if (chartContents !== chartContent.CONNECTIVITY_WIDGET) {
      reportName = recapReportNameSelector(state, decodeURIComponent(reportId));
    }
    let chartName;
    if (chartContents === chartContent.CONTENTS) {
      chartName = getContentsTabTitle(state, chartOption, reportNodeId, reportPath, reportName, reportId, true);
    } else if (chartContents === chartContent.REPORTS) {
      chartName = getComparisonReportsTabTitleSelector(
        state,
        reportName,
        reportNodeId,
        reportPath,
        chartOption,
        shouldCompareWithInvestableAsset,
        reportId,
        false,
        shouldCompareWithTotalAssetsOrDebts,
        shouldCompareWithSheet,
        shouldCompareWithInvestableAssetsWithOutCash
      );
    } else if (chartContents === chartContent.CONTENTS_GROUPED_BY_SHEETS_AND_SECTION) {
      chartName = "Investable Assets x Sheets";
    } else if (chartContents === chartContent.INVESTABLE_ASSETS_GROUPED_BY_SECTION) {
      chartName = "Investable Assets x Sections";
    } else if (chartContents === chartContent.INVESTABLE_ASSETS_WITHOUT_CASH_GROUPED_BY_SHEETS_AND_SECTION) {
      chartName = "Investable Assets ex Cash x Sheets";
    } else if (chartContents === chartContent.INVESTABLE_ASSETS_WITHOUT_CASH_GROUPED_BY_SECTION) {
      chartName = "Investable Assets ex Cash x Sections";
    } else if (chartContents === chartContent.CONNECTIVITY_WIDGET) {
      chartName = "Connectivity";
    } else if (chartContents === chartContent.ASSETS_GROUPED_BY_SECTIONS) {
      chartName = "Assets x Sections";
    } else {
      chartName = reportName;
    }
    return createChartIdUsingReportId(
      reportId,
      chartStyles,
      chartContents,
      isChecked,
      isDefaultChart,
      chartName,
      shouldBeCheckedByDefault,
      shouldCompareWithInvestableAsset,
      shouldCompareWithTotalAssetsOrDebts,
      shouldCompareWithSheet,
      shouldCompareWithInvestableAssetsWithOutCash
    );
  } catch (e) {
    console.log("e", e);
  }
};

export const getColumnForChart = dashboardCharts => {
  try {
    const column1FilteredCharts = dashboardCharts.columns.column1.chartIds.filter(id => {
      const params = parseParams(id);
      return params[chartKeyParams.IS_CHECKED] === "true";
    });
    const column2FilteredCharts = dashboardCharts.columns.column2.chartIds.filter(id => {
      const params = parseParams(id);
      return params[chartKeyParams.IS_CHECKED] === "true";
    });
    if (
      column1FilteredCharts.length === column2FilteredCharts.length ||
      column2FilteredCharts.length > column1FilteredCharts.length
    ) {
      return "column1";
    } else {
      return "column2";
    }
  } catch (e) {
    console.log("e", e);
  }
};

export const getCurrentPortfolioDataInNestedFormat = createStateAccessSelector(
  [
    state => state,
    currentPortfolioSelector,
    (state, category) => currentPortfolioTotalForCategory(state, category),
    (...args) => args[1],
    (...args) => args[2] ?? false
  ],
  (state, currentPortfolio, _, category, onlyInvestable) => {
    const portfolio = currentPortfolio;
    const details = portfolio ? portfolio.details : { sheet: [] };
    const portfolioTicker = getTickerUsingShortName(state, portfolio ? portfolio.currency : "USD");

    var portfolioData = {};
    var sheets = [];
    const categorySheets = details.sheet.filter(sheet => sheet.category === category);
    if (categorySheets.length === 0) {
      return { sheets: sheets, portfolioTotal: 0 };
    }

    const sectionsBySheetId = new Map();
    for (const section of details.section) {
      const bucket = sectionsBySheetId.get(section.sheetId);
      if (bucket === undefined) {
        sectionsBySheetId.set(section.sheetId, [section]);
      } else {
        bucket.push(section);
      }
    }

    const custodiansBySectionId = new Map();
    for (const custodian of details.custodian) {
      if (custodian.hidden === 1) {
        continue;
      }
      const bucket = custodiansBySectionId.get(custodian.sectionId);
      if (bucket === undefined) {
        custodiansBySectionId.set(custodian.sectionId, [custodian]);
      } else {
        bucket.push(custodian);
      }
    }

    for (const sheet of categorySheets) {
      var sections = [];
      for (const section of sectionsBySheetId.get(sheet.id) || []) {
        var custodians = [];
        const custodianValues = new Map();
        for (const custodian of custodiansBySectionId.get(section.id) || []) {
          if (!custodian.value === false) {
            if (
              onlyInvestable === false ||
              (onlyInvestable === true && (custodian.type === 0 || custodian.type === 2))
            ) {
              custodians.push(custodian);
              custodianValues.set(custodian, getCustodianValue(state, custodian, category, portfolioTicker));
            }
          }
        }
        const sectionTotal = custodians.reduce((total, temp) => total + custodianValues.get(temp), 0);
        custodians.sort((a, b) => custodianValues.get(b) - custodianValues.get(a));

        const sectionData = { section: section, custodians: custodians, sectionTotal: sectionTotal };
        sections.push(sectionData);
      }
      sections = sections.filter(sectionData => sectionData.sectionTotal !== 0);
      sections.sort((a, b) => b.sectionTotal - a.sectionTotal);

      const sheetTotal = sections.reduce((total, temp) => total + temp.sectionTotal, 0);
      const sheetData = { sheet: sheet, sections: sections, sheetTotal: sheetTotal };
      sheets.push(sheetData);
    }
    sheets = sheets.filter(sheetData => sheetData.sheetTotal !== 0);
    sheets.sort((a, b) => b.sheetTotal - a.sheetTotal);

    const portfolioTotal = sheets.reduce((total, temp) => total + temp.sheetTotal, 0);
    portfolioData = { sheets: sheets, portfolioTotal: portfolioTotal };

    return portfolioData;
  }
);

const doughnutDataForPortfolioAssets = createStateAccessSelector(
  [
    state => state,
    currentPortfolioSelector,
    (state, onlyInvestable) => getCurrentPortfolioDataInNestedFormat(state, categoryType.ASSET, onlyInvestable),
    (...args) => args[1] ?? false
  ],
  (state, currentPortfolio, portfolioData, onlyInvestable) => {
    const category = categoryType.ASSET;
    const portfolio = currentPortfolio;
    const portfolioTicker = getTickerUsingShortName(state, portfolio ? portfolio.currency : "USD");
    if (portfolioData.portfolioTotal === 0) {
      return [];
    }

    var doughnutData = [];
    if (portfolioData.sheets.length > 1) {
      const data = getDoughnutData(
        `${category}s`,
        portfolioData.portfolioTotal,
        portfolioData.sheets.map(sheetData => sheetData.sheet.name),
        portfolioData.sheets.map(sheetData => sheetData.sheetTotal),
        portfolioTicker.shortName
      );
      doughnutData.push(data);
    }
    var sectionDoughnuts = [];
    var custodianDoughnuts = [];
    for (const sheetData of portfolioData.sheets) {
      if (sheetData.sections.length > 1) {
        const data = getDoughnutData(
          sheetData.sheet.name,
          sheetData.sheetTotal,
          sheetData.sections.map(sectionData => sectionData.section.name),
          sheetData.sections.map(sectionData => sectionData.sectionTotal),
          portfolioTicker.shortName
        );
        sectionDoughnuts.push(data);
      }

      for (const sectionData of sheetData.sections) {
        var custodianGroups = {};

        for (const custodian of sectionData.custodians) {
          const custodianValueTicker = getTickerUsingId(state, custodian.valueTickerId);

          if (custodianValueTicker.type === tickerTypes.FIAT) {
            const currentEntry = custodianGroups[custodian.name];

            if (!currentEntry === true) {
              custodianGroups[custodian.name] = {
                name: custodian.name,
                value: getCustodianValue(state, custodian, category, portfolioTicker)
              };
            } else {
              currentEntry.value += getCustodianValue(state, custodian, category, portfolioTicker);
            }
          } else {
            const currentEntry = custodianGroups[custodian.valueTickerId];

            if (!currentEntry === true) {
              custodianGroups[custodian.valueTickerId] = {
                name: custodianValueTicker.name,
                value: getCustodianValue(state, custodian, category, portfolioTicker)
              };
            } else {
              currentEntry.value += getCustodianValue(state, custodian, category, portfolioTicker);
            }
          }
        }
        const groups = Object.values(custodianGroups);
        groups.sort((a, b) => b.value - a.value);
        if (groups.length > 1) {
          const data = getDoughnutData(
            sheetData.sections.length === 1 ? sheetData.sheet.name : sectionData.section.name,
            sectionData.sectionTotal,
            groups.map(group => group.name),
            groups.map(group => group.value),
            portfolioTicker.shortName
          );
          custodianDoughnuts.push(data);
        }
      }
    }

    doughnutData.push(...sectionDoughnuts);
    doughnutData.push(...custodianDoughnuts);

    const greaterThanVal = onlyInvestable ? 0 : 1;
    const assetDoughnuts = doughnutData.filter(data => data.labels.length > greaterThanVal);
    if (assetDoughnuts.length > 0) {
      assetDoughnuts[0].title = onlyInvestable ? "Investable Assets" : "Assets";
    }
    return assetDoughnuts;
  }
);

const doughnutDataForPortfolioAssetsOnlyInvestable = state => {
  return doughnutDataForPortfolioAssets(state, true);
};

const doughnutDataForPortfolioAssetsNotOnlyInvestable = state => {
  return doughnutDataForPortfolioAssets(state, false);
};

const doughnutDataForPortfolioDebts = createSelector(
  [
    currentPortfolioSelector,
    state => getCurrentPortfolioDataInNestedFormat(state, categoryType.DEBT),
    state => {
      const currentPortfolio = currentPortfolioSelector(state);
      return getTickerUsingShortName(state, currentPortfolio?.currency ?? "USD");
    }
  ],
  (_, portfolioData, portfolioTicker) => {
    const category = categoryType.DEBT;

    var doughnutData = [];
    if (portfolioData.sheets.length > 1) {
      const data = getDoughnutData(
        `${category}s`,
        portfolioData.portfolioTotal,
        portfolioData.sheets.map(sheetData => sheetData.sheet.name),
        portfolioData.sheets.map(sheetData => sheetData.sheetTotal),
        portfolioTicker.shortName
      );
      doughnutData.push(data);
    }
    return doughnutData;
  }
);

export const doughnutDataForPortfolioSelector = createSelector(
  [
    doughnutDataForPortfolioAssetsNotOnlyInvestable,
    doughnutDataForPortfolioAssetsOnlyInvestable,
    doughnutDataForPortfolioDebts
  ],
  (doughnutDataForAssets, doughnutDataForInvestableAssets, doughnutDataForDebts) => {
    var doughnutData = doughnutDataForAssets;
    if (doughnutData.length > 0 && doughnutDataForInvestableAssets.length > 0) {
      if (Math.kuberaFloor(doughnutData[0].total) !== Math.kuberaFloor(doughnutDataForInvestableAssets[0].total)) {
        const investableAssetsTotal = doughnutDataForInvestableAssets[0].total;
        const assetsTotal = doughnutData[0].total;
        const investablePercentage = getPercentageValue(investableAssetsTotal, assetsTotal);
        doughnutDataForInvestableAssets[0].totalSubText = `${investablePercentage}% of Assets`;
        doughnutDataForInvestableAssets[0].isInvestableData = true;
        doughnutData.splice(1, 0, doughnutDataForInvestableAssets[0]);
      }
    }
    doughnutData.push(...doughnutDataForDebts);
    return doughnutData;
  }
);

export const getDoughnutData = (
  title,
  total,
  labels,
  totals,
  currency,
  maxSlices = 5,
  noOfDecimalsForPercentage = 1
) => {
  for (var index = totals.length - 1; index >= 0; index--) {
    if (totals[index] === 0) {
      labels.splice(index, 1);
      totals.splice(index, 1);
    }
  }

  if (labels.length > maxSlices) {
    const othersTotal = totals.reduce((total, temp, index) => {
      return index > maxSlices - 2 ? total + temp : total;
    }, 0);
    labels = labels.slice(0, maxSlices - 1);
    labels.push(i18n.t("reportCharts.label.theRemaining"));
    totals = totals.slice(0, maxSlices - 1);
    totals.push(othersTotal);
  }

  const minPercentage = 5;
  if (labels.length > 2) {
    var belowMinPercentageIndexes = [];
    for (index = 0; index <= totals.length - 1; index++) {
      const percentage = getPercentageValue(totals[index], total);
      if (percentage < minPercentage && labels[index] !== i18n.t("reportCharts.label.theRemaining")) {
        belowMinPercentageIndexes.push(index);
      }
    }

    if (belowMinPercentageIndexes.length > 1) {
      var belowMinPercentageTotal = 0;
      for (const index of belowMinPercentageIndexes) {
        belowMinPercentageTotal += totals[index];
      }
      totals = totals.filter(function(value, index) {
        return belowMinPercentageIndexes.includes(index) === false;
      });
      labels = labels.filter(function(value, index) {
        return belowMinPercentageIndexes.includes(index) === false;
      });
      if (belowMinPercentageTotal > 0) {
        const othersIndex = labels.findIndex(item => item === i18n.t("reportCharts.label.theRemaining"));

        if (othersIndex === -1) {
          labels.push(i18n.t("reportCharts.label.theRemaining"));
          totals.push(belowMinPercentageTotal);
        } else {
          totals[othersIndex] = totals[othersIndex] + belowMinPercentageTotal;
        }
      }
    }
  }

  const othersIndex = labels.findIndex(item => item === i18n.t("reportCharts.label.theRemaining"));
  if (othersIndex) {
    for (const [index, item] of totals.entries()) {
      const othersTotal = totals[othersIndex];
      if (othersTotal > item) {
        totals.splice(othersIndex, 1);
        labels.splice(othersIndex, 1);

        labels.splice(index, 0, i18n.t("reportCharts.label.theRemaining"));
        totals.splice(index, 0, othersTotal);
        break;
      }
    }
  }

  var percentages = [];
  for (index = 0; index < totals.length; index++) {
    percentages[index] = getPercentageValue(totals[index], total, false, noOfDecimalsForPercentage);
  }

  for (index = percentages.length - 1; index >= 0; index--) {
    if (percentages[index] === 0) {
      labels.splice(index, 1);
      totals.splice(index, 1);
      percentages.splice(index, 1);
    }
  }

  return {
    title: title,
    total: total,
    labels: labels,
    data: totals,
    currency: currency,
    percentages: percentages,
    showChart: true
  };
};

export const isCustodianEmpty = custodian => {
  return (
    !custodian.name === true &&
    (custodian.value === null || custodian.value === undefined) &&
    (custodian.cost === null || custodian.cost === undefined)
  );
};

export const getEmptyCustodiansInSection = (state, portfolioId, sectionId) => {
  const portfolio = portfolioSelector(state, portfolioId);
  const sectionCustodians = portfolio.details.custodian.filter(item => item.sectionId === sectionId);
  return sectionCustodians.filter(item => isCustodianEmpty(item) === true);
};

export const getNonEmptyCustodiansInSection = (state, portfolioId, sectionId) => {
  const portfolio = portfolioSelector(state, portfolioId);
  const sectionCustodians = portfolio.details.custodian.filter(item => item.sectionId === sectionId);
  return sectionCustodians.filter(item => isCustodianEmpty(item) === false);
};

export const checkIfDateIsGreaterThanPortfolioStartDate = (state, portfolioId, changeLabel) => {
  const portfolioStartDate = getNetWorthChartStartDateForPortfolio(state);
  const now = toUserTimezoneDate(state).getTime();
  let changeLabelDate;

  if (changeLabel === pastValueInterval.DAY) {
    changeLabelDate = now - 24 * 60 * 60 * 1000;
  } else if (changeLabel === pastValueInterval.WEEK) {
    changeLabelDate = now - 7 * 24 * 60 * 60 * 1000;
  } else if (changeLabel === pastValueInterval.MONTH) {
    changeLabelDate = now - 30 * 24 * 60 * 60 * 1000;
  } else if (changeLabel === pastValueInterval.YEAR) {
    changeLabelDate = now - 365 * 24 * 60 * 60 * 1000;
  }
  if (changeLabelDate > portfolioStartDate) {
    return true;
  } else {
    return false;
  }
};

export const portfolioStartDateTsSelector = (state, portfolio) => {
  if (!portfolio) {
    portfolio = currentPortfolioSelector(state);
  }
  if (!portfolio) {
    return null;
  }
  const userPreferences = userPreferencesSelector(state);

  if (!portfolio.tsStartDate === false) {
    return portfolio.tsStartDate * 1000;
  } else if (!userPreferences.portfolioNetWorthChartStartDateTsMap === false) {
    return userPreferences.portfolioNetWorthChartStartDateTsMap[portfolio.id];
  } else {
    return null;
  }
};

const getPortfolioStartDateTsMemoized = memoize(
  (portfolioStartDateTs, tz) => parseKuberaDateString(getCivilDateString(portfolioStartDateTs, tz)) || new Date(NaN),
  (portfolioStartDateTs, tz) => `${portfolioStartDateTs}-${tz}`
);
const getPortfolioTsCreatedMemoized = memoize(
  (tsCreated, tz) => parseKuberaDateString(getCivilDateString(tsCreated * 1000, tz)) || new Date(NaN),
  (tsCreated, tz) => `${tsCreated}-${tz}`
);

export const getNetWorthChartStartDateForPortfolio = createSelector(
  [
    currentPortfolioSelector,
    portfolioStartDateTsSelector,
    (state, portfolio) => {
      let _portfolio = portfolio;

      if (!_portfolio) {
        _portfolio = currentPortfolioSelector(state);
      }
      return _portfolio?.details?.networth;
    },
    (_, _1, latestNetWorthData) => latestNetWorthData,
    state => displayTimezoneSelector(state)
  ],
  (portfolio, portfolioStartDateTs, networthDetails, latestNetWorthData, tz) => {
    if (!portfolioStartDateTs === true) {
      let netWorthData = networthDetails?.data;
      if (!latestNetWorthData === false) {
        netWorthData = latestNetWorthData;
      }
      if (netWorthData?.startDate) {
        return parseNetWorthDateString(netWorthData.startDate);
      }
      if (portfolio?.tsCreated) {
        return getPortfolioTsCreatedMemoized(portfolio.tsCreated, tz);
      }
    }
    const startDate = getPortfolioStartDateTsMemoized(portfolioStartDateTs, tz);
    if (startDate.getTime() >= toTimezoneDate(new Date(), tz).getTime() && portfolio?.tsCreated) {
      return getPortfolioTsCreatedMemoized(portfolio.tsCreated, tz);
    }
    return startDate;
  }
);

export const getNetWorthChartTimeRangeForPortfolio = (state, portfolio) => {
  if (!portfolio) {
    portfolio = currentPortfolioSelector(state);
  }
  const userPreferences = userPreferencesSelector(state);
  const timeRangePortfolioMap = userPreferences.portfolioNetWorthChartTimeRangeMap;

  if (!timeRangePortfolioMap === true || !timeRangePortfolioMap[portfolio.id] === true) {
    return chartTimeRange.MONTHLY;
  }
  return timeRangePortfolioMap[portfolio.id];
};

export const getShowNetworthChartPreferenceKey = portfolioId => `${portfolioId}-showNetworthChart`;

export const getShowInvestableAssetsChartPreferenceKey = portfolioId => `${portfolioId}-showInvestableAssetsChart`;

const getChartSeriesPreference = (state, portfolio, preferenceKeyForPortfolioId) => {
  if (!portfolio) {
    portfolio = currentPortfolioSelector(state);
  }
  const preference = userPreferencesSelector(state)[preferenceKeyForPortfolioId(portfolio?.id)];
  return preference === undefined ? true : preference;
};

export const getShowNetworthChartForPortfolio = (state, portfolio) =>
  getChartSeriesPreference(state, portfolio, getShowNetworthChartPreferenceKey);

export const getShowInvestableAssetsChartForPortfolio = (state, portfolio) =>
  getChartSeriesPreference(state, portfolio, getShowInvestableAssetsChartPreferenceKey);

export const getRecapChartTimeRangeForPortfolio = state => {
  const portfolio = currentPortfolioSelector(state);
  const userPreferences = userPreferencesSelector(state);
  const timeRangePortfolioMap = userPreferences.portfolioRecapChartTimeRangeMap;

  if (!timeRangePortfolioMap === true || !timeRangePortfolioMap[(portfolio?.id)] === true) {
    return chartTimeRange.TODAY;
  }
  return timeRangePortfolioMap[portfolio.id];
};

export const getRecapChartOptionForPortfolio = (state, portfolio) => {
  if (!portfolio) {
    portfolio = currentPortfolioSelector(state);
  }
  const userPreferences = userPreferencesSelector(state);
  const chartOptionsMap = userPreferences.portfolioRecapChartOptionsMap;
  if (!chartOptionsMap === true || !chartOptionsMap[(portfolio?.id)] === true) {
    return recapChartOptions.NETWORTH.id;
  }
  return chartOptionsMap[portfolio.id];
};

export const getRecapChartTypeForPortfolio = state => {
  const portfolio = currentPortfolioSelector(state);
  const userPreferences = userPreferencesSelector(state);
  const chartTypeMap = userPreferences.portfolioRecapChartTypeMap;
  if (!chartTypeMap === true || !chartTypeMap[(portfolio?.id)] === true) {
    return recapChartTypes.TOTALS;
  }
  return chartTypeMap[portfolio.id];
};

export const getRecapChartPercentageChangeFlagForPortfolio = state => {
  const portfolio = currentPortfolioSelector(state);
  const userPreferences = userPreferencesSelector(state);
  const percentageChangeMap = userPreferences.portfolioRecapPercentageChangeFlagMap;
  if (!percentageChangeMap === true || !percentageChangeMap[portfolio.id] === true) {
    return false;
  }
  return percentageChangeMap[portfolio.id];
};

export const getCustodianValueChartTimeRange = state => {
  const userPreferences = userPreferencesSelector(state);
  if (!userPreferences.custodianValueChartTimeRange === true) {
    return chartTimeRange.MONTHLY;
  }
  return userPreferences.custodianValueChartTimeRange;
};

export const getValueChangeContributionsForNetworth = (
  state,
  portfolioCurrency,
  networthCurrency,
  startValueCustodians,
  endValueCustodians,
  onlyInvestable = false
) => {
  var contributingCustodiansMap = {};

  const groupCustodian = (name, startValue, currentValue) => {
    const currentContributionEntry = contributingCustodiansMap[name];
    if (!currentContributionEntry === true) {
      contributingCustodiansMap[name] = {
        name: name,
        startValue: startValue,
        currentValue: currentValue,
        entries: 1
      };
    } else {
      currentContributionEntry.startValue += startValue;
      currentContributionEntry.currentValue += currentValue;
      currentContributionEntry.entries += 1;
    }
    return name;
  };

  for (const custodian of endValueCustodians) {
    if (!custodian.hidden === true) {
      if (onlyInvestable === true && custodian.type === 1) {
        continue;
      }

      const currentValue = convertCurrency(
        state,
        calcCustodianOwnershipValue(custodian.value, custodian.ownership),
        networthCurrency,
        portfolioCurrency
      );

      var startValue = 0;
      const startValueCustodian = startValueCustodians.find(
        item =>
          item.id === custodian.id &&
          item.portfolioId === custodian.portfolioId &&
          item.parentPortfolioId === custodian.parentPortfolioId &&
          item.directLinkedAssetCustodianId === custodian.directLinkedAssetCustodianId &&
          item.linkedAssetCustodianIdInCurrentPortfolio === custodian.linkedAssetCustodianIdInCurrentPortfolio
      );
      if (!startValueCustodian === false) {
        startValue = convertCurrency(
          state,
          calcCustodianOwnershipValue(startValueCustodian.value, startValueCustodian.ownership),
          networthCurrency,
          portfolioCurrency
        );
      }
      groupCustodian(custodian.name, startValue, currentValue);
    }
  }

  // Add custodians that were there at the start but are no longer there in the portfolio
  for (const custodian of startValueCustodians) {
    const currentCustodian = endValueCustodians.find(
      item =>
        item.id === custodian.id &&
        item.portfolioId === custodian.portfolioId &&
        item.parentPortfolioId === custodian.parentPortfolioId &&
        item.directLinkedAssetCustodianId === custodian.directLinkedAssetCustodianId &&
        item.linkedAssetCustodianIdInCurrentPortfolio === custodian.linkedAssetCustodianIdInCurrentPortfolio
    );
    if (!currentCustodian === true) {
      if (onlyInvestable === true && custodian.type === 1) {
        continue;
      }

      const startValue = convertCurrency(
        state,
        calcCustodianOwnershipValue(custodian.value, custodian.ownership),
        networthCurrency,
        portfolioCurrency
      );

      const groupingKey = groupCustodian(custodian.name, startValue, 0);

      // No matching group found
      if (contributingCustodiansMap[groupingKey].entries >= 1) {
        contributingCustodiansMap[groupingKey].isArchived = true;
      }
    }
  }

  var contributingCustodians = Object.values(contributingCustodiansMap);
  contributingCustodians.sort(
    (a, b) => Math.abs(b.currentValue - b.startValue) - Math.abs(a.currentValue - a.startValue)
  );

  contributingCustodians = contributingCustodians.filter(
    item => parseFloat(item.currentValue - item.startValue).toFixed(2) != 0
  );
  return contributingCustodians;
};

export const globalClubbingNamesSelector = createStateAccessSelector(
  [
    state => state,
    state => portfoliosSelector(state),
    state => portfolioTreeDataSelector(state),
    state => currentPortfolioSelector(state)?.id
  ],
  (state, portfolios, portfolioTreeData, currentPortfolioId) => {
    if (!portfolioTreeData?.children?.length) {
      return new Map();
    }

    const portfolioMap = new Map();
    for (const portfolio of portfolios || []) {
      portfolioMap.set(portfolio.id, portfolio);
    }
    return buildGlobalClubbingNames(state, findPortfolioInTree(portfolioTreeData, currentPortfolioId), portfolioMap);
  }
);

export const getTopInvestableAssetsForDay = (
  state,
  portfolioCurrency,
  networthCurrency,
  custodians,
  custodiansFundData,
  count
) => {
  const assetsMap = Object.create(null);
  const globalClubbingNames = globalClubbingNamesSelector(state);
  const fundDataMap = new Map();
  for (const custodian of custodiansFundData || []) {
    fundDataMap.set(`${custodian.id}_${custodian.portfolioId}`, custodian);
  }

  for (const custodian of custodians) {
    if (custodian.type !== custodianTypes.INVESTABLE && custodian.type !== custodianTypes.CASH_IN_HAND) {
      continue;
    }

    const value = convertCurrency(
      state,
      calcCustodianOwnershipValue(custodian.value, custodian.ownership),
      networthCurrency,
      portfolioCurrency
    );

    const fundData = fundDataMap.get(`${custodian.id}_${custodian.portfolioId}`);
    if (fundData?.hCnt) {
      continue;
    }
    const tickerDetails = fundData ? getTickerUsingId(state, fundData.vTId) : null;
    const name = getClubbingKeyForCustodian(tickerDetails, custodian.name, globalClubbingNames);

    const existingEntry = assetsMap[name];
    if (!existingEntry === true) {
      assetsMap[name] = { name: name, value: value };
    } else {
      existingEntry.value += value;
    }
  }

  return Object.values(assetsMap)
    .sort((a, b) => b.value - a.value)
    .slice(0, count);
};

export const getTotalForSection = (state, portfolio, section, onlyInvestable = false) => {
  const sectionCustodians = sectionCustodiansSelector(state, portfolio.id, section.id).filter(
    item => item.hidden !== 1 && (onlyInvestable === false || item.type === 0 || item.type === 2)
  );
  const sheet = sheetSelector(state, section.sheetId);
  const sum = sectionCustodians.reduce((total, temp) => {
    const currentValue = getCustodianValue(
      state,
      temp,
      sheet.category,
      getTickerUsingShortName(state, portfolio.currency)
    );
    return total + currentValue;
  }, 0);
  return sum;
};

export const getTotalForSheet = (state, portfolio, sheet, onlyInvestable = false) => {
  const sheetCustodians = sheetCustodiansSelector(state, portfolio.id, sheet.id).filter(
    item => item.hidden !== 1 && (onlyInvestable === false || item.type === 0 || item.type === 2)
  );
  const sum = sheetCustodians.reduce((total, temp) => {
    const currentValue = getCustodianValue(
      state,
      temp,
      temp.category,
      getTickerUsingShortName(state, portfolio.currency)
    );
    return total + currentValue;
  }, 0);
  return sum;
};

export const portfolioSavedChartsSelector = portfolio => {
  if (portfolio && portfolio.diyChart && portfolio.diyChart.data) {
    return portfolio.diyChart.data;
  }
  return null;
};

export const dashboardChartIdsSelector = createSelector(
  [state => state],
  state => {
    const currentPortfolio = currentPortfolioSelector(state);
    const initialDashboardCharts = {
      columns: {
        column1: {
          chartIds: []
        },
        column2: {
          chartIds: []
        }
      },
      columnOrder: ["column1", "column2"]
    };

    if (currentPortfolio && currentPortfolio.diyChart && currentPortfolio.diyChart.data) {
      return currentPortfolio.diyChart.data;
    }
    const defaultChartIds = defaultDashboardChartIdsSelector(state);
    return getDIYDashboardCharts(defaultChartIds, initialDashboardCharts);
  }
);

export const getDIYDashboardCharts = memoize((chartIds, initialDashboardCharts) => {
  if (chartIds?.length) {
    const diyDashBoardCharts = initialDashboardCharts;
    for (const id of chartIds) {
      const chartParams = parseParams(id);
      if (chartParams.is_checked !== "true") {
        continue;
      }
      const column1Length = diyDashBoardCharts.columns.column1.chartIds.length;
      const column2Length = diyDashBoardCharts.columns.column2.chartIds.length;

      if (column1Length === column2Length || column2Length > column1Length) {
        diyDashBoardCharts.columns.column1.chartIds.push(id);
      } else {
        diyDashBoardCharts.columns.column2.chartIds.push(id);
      }
    }
    return diyDashBoardCharts;
  }

  return initialDashboardCharts;
});

export const addedChartsSelector = state => {
  const dashboardChartIds = dashboardChartIdsSelector(state);
  const defaultChartIds = defaultDashboardChartIdsSelector(state);
  return dashboardChartIds.filter(dashboardChartId =>
    defaultChartIds.every(defaultChartId => defaultChartId !== dashboardChartId)
  );
};

export const suggestedChartsSelector = createSelector(
  [
    defaultDashboardChartIdsSelector,
    state => {
      const currentPortfolio = currentPortfolioSelector(state);
      return portfolioSavedChartsSelector(currentPortfolio);
    }
  ],
  (defaultDashboardChartIds, savedCharts) => {
    const charts = savedCharts;
    const suggestedCharts = [];

    if (charts) {
      const dashboardChartIds = [...charts.columns.column1.chartIds, ...charts.columns.column2.chartIds];
      for (const chartId of defaultDashboardChartIds) {
        const defaultChartParams = parseParams(chartId);
        const isDefaultChartChecked = defaultChartParams.is_checked;
        const chartIndex = dashboardChartIds.findIndex(dashboardChartId => {
          const dashboardChartParams = parseParams(dashboardChartId);
          if (parseParams(defaultChartParams.report_id).chart_option === recapChartOptions.SHEETS_AND_SECTIONS.id) {
            return (
              parseParams(dashboardChartParams.report_id).chart_option ===
                parseParams(defaultChartParams.report_id).chart_option &&
              parseParams(dashboardChartParams.report_id).report_node_id ===
                parseParams(defaultChartParams.report_id).report_node_id &&
              parseParams(dashboardChartParams.report_id).report_path ===
                parseParams(defaultChartParams.report_id).report_path &&
              defaultChartParams.chart_style === dashboardChartParams.chart_style &&
              dashboardChartParams.chart_content === defaultChartParams.chart_content &&
              dashboardChartParams.should_compare_with_investable_assets ===
                defaultChartParams.should_compare_with_investable_assets &&
              dashboardChartParams.should_compare_with_sheet === defaultChartParams.should_compare_with_sheet &&
              dashboardChartParams.should_compare_with_total_assets_or_debts ===
                defaultChartParams.should_compare_with_total_assets_or_debts
            );
          }
          return (
            defaultChartParams.is_default_chart === dashboardChartParams.is_default_chart &&
            defaultChartParams.chart_style === dashboardChartParams.chart_style &&
            dashboardChartParams.chart_content === defaultChartParams.chart_content &&
            dashboardChartParams.chart_name === defaultChartParams.chart_name
          );
        });
        if (chartIndex !== -1) {
          const selectedChart = dashboardChartIds[chartIndex];
          const isChecked = parseParams(selectedChart).is_checked;
          if (isChecked === isDefaultChartChecked) {
            suggestedCharts.push(chartId);
          } else {
            suggestedCharts.push(selectedChart);
          }
        } else {
          suggestedCharts.push(chartId);
        }
      }
      return suggestedCharts;
    } else {
      return defaultDashboardChartIds;
    }
  }
);

export const portfolioQuantityForTicker = (state, portfolio, category = "Asset", tickerId, onlyInvestable = false) => {
  if (!portfolio) {
    portfolio = currentPortfolioSelector(state);
  }
  if (!portfolio) {
    return 0;
  }
  const categoryCustodians = portfolioCustodiansSelector(state, portfolio, category).filter(
    item => item.valueTickerId === tickerId && (onlyInvestable === false || item.type === 0 || item.type === 2)
  );
  const portfolioTicker = getTickerUsingShortName(state, portfolio.currency);

  var total = 0;
  for (const custodian of categoryCustodians) {
    const custodianValue = getCustodianValue(state, custodian, category, portfolioTicker, false);
    total = total + custodianValue;
  }
  return total;
};

export const connectivityCenterDataSelector = state => {
  return portfoliosStateSelector(state).connectivityCenterData;
};

export const connectivityCenterDataForPortfolioSelectorMemoized = memoize(portfolioId =>
  createSelector(
    [connectivityCenterDataSelector],
    connectivityCenterData => {
      const filteredFirstItem =
        connectivityCenterData && connectivityCenterData.filter(item => item.portfolioId === portfolioId)[0];

      return filteredFirstItem ? filteredFirstItem.connectivityCenter : [];
    }
  )
);

export const connectivityCenterDataForPortfolioSelector = (state, portfolioId) => {
  return connectivityCenterDataForPortfolioSelectorMemoized(portfolioId)(state);
};

export const portfolioFundScheduleSelector = state => {
  const portfolio = currentPortfolioSelector(state);
  return portfoliosStateSelector(state).portfolioFundScheduleMap[portfolio.id];
};

export const portfolioGroupedFundScheduleSelector = createStateAccessSelector(
  [
    state => state,
    currentPortfolioSelector,
    portfolioFundScheduleSelector,
    portfolioUnfundedCapital,
    state => displayTimezoneSelector(state)
  ],
  (state, portfolio, fundSchedule, _) => {
    if (!fundSchedule) {
      fundSchedule = [];
    }

    fundSchedule.sort((a, b) => a.date.localeCompare(b.date));

    const groupedFundSchedule = { data: {}, custodianIds: [] };

    const insertItem = (itemType, item, value, valueTickerId, duration) => {
      const valueInPortfoiloCurrency =
        (itemType === fundScheduleTypes.CAPITAL_CALL ? -1 : 1) *
        convertCurrency(state, value, getTickerUsingId(state, valueTickerId).shortName, portfolio.currency);

      const custodian = custodianSelector(state, item.custodianId || item.id);
      if (!custodian === true) {
        return;
      }
      item.custodianName = custodian.name;

      if (!groupedFundSchedule.data[duration]) {
        groupedFundSchedule.data[duration] = { total: 0, data: {} };
      }

      if (!groupedFundSchedule.data[duration].data[item.custodianId || item.id]) {
        groupedFundSchedule.data[duration].data[item.custodianId || item.id] = { total: 0, items: [] };
      }

      groupedFundSchedule.data[duration].total += valueInPortfoiloCurrency;
      groupedFundSchedule.data[duration].data[item.custodianId || item.id].total += valueInPortfoiloCurrency;
      groupedFundSchedule.data[duration].data[item.custodianId || item.id].items.push(item);
    };

    const todayMidnight = getTodayMidnight(state);
    for (const item of fundSchedule) {
      const itemDate = parseKuberaDateString(item.date);

      if (itemDate.getTime() <= todayMidnight.getTime()) {
        insertItem(item.type, item, item.value, item.valueTickerId, fundScheduleDurations.OVERDUE);
      } else if (itemDate.getTime() <= addDaysToDate(todayMidnight, 30)) {
        insertItem(item.type, item, item.value, item.valueTickerId, fundScheduleDurations.IN_30_DAYS);
      } else if (itemDate.getTime() <= addDaysToDate(todayMidnight, 90)) {
        insertItem(item.type, item, item.value, item.valueTickerId, fundScheduleDurations.IN_90_DAYS);
      } else if (itemDate.getTime() > addDaysToDate(todayMidnight, 90)) {
        insertItem(item.type, item, item.value, item.valueTickerId, fundScheduleDurations.MORE_THAN_90_DAYS);
      }
    }

    const custodiansWithCommittedCapital = custodiansWithCommitedCapitalForPortfolioSelector(state) || [];
    const uniqueCustodiansWithCommittedCapital = custodiansWithCommittedCapital.filter(
      (obj1, i, arr) => arr.findIndex(obj2 => obj2.id === obj1.id) === i
    );

    let unscheduledCustodians = uniqueCustodiansWithCommittedCapital;
    let validUnscheduledCustodians = [];
    for (const item of unscheduledCustodians) {
      let value = getUnfundedCommitmentForCustodian(state, item);
      const scheduledCapitalCalls = fundSchedule.filter(
        schedule => schedule.custodianId === item.id && schedule.type === fundScheduleTypes.CAPITAL_CALL
      );
      const scheduledCapitalCallsTotal = scheduledCapitalCalls.reduce(
        (total, temp) =>
          total +
          convertCurrency(state, temp.value, getTickerUsingId(state, temp.valueTickerId).shortName, portfolio.currency),
        0
      );
      value -= scheduledCapitalCallsTotal;

      if (value !== 0) {
        insertItem(
          fundScheduleTypes.CAPITAL_CALL,
          item,
          value,
          getTickerUsingShortName(state, portfolio.currency).id,
          fundScheduleDurations.UNSCHEDULED
        );
        validUnscheduledCustodians.push(item);
      }
    }

    const custodianIds = new Set();
    for (const item of fundSchedule) {
      custodianIds.add(item.custodianId);
    }
    groupedFundSchedule.custodianIds = Array.from(
      new Set([...fundSchedule.map(item => item.custodianId), ...validUnscheduledCustodians.map(item => item.id)])
    );
    return groupedFundSchedule;
  }
);

export const getSheetsAndSectionsSankeyChartDataFromRecap = createStateAccessSelector(
  [
    state => state,
    (_, forDebt, __) => forDebt,
    (_, __, expandSections) => expandSections,
    currentPortfolioSelector,
    currentPortfolioCurrencySelector,
    state => {
      const currentPortfolioCurrency = currentPortfolioCurrencySelector(state);
      return getTickerUsingShortName(state, currentPortfolioCurrency);
    },
    state => getCurrentPortfolioDataInNestedFormat(state, categoryType.ASSET),
    state => getCurrentPortfolioDataInNestedFormat(state, categoryType.DEBT),
    state => currentPortfolioTotalForCategory(state, categoryType.ASSET),
    state => currentPortfolioTotalForCategory(state, categoryType.DEBT)
  ],
  (
    state,
    forDebt,
    expandSections,
    currentPortfolio,
    currency,
    portfolioTicker,
    assetsSheetsAndSections,
    debtsSheetsAndSections,
    assetsTotal,
    debtsTotal
  ) => {
    const portfolio = currentPortfolio;
    if (!portfolio === true) {
      return null;
    }

    const chartData = { currency: currency, data: [] };
    const networth = assetsTotal - debtsTotal;

    const calculateData = (sheetsAndSections, categoryTotal, categoryType) => {
      var sheets = sheetsAndSections.sheets.filter(item => !item === false);
      const totalSectionCount = sheets.reduce((total, sheetData) => total + sheetData.sections.length, 0);
      sheets = sheets.sort((current, next) => next.sheetTotal - current.sheetTotal);
      var realSectionCount = 0;

      const sectionRows = (sectionData, totalRowCount, isSingleSectionPortfolio, sheetDataForTarget = null) => {
        var rows = sectionData.custodians
          .filter(item => !item === false && getCustodianValue(state, item, categoryType.ASSET, portfolioTicker) !== 0)
          .sort(
            (current, next) =>
              getCustodianValue(state, next, categoryType.ASSET, portfolioTicker) -
              getCustodianValue(state, current, categoryType.ASSET, portfolioTicker)
          );

        const otherRows =
          totalRowCount > 10
            ? rows.filter(
                (item, index) =>
                  index >= 1 &&
                  getCustodianValue(state, item, categoryType.ASSET, portfolioTicker) / categoryTotal < 0.02
              )
            : [];
        rows = rows
          .filter(item => otherRows.find(other => other.id === item.id) === undefined)
          .sort(
            (current, next) =>
              getCustodianValue(state, next, categoryType.ASSET, portfolioTicker) -
              getCustodianValue(state, current, categoryType.ASSET, portfolioTicker)
          );
        realSectionCount += rows.length;

        for (const rowData of rows) {
          if (!rowData) {
            continue;
          }

          const custodianValue = getCustodianValue(state, rowData, categoryType.ASSET, portfolioTicker);
          chartData.data.push({
            source: {
              id: rowData.id,
              label: rowData.name,
              percent: getPercentageValue(custodianValue, sectionData.sectionTotal, false)
            },
            target: isSingleSectionPortfolio
              ? { id: categoryType, label: categoryType }
              : {
                  id: sheetDataForTarget ? sheetDataForTarget.sheet.id : sectionData.section.id,
                  label: sheetDataForTarget ? sheetDataForTarget.sheet.name : sectionData.section.name
                },
            value: custodianValue
          });
        }

        if (otherRows.length > 0) {
          const othersValue = otherRows.reduce((total, temp) => {
            return total + getCustodianValue(state, temp, categoryType.ASSET, portfolioTicker);
          }, 0);

          chartData.data.push({
            source: {
              id: `${sectionData.section.id}-others`,
              label: otherRows.length === 1 ? otherRows[0].name : `${otherRows[0].name} +${otherRows.length - 1}`,
              isOthersLabel: otherRows.length > 1,
              description: otherRows
                .reduce((total, temp) => {
                  return `${total} ${temp.name},`;
                }, "")
                .slice(0, -1),
              others: otherRows.map(item => ({
                id: item.id,
                label: item.name,
                value: getCustodianValue(state, item, categoryType.ASSET, portfolioTicker)
              })),
              percent: getPercentageValue(othersValue, sectionData.sectionTotal, false)
            },
            target: isSingleSectionPortfolio
              ? { id: categoryType, label: categoryType }
              : {
                  id: sheetDataForTarget ? sheetDataForTarget.sheet.id : sectionData.section.id,
                  label: sheetDataForTarget ? sheetDataForTarget.sheet.name : sectionData.section.name
                },
            value: othersValue
          });
        }
      };

      if (sheets.length === 1) {
        const sections = sheets[0].sections.filter(item => item.sectionTotal !== 0);
        const totalRowCount = sections.reduce((total, sectionData) => total + sectionData.custodians.length, 0);
        const isSingleSectionPortfolio = sections.length === 1;

        for (const sectionData of sections) {
          if (isSingleSectionPortfolio === false) {
            chartData.data.push({
              source: {
                id: sectionData.section.id,
                label: sectionData.section.name,
                percent: getPercentageValue(sectionData.sectionTotal, sheets[0].sheetTotal, false)
              },
              target: { id: categoryType, label: categoryType },
              value: sectionData.sectionTotal
            });
          }
          sectionRows(sectionData, totalRowCount, isSingleSectionPortfolio);
        }
      } else {
        for (const sheetData of sheets) {
          chartData.data.push({
            source: {
              id: sheetData.sheet.id,
              label: sheetData.sheet.name,
              percent: getPercentageValue(sheetData.sheetTotal, categoryTotal, false)
            },
            target: { id: categoryType, label: categoryType },
            value: sheetData.sheetTotal
          });

          if (
            expandSections === true &&
            sheetData.sheetTotal / categoryTotal > 0.1 &&
            sheetData.sections.length === 1
          ) {
            const sectionData = sheetData.sections[0];
            sectionRows(sectionData, sectionData.custodians.length, false, sheetData);
          } else if (sheetData.sheetTotal / categoryTotal > 0.05 && sheetData.sections.length > 1) {
            var sections = sheetData.sections
              .filter(item => !item === false && item.sectionTotal !== 0)
              .sort((current, next) => next.sectionTotal - current.sectionTotal);

            const otherSections =
              totalSectionCount > 10
                ? sections.filter((item, index) => index >= 1 && item.sectionTotal / categoryTotal < 0.02)
                : [];
            sections = sections
              .filter(item => otherSections.find(other => other.section.id === item.section.id) === undefined)
              .sort((current, next) => next.sectionTotal - current.sectionTotal);
            realSectionCount += sections.length;

            for (const sectionData of sections) {
              if (!sectionData) {
                continue;
              }

              chartData.data.push({
                source: {
                  id: sectionData.section.id,
                  label: sectionData.section.name,
                  percent: getPercentageValue(sectionData.sectionTotal, sheetData.sheetTotal, false)
                },
                target: { id: sheetData.sheet.id, label: sheetData.sheet.name },
                value: sectionData.sectionTotal
              });
            }

            if (otherSections.length > 0) {
              const otherSectionsTotal = otherSections.reduce((total, temp) => {
                return total + temp.sectionTotal;
              }, 0);

              chartData.data.push({
                source: {
                  id: `${sheetData.sheet.id}-others`,
                  label:
                    otherSections.length === 1
                      ? otherSections[0].section.name
                      : `${otherSections[0].section.name} +${otherSections.length - 1}`,
                  isOthersLabel: otherSections.length > 1,
                  others: otherSections.map(item => ({
                    id: item.section.id,
                    label: item.section.name,
                    value: item.sectionTotal
                  })),
                  description: otherSections
                    .reduce((total, temp) => {
                      return `${total} ${temp.section.name},`;
                    }, "")
                    .slice(0, -1),
                  percent: getPercentageValue(otherSectionsTotal, sheetData.sheetTotal, false)
                },
                target: { id: sheetData.sheet.id, label: sheetData.sheet.name },
                value: otherSectionsTotal
              });
            }
          }
        }
      }

      chartData.data.push({
        source: { id: categoryType, label: categoryType },
        target: {
          id: RECAP_CATEGORY_TYPE_NETWORTH,
          label: RECAP_CATEGORY_TYPE_NETWORTH,
          position: "middle",
          linkColor: "target"
        },
        value: networth
      });

      if (categoryType === RECAP_CATEGORY_TYPE_ASSET) {
        if (debtsTotal !== 0) {
          chartData.data.push({
            source: { id: categoryType, label: categoryType },
            target: { id: RECAP_CATEGORY_TYPE_DEBT, label: RECAP_CATEGORY_TYPE_DEBT, linkColor: "target" },
            value: debtsTotal
          });
        }
      } else {
        if (assetsTotal !== 0) {
          chartData.data.push({
            source: { id: categoryType, label: categoryType },
            target: { id: RECAP_CATEGORY_TYPE_ASSET, label: RECAP_CATEGORY_TYPE_ASSET, linkColor: "target" },
            value: assetsTotal
          });
        }
      }

      chartData.maxLayerDepth = Math.max(realSectionCount, sheetsAndSections.sheets.length);
      return chartData;
    };
    return calculateData(
      forDebt ? debtsSheetsAndSections : assetsSheetsAndSections,
      forDebt ? debtsTotal : assetsTotal,
      forDebt ? RECAP_CATEGORY_TYPE_DEBT : RECAP_CATEGORY_TYPE_ASSET
    );
  }
);

export const getSheetsAndSectionsSankeyChartDataInNestedFormat = createSelector(
  [
    state => getSheetsAndSectionsSankeyChartDataFromRecap(state, false, true),
    state => getSheetsAndSectionsSankeyChartDataFromRecap(state, true, true)
  ],
  (sankeyChartAssetsData, sankeyChartDebtsData) => {
    let nestedData = { currency: sankeyChartAssetsData.currency, data: {} };
    nestedData.data.networth = sankeyChartAssetsData.data.find(
      item => item.target.id === RECAP_CATEGORY_TYPE_NETWORTH && item.source.id === RECAP_CATEGORY_TYPE_ASSET
    ).value;

    const assetChildren = sankeyChartAssetsData.data.filter(item => item.target.id === RECAP_CATEGORY_TYPE_ASSET);
    nestedData.data[categoryType.ASSET] = {
      value: assetChildren.reduce((total, node) => total + node.value, 0),
      children: assetChildren
        .map(item => {
          if (item.source.others) {
            return [...item.source.others];
          }
          return { ...item.source, value: item.value };
        })
        .flat(1)
    };

    nestedData.data[categoryType.ASSET].children.forEach(node => {
      const children = sankeyChartAssetsData.data.filter(item => item.target.id === node.id);
      node.children = children
        .map(item => {
          if (item.source.others) {
            return [...item.source.others];
          }
          return { ...item.source, value: item.value };
        })
        .flat(1);
    });

    const debtChildren = sankeyChartDebtsData.data.filter(item => item.target.id === RECAP_CATEGORY_TYPE_DEBT);
    nestedData.data[categoryType.DEBT] = {
      value: debtChildren.reduce((total, node) => total + node.value, 0),
      children: debtChildren
        .map(item => {
          if (item.source.others) {
            return [...item.source.others];
          }
          return { ...item.source, value: item.value };
        })
        .flat(1)
    };
    nestedData.data[categoryType.DEBT].children.forEach(node => {
      const children = sankeyChartDebtsData.data.filter(item => item.target.id === node.id);
      node.children = children
        .map(item => {
          if (item.source.others) {
            return [...item.source.others];
          }
          return { ...item.source, value: item.value };
        })
        .flat(1);
    });
    return nestedData;
  }
);

const constructTree = (tree, portfolioIdMap, links) => {
  if (tree.children.length === 0) {
    return tree;
  }

  tree.children.forEach(child => {
    child.children = links[child.id]
      .filter(childPortfolio => !portfolioIdMap[childPortfolio.id] === false)
      .map(data => {
        const portfolio = portfolioIdMap[data.id];
        return {
          name: portfolio.name,
          id: data.id,
          ownership: data.ownership,
          Asset: data.Asset,
          Debt: data.Debt
        };
      });
    constructTree(child, portfolioIdMap, links);
  });
  return tree;
};

//
export const portfolioTreeDataSelector = createSelector(
  [portfoliosSelector],
  portfolios => {
    const portfolioIdMap = {};
    portfolios.forEach(portfolio => {
      portfolioIdMap[portfolio.id] = portfolio;
    });

    const links = {};
    for (const portfolio of portfolios) {
      const connectedPortfolioCustodians = portfolio.details.custodian.filter(
        item => !item.parentId === true && item.linkType === accountLinkingService.KUBERA_PORTFOLIO
      );
      const portfolioIdToItem = new Map();

      const assetConnectedPortfolios = connectedPortfolioCustodians
        .filter(item => item.linkContainer === "asset")
        .map(item => {
          return {
            id: item.linkProviderAccountId,
            ownership: item.ownership,
            Asset: {
              // used in FF
              ownership: item.ownership,
              linkedCustodianId: item.id,
              linkedCustodianSectionId: item.sectionId
            }
          };
        });
      assetConnectedPortfolios.forEach(item => portfolioIdToItem.set(item.id, item));

      // debt only links will technically be ignored, but this is an edge case
      connectedPortfolioCustodians
        .filter(item => item.linkContainer === "debt")
        .forEach(item => {
          const existingItem = portfolioIdToItem.get(item.linkProviderAccountId);
          if (!existingItem) return;
          existingItem.Debt = {
            // used in FF
            ownership: item.ownership,
            linkedCustodianId: item.id,
            linkedCustodianSectionId: item.sectionId
          };
        });

      links[portfolio.id] = [...new Set([...assetConnectedPortfolios])];
    }

    const portfoliosWithIncomingLinks = [...new Set([...Object.values(links).flat()])];
    const portfoliosWithoutIncomingLinks = portfolios
      .map(item => item.id)
      .filter(id => portfoliosWithIncomingLinks.findIndex(item => item.id === id) === -1);

    const tree = constructTree(
      {
        name: "",
        children: portfoliosWithoutIncomingLinks.map(id => {
          return { name: portfolioIdMap[id].name, id: id };
        })
      },
      portfolioIdMap,
      links
    );
    return tree;
  }
);

export const portfolioTreeReverseLinkedIdMapSelector = createSelector(
  [portfolioTreeDataSelector, (_, allowDuplicates = false) => allowDuplicates],
  (treeData, allowDuplicates) => {
    const reversePortfolioLinkedIdMap = {};

    const mapChildToParentUsingHashMap = (reversePortfolioLinkedIdMap, parent, child) => {
      if (!parent === true) {
        return;
      }
      if (!reversePortfolioLinkedIdMap[child.id]) {
        reversePortfolioLinkedIdMap[child.id] = [];
      }
      if (allowDuplicates === true || reversePortfolioLinkedIdMap[child.id]?.includes(parent.id) === false) {
        reversePortfolioLinkedIdMap[child.id].push(parent.id);
      }
    };

    const constructReverseMap = (children, parent) => {
      if (children.length === 0) {
        return;
      }
      children.forEach(child => {
        mapChildToParentUsingHashMap(reversePortfolioLinkedIdMap, parent, child);
        constructReverseMap(child.children, child);
      });
    };
    constructReverseMap(treeData.children, null);
    return reversePortfolioLinkedIdMap;
  }
);

export const portfolioDataCategory = {
  DOCUMENTS: "documents",
  INSURANCE: "insurance"
};

export const documentInsurancePortfolioListSelector = (state, dataCategory) => {
  const portfolios = portfoliosSelector(state) || [];
  const reverseLinkedIdMap = portfolioTreeReverseLinkedIdMapSelector(state);

  const hasCategoryData = portfolio => {
    if (dataCategory === portfolioDataCategory.INSURANCE) {
      return portfolioCustodiansSelector(state, portfolio, categoryType.INSURANCE, true).length > 0;
    }
    return (portfolioDocumentsSelector(state, portfolio.id) || []).length > 0;
  };

  return portfolios.filter(portfolio => {
    if (!reverseLinkedIdMap[portfolio.id]) {
      return true;
    }
    return hasCategoryData(portfolio);
  });
};

export const portfolioPredecessorsSelector = createSelector(
  [currentPortfolioSelector, portfolioTreeReverseLinkedIdMapSelector],
  (currentPortfolio, reverseLinkedIdMap) => {
    const predecessors = [];
    const findPredecessors = id => {
      if (!reverseLinkedIdMap[id] === true) {
        return;
      }
      for (const parentId of reverseLinkedIdMap[id]) {
        if (predecessors.find(item => item.id === parentId) === undefined) {
          predecessors.push({ id: parentId, childId: id });
          findPredecessors(parentId);
        }
      }
    };
    findPredecessors(currentPortfolio.id);
    return predecessors;
  }
);

export const connectedPortfoliosSelector = createSelector(
  [currentPortfolioSelector, portfolioTreeDataSelector, portfoliosSelector],
  (currentPortfolio, treeData, portfolios) => {
    const connectedPortfolioIds = [];
    const findChildPortfolios = (tree, isSubTree) => {
      if (tree.id === currentPortfolio.id) {
        isSubTree = true;
      }
      if (tree.children.length === 0) {
        return;
      }
      for (const child of tree.children) {
        if (isSubTree && connectedPortfolioIds.indexOf(child.id) === -1) {
          connectedPortfolioIds.push(child.id);
        }
        findChildPortfolios(child, isSubTree);
      }
    };
    findChildPortfolios(treeData, false);
    return portfolios.filter(portfolio => connectedPortfolioIds.includes(portfolio.id));
  }
);

export const shouldShowLoaderOnChartsModalSelector = state => {
  return portfoliosStateSelector(state).showLoaderOnChartsModal;
};

export const isCalculatingRecapReportSelector = state => {
  return portfoliosStateSelector(state).isCalculatingRecapReport;
};

export const percentageAllocationDataFetchStatusSelector = state => {
  return portfoliosStateSelector(state).fetchingPercentageAllocationData;
};

export const primaryResidenceCustodianSelector = createSelector(
  [currentPortfolioSelector],
  currentPortfolio => {
    return currentPortfolio.details.custodian.filter(
      custodian => custodian.subType === custodianSubTypes.PRIMARY_RESIDENCE
    );
  }
);

export const primaryResidenceValueSelector = state => {
  const currPortfolio = currentPortfolioSelector(state);
  if (!currPortfolio) return null;

  const custs = currPortfolio.details.custodian.filter(
    custodian => custodian.subType === custodianSubTypes.PRIMARY_RESIDENCE
  );
  if (!custs || !custs?.length || !currPortfolio?.currency) {
    return primaryResidenceValueStateSelector(state) || null;
  }

  const { value, ownership, valueTickerId } = custs[0];
  const cellExchangeRate = getExchangeRate(
    state,
    getTickerUsingId(state, valueTickerId).shortName,
    currPortfolio.currency
  );
  return calcCustodianOwnershipValue(cellExchangeRate ? value * cellExchangeRate : value, ownership);
};

const getCorrespondingStartDataForTimeRange = (state, timeRange, forInvestable) => {
  const cagrOldValues = currentPortfolioCagrDataSelector(state)?.cagrOldValues;
  if (!cagrOldValues) {
    return null;
  }
  let startData = null;
  switch (timeRange) {
    case chartTimeRange.ALL:
      startData = forInvestable ? cagrOldValues.alltime_investable : cagrOldValues.alltime_networth;
      break;
    case chartTimeRange.YEARLY:
      startData = forInvestable ? cagrOldValues.yearly_investable : cagrOldValues.yearly_networth;
      break;
    case chartTimeRange.QTD:
      startData = forInvestable ? cagrOldValues.qtd_investable : cagrOldValues.qtd_networth;
      break;
    case chartTimeRange.YTD:
      startData = forInvestable ? cagrOldValues.ytd_investable : cagrOldValues.ytd_networth;
      break;
    default:
      return null;
  }
  if (!startData || startData.oldValue === null || startData.date === null) {
    return null;
  }
  return startData;
};

const getNetworthChange = (state, forInvestable, forTimeRange = null) => {
  const myRange =
    forTimeRange || getChartRangeFromTimePeriod(netWorthIrrComparisonTimePeriodSelector(state)) || chartTimeRange.ALL;

  const currentDayNetworthData = portfolioNetWorth(state);
  const currentDayInvestableData = totalInvestableAssetsForDashboardSelector(state);
  const startPoint = getCorrespondingStartDataForTimeRange(state, myRange, forInvestable);
  if (!startPoint) {
    return null;
  }
  const startValue = startPoint.oldValue;
  const endValue = forInvestable ? currentDayInvestableData : currentDayNetworthData;

  return {
    startValue: startValue,
    startDate: startPoint.date,
    endValue: endValue,
    endDate: getKuberaDateString(toUserTimezoneDate(state))
  };
};

const getCagrFromObj = (state, netWorthChange, forInvestable) => {
  if (!netWorthChange === true) {
    return null;
  }
  const netWorthChartStartDate = getNetWorthChartStartDateForPortfolio(state);
  if (toUserTimezoneDate(state).getTime() - netWorthChartStartDate.getTime() < 30 * 24 * 60 * 60 * 1000) {
    return null;
  }
  if (netWorthChange.startValue === null || netWorthChange.startDate === null) {
    netWorthChange = getNetworthChange(state, forInvestable, chartTimeRange.ALL);
  }
  return getCagr(netWorthChange.startValue, netWorthChange.endValue, netWorthChange.startDate, netWorthChange.endDate);
};

const getAllCagr = (state, forInvestable) => {
  const retVal = {};
  const myRanges = [chartTimeRange.ALL, chartTimeRange.YEARLY, chartTimeRange.QTD, chartTimeRange.YTD];
  for (const range of myRanges) {
    retVal[range] = getCagrFromObj(state, getNetworthChange(state, forInvestable, range), forInvestable);
  }
  return retVal;
};

export const getNWCagr = state => getCagrFromObj(state, getNetworthChange(state, false));
export const getIvCagr = state => getCagrFromObj(state, getNetworthChange(state, true));
export const getAllNWCagr = state => getAllCagr(state, false);
export const getAllIvCagr = state => getAllCagr(state, true);
export const getCagrLabel = state => getIrrPeriodLabel(netWorthIrrComparisonTimePeriodSelector(state));

const cagrChartRanges = [chartTimeRange.YEARLY, chartTimeRange.QTD, chartTimeRange.YTD];
const medianCagrSelector = (state, forNW) => {
  const myRange = getChartRangeFromTimePeriod(netWorthIrrComparisonTimePeriodSelector(state));
  if (!cagrChartRanges.includes(myRange)) {
    return null;
  }
  // if range is YTD and QTD, and today is the start of year or quarter, return null because only 0 cagr is possible since startDate === endDate. the club cagr from backend will likely be stale
  const todayDateString = getTodayCivilDateString(state);
  if (myRange === chartTimeRange.YTD && todayDateString === getYTDStartDateString(state)) {
    return null;
  }
  if (myRange === chartTimeRange.QTD && todayDateString === getQTDStartDateString(state)) {
    return null;
  }
  return vanityStatDataSelector(state)?.clubMedians?.[`${myRange}_${forNW ? "networth" : "investable"}`];
};

export const medianNWCagrSelector = state => medianCagrSelector(state, true);
export const medianInvestableCagrSelector = state => medianCagrSelector(state, false);
export const showClubCAGR = state =>
  numIsNotNull(getNWCagr(state)) &&
  numIsNotNull(getIvCagr(state)) &&
  numIsNotNull(medianNWCagrSelector(state)) &&
  numIsNotNull(medianInvestableCagrSelector(state));

const findInTree = (curr, portfolioId) => {
  if (!curr) {
    return null;
  }
  if (curr.id === portfolioId) {
    return curr;
  }
  const children = curr.children || [];
  for (const child of children) {
    const myObj = findInTree(child, portfolioId);
    if (myObj) return myObj;
  }
  return null;
};

export const dashboardDataForPortfolioSelector = state => {
  const portfolio = currentPortfolioSelector(state);
  if (portfolio && portfoliosStateSelector(state).dashboardDataPortfolioMap[portfolio.id]) {
    return portfoliosStateSelector(state).dashboardDataPortfolioMap[portfolio.id];
  }
  return null;
};

export const cashOnHandDataForDashboardSelector = createStateAccessSelector(
  [
    state => state,
    state => dashboardDataForPortfolioSelector(state)?.cashOnHandData,
    state => currentPortfolioSelector(state),
    state => currentPortfolioSelector(state)?.currency
  ],
  (state, cashOnHandData, currentPortfolio) => {
    if (!cashOnHandData || !currentPortfolio) return [];
    return cashOnHandData
      .map(custodian => ({
        ...custodian,
        value: getCustodianValue(
          state,
          custodian,
          categoryType.ASSET,
          getTickerUsingShortName(state, currentPortfolio.currency)
        )
      }))
      .sort((a, b) => b.value - a.value);
  }
);

export const totalCashOnHandForDashboardSelector = state => {
  const cashOnHandData = cashOnHandDataForDashboardSelector(state);
  return cashOnHandData.reduce((total, item) => {
    return total + item.value;
  }, 0);
};

export const calculatingDashboardDataSelector = state => {
  return portfoliosStateSelector(state).calculatingDashboardData;
};

export const taxEstimateDataForDashboardSelector = createStateAccessSelector(
  [
    state => state,
    state => dashboardDataForPortfolioSelector(state)?.taxEstimateData,
    state => allPortfoliosCustodiansSelector(state),
    state => currentPortfolioSelector(state)?.currency
  ],
  (state, taxEstimateData, allCustodians) => {
    if (!taxEstimateData || taxEstimateData.length === 0) return [];

    const holdingsByParentId = new Map();
    for (const holding of allCustodians) {
      const holdingsForParent = holdingsByParentId.get(holding.parentId);
      if (holdingsForParent === undefined) {
        holdingsByParentId.set(holding.parentId, [holding]);
      } else {
        holdingsForParent.push(holding);
      }
    }

    return taxEstimateData
      .map(custodian => {
        const holdingsForACustodian = holdingsByParentId.get(custodian.id) || [];
        const unrealizedGain = getUnrealizedGainForACustodian(
          state,
          custodian,
          categoryType.ASSET,
          holdingsForACustodian
        );
        return {
          name: custodian.name,
          value: custodian.cumulativeOwnership
            ? calcCustodianOwnershipValue(
                getEstimatedTaxOnUnrealizedGainsForCustodian(state, custodian, unrealizedGain),
                custodian.cumulativeOwnership
              )
            : getEstimatedTaxOnUnrealizedGainsForCustodian(state, custodian, unrealizedGain),
          id: custodian.id
        };
      })
      .sort((a, b) => b.value - a.value);
  }
);

export const totalTaxOnUnrealizedGainsForDashboardSelector = state => {
  const taxEstimateData = taxEstimateDataForDashboardSelector(state);

  return taxEstimateData.reduce((total, item) => {
    return total + item.value;
  }, 0);
};

export const investableDataForDashboardSelector = createStateAccessSelector(
  [
    state => state,
    state => dashboardDataForPortfolioSelector(state)?.investableData,
    state => currentPortfolioSelector(state),
    state => currentPortfolioSelector(state)?.currency
  ],
  (state, investableData, currentPortfolio) => {
    if (!investableData || !currentPortfolio) return [];
    return investableData.map(custodian => {
      const custodianTicker = getTickerUsingId(state, custodian.valueTickerId);
      return {
        ...custodian,
        value: convertCurrency(state, custodian.value, custodianTicker.shortName, currentPortfolio.currency)
      };
    });
  }
);

export const totalInvestableAssetsForDashboardSelector = state => {
  const investableData = investableDataForDashboardSelector(state);
  return investableData.reduce((total, item) => {
    return total + item.value;
  }, 0);
};

export const custodiansWithCommitedCapitalForDashboardSelector = state => {
  const dashboardData = dashboardDataForPortfolioSelector(state);
  return dashboardData?.unfundedCustodiansData || [];
};

export const custodiansWithCommitedCapitalForPortfolioSelector = state => {
  const portfolio = currentPortfolioSelector(state);
  const unfundedCustodiansData = custodiansWithCommitedCapitalForDashboardSelector(state);
  if (!portfolio) return [];
  return unfundedCustodiansData.filter(custodian => custodian.portfolioId === portfolio.id);
};

const aClsToFundKey = {
  Stock: ["usStock", "nonUsStock"],
  Bond: ["bond"],
  Crypto: ["crypto"],
  "Real Estate": ["realty"],
  "Precious Metal": ["metal"],
  Investment: ["investment"],
  Fund: ["fund"],
  Derivative: ["derivative"],
  Miscellaneous: [],
  [planningAssetTypes.cash_equivalents.key]: ["cash"]
};

const breakdownFund = (assetAllocationForFund = {}) => {
  let equityRemaining = 100;
  const equityPercentageObj = {};

  for (const [aCls, allocKeys] of Object.entries(aClsToFundKey)) {
    for (const allocKey of allocKeys) {
      const valueObj = assetAllocationForFund[allocKey];
      if (!valueObj) continue;
      const value = valueObj.long - valueObj.short;
      if (value === 0) continue;
      equityPercentageObj[aCls] = (equityPercentageObj[aCls] || 0) + value;
      equityRemaining -= value;
    }
  }
  equityPercentageObj.Miscellaneous = equityRemaining;
  return equityPercentageObj;
};

const getAggregatedHoldingAllocation = (category, ffObj, custodian) => {
  if (
    category !== categoryType.ASSET ||
    ffObj.tp === custodianTypes.CASH_IN_HAND ||
    !!ffObj.rt ||
    (custodian.holdingSubType || custodian.subType) !== holdingSubTypes.AGGREGATED_HOLDING ||
    !custodian.meta
  ) {
    return null;
  }

  try {
    const { assetAllocation } = JSON.parse(custodian.meta) || {};
    const allocations = Object.values(assetAllocation || {});
    const isWellFormed =
      allocations.length > 0 &&
      allocations.every(value => Number.isFinite(value?.long) && Number.isFinite(value?.short));

    return isWellFormed && allocations.some(value => value.long !== value.short) ? assetAllocation : null;
  } catch {
    return null;
  }
};

const getAssetClassNameFromCustodian = (state, assetClassesList, custodian) => {
  const tickerDetails = getTickerUsingId(state, custodian.valueTickerId);
  const tickerSubType = tickerDetails?.subType;
  const tickerType = tickerDetails?.type;
  if (custodian.type === custodianTypes.CASH_IN_HAND) {
    return assetClassesList[9].name;
  } else if (tickerType !== "fiat") {
    if (tickerSubType === "pm" || tickerSubType === "spm") {
      return assetClassesList[5].name;
    } else if (tickerSubType === "sre") {
      return assetClassesList[6].name;
    } else if (tickerSubType === "sco") {
      return assetClassesList[13].name;
    } else if (tickerSubType === "sst") {
      return assetClassesList[1].name;
    } else if (tickerSubType === "scr" || tickerType === "crypto") {
      return assetClassesList[4].name;
    } else if (tickerSubType === "svc") {
      return assetClassesList[14].name;
    } else if (tickerSubType === "spe") {
      return assetClassesList[11].name;
    } else if (tickerSubType === "ps") {
      return assetClassesList[1].name;
    } else if (tickerSubType === "sbo") {
      return assetClassesList[2].name;
    } else if (tickerType === "stock") {
      return assetClassesList[1].name;
    } else if (tickerType === "bond") {
      return assetClassesList[2].name;
    } else if (tickerType === "derivative") {
      return assetClassesList[7].name;
    } else if (tickerType === "fund" || tickerType === "index") {
      if (tickerDetails?.countryCode === "US") {
        return assetClassesList[3].name;
      } else {
        // non US funds
        if (custodian.assetClassId) {
          const assetClass = assetClassesList.find(assetClass => assetClass.id === custodian.assetClassId);
          return assetClass?.name || assetClassesList[0].name;
        }
        return assetClassesList[3].name;
      }
    }
  } else {
    // handle fiat
    if (tickerDetails.id === PVST_VALUE_TICKER_ID) {
      if (custodian.assetClassId) {
        const assetClass = assetClassesList.find(assetClass => assetClass.id === custodian.assetClassId);
        return assetClass?.name || assetClassesList[0].name;
      }
      return assetClassesList[1].name;
    } else if (
      custodian.linkType === accountLinkingService.CARS ||
      tickerSubType === tickerSubTypes.CARS ||
      custodian.subType === custodianSubTypes.CAR ||
      custodian.subType === "cars"
    ) {
      return assetClassesList[8].name;
    } else if (
      custodian.linkType === accountLinkingService.DOMAINS ||
      tickerSubType === tickerSubTypes.DOMAINS ||
      custodian.subType === custodianSubTypes.DOMAIN ||
      custodian.subType === "domains"
    ) {
      return assetClassesList[10].name;
    } else if (
      custodian.linkType === accountLinkingService.ZILLOW ||
      custodian.subType === custodianSubTypes.HOME ||
      custodian.subType === custodianSubTypes.PRIMARY_RESIDENCE
    ) {
      return assetClassesList[6].name;
    } else if (tickerSubType === "pm" || tickerSubType === "spm") {
      return assetClassesList[5].name;
    } else {
      if (custodian.assetClassId) {
        const assetClass = assetClassesList.find(assetClass => assetClass.id === custodian.assetClassId);
        return assetClass?.name || assetClassesList[0].name;
      }
      return assetClassesList[0].name;
    }
  }
  // Explicit default return to avoid undefined
  return assetClassesList && assetClassesList.length > 0 ? assetClassesList[0].name : "";
};

export const calculateFFData = createStateAccessSelector(
  [
    state => state,
    currentPortfolioSelector,
    state => {
      const currentPortfolioCurrency = currentPortfolioCurrencySelector(state);
      return getTickerUsingShortName(state, currentPortfolioCurrency);
    },
    additionalMetadataSelector,
    portfolioTreeDataSelector,
    portfoliosSelector,
    assetClassesListSelector
  ],
  (state, currPortfolio, targetTicker, fundData, portfolioTree, portfolios, assetClassesList) => {
    if (!currPortfolio || !portfolios) {
      return { Asset: [], Debt: [] };
    }

    const portfoliosById = new Map(portfolios.map(p => [p.id, p]));
    const cache = new Map();

    const getDataForPortfolio = (portfolioId, tree) => {
      const cached = cache.get(portfolioId);
      if (cached) return cached;

      const retObj = { Asset: [], Debt: [] };
      const portfolio = portfoliosById.get(portfolioId);

      if (!portfolio) {
        return retObj;
      }

      const parentsToFilter = new Set();
      const subTree = findInTree(tree, portfolioId);
      const childLinkObjs = subTree?.children || [];

      for (const childLinkObj of childLinkObjs) {
        const childDataPayload = getDataForPortfolio(childLinkObj.id, subTree);

        const processCategory = category => {
          const linkObj = childLinkObj?.[category];
          const childCustodians = childDataPayload?.[category];
          if (!linkObj || !childCustodians?.length) {
            return;
          }
          parentsToFilter.add(linkObj.linkedCustodianId);
          const multiplier = linkObj.ownership / 100;

          for (const child of childCustodians) {
            retObj[category].push({
              ...child,
              linkedCustodianId: linkObj.linkedCustodianId,
              linkedCustodianSectionId: linkObj.linkedCustodianSectionId,
              planningCid: `${linkObj.linkedCustodianId}_${child.fundId || child.cid}`,
              total: child.total * multiplier,
              pvstQuantity: child.pvstQuantity && child.pvstQuantity * multiplier
            });
          }
        };

        processCategory("Asset");
        processCategory("Debt");
      }

      for (const child of portfolio.details.custodian) {
        if (!child.parentId) continue;
        parentsToFilter.add(child.parentId);
      }

      for (const custodian of portfolio.details.custodian) {
        if (!custodian.valueTickerId) {
          // empty custodians to fill up portfolio
          continue;
        }
        if (parentsToFilter.has(custodian.id)) {
          // Do not add parent since holdings/child custodians are already there
          continue;
        }

        const {
          id: cid,
          sectionId: sId,
          valueTickerId,
          assetClassId: acId,
          type: tp,
          parentId: pId,
          rate: rt,
          taxDetails: td,
          name,
          linkType,
          subType
        } = custodian;

        const section = portfolio.details.section.find(section => section.id === custodian.sectionId);
        if (!section) {
          continue; // Should not happen
        }

        const sheet = portfolio.details.sheet.find(sheet => sheet.id === section.sheetId);
        if (!sheet) {
          continue; // Should not happen
        }

        const { category } = sheet;
        if (!retObj[category]) {
          continue; // Insurance or something else
        }
        const destinationArray = retObj[category];

        const myFFObj = { cid, sId, valueTickerId, acId, tp, pId, rt, td, name };

        if (category === "Asset") {
          myFFObj.aCls = getAssetClassNameFromCustodian(state, assetClassesList, {
            ...myFFObj,
            linkType,
            subType,
            valueTickerId,
            assetClassId: acId,
            type: tp
          });
        }

        myFFObj.planningCid = cid; // this can be a new UUID, but manipulated for easy tracing
        myFFObj.total = getCustodianValue(state, custodian, category, targetTicker);

        const tickerAddlInfo =
          myFFObj.aCls === "Fund" &&
          getTickerUsingId(state, valueTickerId).countryCode === "US" &&
          fundData.find(data => data.i === valueTickerId); // handle American funds

        const assetAllocation =
          tickerAddlInfo?.amt?.assetAllocation || getAggregatedHoldingAllocation(category, myFFObj, custodian);

        const breakdown = assetAllocation && breakdownFund(assetAllocation);

        if (breakdown) {
          // breakdown funds into their own parts
          for (const [aCls, coeff] of Object.entries(breakdown)) {
            if (!coeff) continue;
            destinationArray.push({
              ...myFFObj,
              total: (myFFObj.total * coeff) / 100,
              planningCid: `${myFFObj.cid}_${aCls}`,
              fundId: `${myFFObj.cid}_${aCls}`, // ensure there is a UUID
              aCls
            });
          }
        } else {
          if (rt) {
            myFFObj.pvstRate = getPVSTRate(state, rt, portfolio.currency); // handle PVST
            myFFObj.pvstQuantity = myFFObj.total / myFFObj.pvstRate;
            myFFObj.type = tp; // support legacy code
          }

          destinationArray.push(myFFObj);
        }
      }

      cache.set(portfolioId, retObj);
      return retObj;
    };

    return getDataForPortfolio(currPortfolio.id, portfolioTree);
  }
);

export const getAdjustmentTickerIdForCustodian = (state, custodian) => {
  if (!custodian.adjTickerId === false) {
    return custodian.adjTickerId;
  }
  if (custodian.valueTickerId === PVST_VALUE_TICKER_ID) {
    try {
      const rateTickerId = JSON.parse(custodian.rate)?.t;
      if (!rateTickerId === false) {
        return rateTickerId;
      }
    } catch (e) {}
  }
  const valueTicker = getTickerUsingId(state, custodian.valueTickerId);
  if (isFiatTicker(valueTicker)) {
    return valueTicker.id;
  }
  const quoteTicker = !valueTicker.currency === true ? null : getTickerUsingShortName(state, valueTicker.currency);
  if (isFiatTicker(quoteTicker)) {
    return quoteTicker.id;
  }
  return getTickerUsingShortName(state, currentPortfolioSelector(state).currency).id;
};
